/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * PLCnext Store Frontend API
 * This is the PLCnext Store API used by the frontend.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ActivateOfflineLicenseParams,
  AddAppBinaryBody,
  AddAppToDeveloperFavoritesParams,
  AddAppUsersParams,
  AddDeviceBody,
  AddRoleParams,
  AuthorizeReactivationParams,
  CmContainerContextFile,
  CmContainerUpdateFile,
  ConfirmOfflineProcessAfterwardsParams,
  ConfirmOfflineProcessParams,
  ConfirmOfflineRarRequestedParams,
  ConfirmOfflineUpdateFileDownloadParams,
  CreateCertificateBody,
  CreateCertificateParams,
  CreatePaymentAccountParams,
  DeactivateOfflineLicenseParams,
  DeleteAppFromDeveloperFavoritesParams,
  DeleteAppUsersParams,
  DeploymentInfo,
  DeviceDetails,
  ExportKPIsAsCsvParams,
  ExportKPIsAsWebModelParams,
  ExportPaymentsCsv200,
  ExportPaymentsCsvParams,
  FindAllDevicesWithAppsAndLicensesParams,
  FindAppByAppIdAndInternalVersionParams,
  FindAppLicensesParams,
  FindAppsPageParams,
  FindAppsParams,
  FindCompanyProfileByCompanyParams,
  FindDevicesParams,
  FindHubForUserParams,
  FindOrdersParams,
  FindPaymentAccountsByCompanyParams,
  FindPublicCompanyUsersParams,
  FindSelectableDevicesParams,
  FindUserByIdentifierParams,
  FindUserRolesParams,
  FindUsersByRoleParams,
  GetAllKnowlegdebaseDocumentsParams,
  GetAllLicenseOptionsParams,
  GetAppUsersParams,
  GetAppWithHistoryParams,
  GetCompanyJournalCountParams,
  GetCompanyJournalsParams,
  GetDetailedAppInstallationInformationParams,
  GetDetailedLicenseInstallationInformationParams,
  GetDeviceJournalsCountParams,
  GetDeviceJournalsParams,
  GetDeviceStatusParams,
  GetJournalsCountParams,
  GetJournalsParams,
  GetMfaRecoveryCodeInfoParams,
  GetNovalnetErrorCodeTranslationParams,
  GetRequstedActionsParams,
  GetUserJournalCountParams,
  GetUserJournalsParams,
  GetUserRefreshTaskStatus200,
  GetUserStatus200Item,
  GetUserStatusParams,
  HardwareType,
  ImportLicensesViaLicenseOrderXmlFileParams,
  InstallationDetailStatus,
  IsTrialAvailableParams,
  IssueMfaRecoveryCodeParams,
  JwtTokenInfo200,
  KeyValue,
  PaymentRegisterRequest,
  PublicUser,
  RegisterPayment200,
  RemoveFromAccountByAdminParams,
  RemoveFromCompanyParams,
  RemoveRoleParams,
  Role,
  SendSupportMessageBody,
  StoreApiError,
  UninstallAppAndLicenseParams,
  UninstallLicenseParams,
  UpdateCompanyProfileBody,
  UpdateCoreDataBody,
  UpdateCreditNoteTemplateForHubBody,
  UpdateDeviceBody,
  UpdateInvoiceTemplateForHubBody,
  UpdateVersionDataBody,
  UploadStoreFileToSetContainerIdBody,
  WebModelAdminErrorInfo,
  WebModelAppPageAndContent,
  WebModelConfirmUser,
  WebModelCountryAndHubForUser,
  WebModelCreateOrder,
  WebModelCreateReportJSError,
  WebModelCreateUser,
  WebModelCreditNoteEmailAddress,
  WebModelCreditNoteEmailAddressVerify,
  WebModelDeleteRemoveDeviceFromAccount,
  WebModelEBillingAddress,
  WebModelEBillingAddressVerify,
  WebModelGenericEnum,
  WebModelGetAddress,
  WebModelGetAppBinary,
  WebModelGetAppLicense,
  WebModelGetAppLicenseOption,
  WebModelGetAppSettings,
  WebModelGetAppType,
  WebModelGetAppVersion,
  WebModelGetCategory,
  WebModelGetCategoryGroup,
  WebModelGetCertificate,
  WebModelGetCompany,
  WebModelGetCompanyForAdminView,
  WebModelGetCompanyInvite,
  WebModelGetCompanyMember,
  WebModelGetCompanyProfile,
  WebModelGetConfigVar,
  WebModelGetCountry,
  WebModelGetDeveloperApp,
  WebModelGetDevice,
  WebModelGetDeviceCounts,
  WebModelGetDeviceWithAppsAndLicenses,
  WebModelGetExtendedTrialCode,
  WebModelGetHardwareType,
  WebModelGetHub,
  WebModelGetIsAppReleaseable,
  WebModelGetJournal,
  WebModelGetJournalCount,
  WebModelGetKPI,
  WebModelGetLicenseContainer,
  WebModelGetLicenseContainerType,
  WebModelGetLicenseCounts,
  WebModelGetLicenseImportResult,
  WebModelGetMajorMinorFirmwareVersion,
  WebModelGetOrder,
  WebModelGetRequstedAction,
  WebModelGetTrialCode,
  WebModelGetUser,
  WebModelGetUserAccessToken,
  WebModelGetUserAppSubscription,
  WebModelGetUserWithIdmInfos,
  WebModelKnowledgeBaseDocument,
  WebModelMfaActivationRequest,
  WebModelMfaActivationResponse,
  WebModelMfaConfirmRequest,
  WebModelMfaConfirmResponse,
  WebModelMfaDeactivationRequest,
  WebModelMfaDeactivationResponse,
  WebModelMfaDeviceTokenInfoResponse,
  WebModelMfaResetByRecoveryCodeRequest,
  WebModelMfaResetByRecoveryCodeResponse,
  WebModelMfaResetRequestCodeInfoResponse,
  WebModelPasswordReset,
  WebModelPasswordResetConfirm,
  WebModelPaymentAccount,
  WebModelPostAdminNote,
  WebModelPostCategory,
  WebModelPostCategoryGroup,
  WebModelPostCompany,
  WebModelPostCompanyInvite,
  WebModelPostCompanyProfile,
  WebModelPostEmailToAllUsers,
  WebModelPostIllegalContentReport,
  WebModelPostInstallAppAndLicenses,
  WebModelPostLinkLicensesToHostDevice,
  WebModelPostMajorMinorFirmwareVersion,
  WebModelPostMessage,
  WebModelPostNewAppAsAdmin,
  WebModelPostNewHardwareType,
  WebModelPostNewRelease,
  WebModelPostNewTrialCode,
  WebModelPostNewUserAccessToken,
  WebModelPostPxCNumberAdminNote,
  WebModelPostReportApp,
  WebModelPutAppSettingsAsAdmin,
  WebModelPutAppType,
  WebModelPutCategorie,
  WebModelPutCategoryGroup,
  WebModelPutConfigVar,
  WebModelPutLicenseOption,
  WebModelPutLicenseOptionStatus,
  WebModelPutUpdateAppStatus,
  WebModelPutUpdateCompany,
  WebModelPutUpdateCompanyMember,
  WebModelPutUpdateHardwareType,
  WebModelPutUserAccessToken,
  WebModelReactivation,
  WebModelSelectableDevice,
  WebModelUpdateUser,
  WebModelUpdateUserCountry,
  WebModelUpdateUserEmail,
  WebModelUpdateUserPassword,
  WebModelUserLogin
} from './pLCnextStoreFrontendAPI.schemas';





/**
 * Security: User is authenticated. User is store admin or user is requested user himself
 * @summary Search an user by uuid
 */
export const findUser = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUser>> => {
    uuid = toValue(uuid);

    return axios.get(
      `/service/api/users/${uuid}`,options
    );
  }




export const getFindUserQueryKey = (uuid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','users',uuid
    ] as const;
    }


export const getFindUserQueryOptions = <TData = Awaited<ReturnType<typeof findUser>>, TError = AxiosError<unknown>>(uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindUserQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUser>>> = ({ signal }) => findUser(uuid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uuid) !== null && toValue(uuid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>
}

export type FindUserQueryResult = NonNullable<Awaited<ReturnType<typeof findUser>>>
export type FindUserQueryError = AxiosError<unknown>


/**
 * @summary Search an user by uuid
 */

export function useFindUser<TData = Awaited<ReturnType<typeof findUser>>, TError = AxiosError<unknown>>(
 uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is the requested user himself
 * @summary Update an user
 */
export const updateUser = (
    uuid: MaybeRefOrGetter<string>,
    webModelUpdateUser: MaybeRefOrGetter<WebModelUpdateUser>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUser>> => {
    uuid = toValue(uuid);
webModelUpdateUser = toValue(webModelUpdateUser);

    return axios.put(
      `/service/api/users/${uuid}`,
      webModelUpdateUser,options
    );
  }




export const getUpdateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{uuid: string;data: WebModelUpdateUser}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{uuid: string;data: WebModelUpdateUser}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {uuid: string;data: WebModelUpdateUser}> = (props) => {
          const {uuid,data} = props ?? {};

          return  updateUser(uuid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = WebModelUpdateUser
    export type UpdateUserMutationError = AxiosError<unknown>

    /**
 * @summary Update an user
 */
export const useUpdateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{uuid: string;data: WebModelUpdateUser}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {uuid: string;data: WebModelUpdateUser},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is requested user himself
 * @summary Update the password of an user
 */
export const updateUserPassword = (
    uuid: MaybeRefOrGetter<string>,
    webModelUpdateUserPassword: MaybeRefOrGetter<WebModelUpdateUserPassword>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
webModelUpdateUserPassword = toValue(webModelUpdateUserPassword);

    return axios.put(
      `/service/api/users/${uuid}/update/password`,
      webModelUpdateUserPassword,options
    );
  }




export const getUpdateUserPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPassword>>, TError,{uuid: string;data: WebModelUpdateUserPassword}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserPassword>>, TError,{uuid: string;data: WebModelUpdateUserPassword}, TContext> => {

const mutationKey = ['updateUserPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserPassword>>, {uuid: string;data: WebModelUpdateUserPassword}> = (props) => {
          const {uuid,data} = props ?? {};

          return  updateUserPassword(uuid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserPassword>>>
    export type UpdateUserPasswordMutationBody = WebModelUpdateUserPassword
    export type UpdateUserPasswordMutationError = AxiosError<unknown>

    /**
 * @summary Update the password of an user
 */
export const useUpdateUserPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPassword>>, TError,{uuid: string;data: WebModelUpdateUserPassword}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserPassword>>,
        TError,
        {uuid: string;data: WebModelUpdateUserPassword},
        TContext
      > => {
      return useMutation(getUpdateUserPasswordMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is requested user himself
 * @summary Update the email address of an user
 */
export const updateUserEmail = (
    uuid: MaybeRefOrGetter<string>,
    webModelUpdateUserEmail: MaybeRefOrGetter<WebModelUpdateUserEmail>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
webModelUpdateUserEmail = toValue(webModelUpdateUserEmail);

    return axios.put(
      `/service/api/users/${uuid}/update/email`,
      webModelUpdateUserEmail,options
    );
  }




export const getUpdateUserEmailMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserEmail>>, TError,{uuid: string;data: WebModelUpdateUserEmail}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserEmail>>, TError,{uuid: string;data: WebModelUpdateUserEmail}, TContext> => {

const mutationKey = ['updateUserEmail'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserEmail>>, {uuid: string;data: WebModelUpdateUserEmail}> = (props) => {
          const {uuid,data} = props ?? {};

          return  updateUserEmail(uuid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserEmail>>>
    export type UpdateUserEmailMutationBody = WebModelUpdateUserEmail
    export type UpdateUserEmailMutationError = AxiosError<unknown>

    /**
 * @summary Update the email address of an user
 */
export const useUpdateUserEmail = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserEmail>>, TError,{uuid: string;data: WebModelUpdateUserEmail}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserEmail>>,
        TError,
        {uuid: string;data: WebModelUpdateUserEmail},
        TContext
      > => {
      return useMutation(getUpdateUserEmailMutationOptions(options), queryClient);
    }

/**
 * @summary Download a developer certificate
 */
export const getCertificate = (
    uuid: MaybeRefOrGetter<string>,
    certificateid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
certificateid = toValue(certificateid);

    return axios.get(
      `/service/api/users/${uuid}/certificates/${certificateid}`,options
    );
  }




export const getGetCertificateQueryKey = (uuid: MaybeRefOrGetter<string>,
    certificateid: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','users',uuid,'certificates',certificateid
    ] as const;
    }


export const getGetCertificateQueryOptions = <TData = Awaited<ReturnType<typeof getCertificate>>, TError = AxiosError<unknown>>(uuid: MaybeRefOrGetter<string>,
    certificateid: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCertificateQueryKey(uuid,certificateid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertificate>>> = ({ signal }) => getCertificate(uuid,certificateid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uuid) !== null && toValue(uuid) !== undefined && toValue(certificateid) !== null && toValue(certificateid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>
}

export type GetCertificateQueryResult = NonNullable<Awaited<ReturnType<typeof getCertificate>>>
export type GetCertificateQueryError = AxiosError<unknown>


/**
 * @summary Download a developer certificate
 */

export function useGetCertificate<TData = Awaited<ReturnType<typeof getCertificate>>, TError = AxiosError<unknown>>(
 uuid: MaybeRefOrGetter<string>,
    certificateid: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificate>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCertificateQueryOptions(uuid,certificateid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * @summary Renew a certificate for a user, renew a certificate for a user by its id.
 */
export const renewCertificate = (
    uuid: MaybeRefOrGetter<string>,
    certificateid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCertificate>> => {
    uuid = toValue(uuid);
certificateid = toValue(certificateid);

    return axios.put(
      `/service/api/users/${uuid}/certificates/${certificateid}`,
      undefined,options
    );
  }




export const getRenewCertificateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewCertificate>>, TError,{uuid: string;certificateid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof renewCertificate>>, TError,{uuid: string;certificateid: number}, TContext> => {

const mutationKey = ['renewCertificate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renewCertificate>>, {uuid: string;certificateid: number}> = (props) => {
          const {uuid,certificateid} = props ?? {};

          return  renewCertificate(uuid,certificateid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenewCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof renewCertificate>>>

    export type RenewCertificateMutationError = AxiosError<unknown>

    /**
 * @summary Renew a certificate for a user, renew a certificate for a user by its id.
 */
export const useRenewCertificate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewCertificate>>, TError,{uuid: string;certificateid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof renewCertificate>>,
        TError,
        {uuid: string;certificateid: number},
        TContext
      > => {
      return useMutation(getRenewCertificateMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a certificate for a user, delete a certificate for a user by its id.
 */
export const revokeCertificate = (
    uuid: MaybeRefOrGetter<string>,
    certificateid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
certificateid = toValue(certificateid);

    return axios.delete(
      `/service/api/users/${uuid}/certificates/${certificateid}`,options
    );
  }




export const getRevokeCertificateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCertificate>>, TError,{uuid: string;certificateid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof revokeCertificate>>, TError,{uuid: string;certificateid: number}, TContext> => {

const mutationKey = ['revokeCertificate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeCertificate>>, {uuid: string;certificateid: number}> = (props) => {
          const {uuid,certificateid} = props ?? {};

          return  revokeCertificate(uuid,certificateid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof revokeCertificate>>>

    export type RevokeCertificateMutationError = AxiosError<unknown>

    /**
 * @summary Delete a certificate for a user, delete a certificate for a user by its id.
 */
export const useRevokeCertificate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCertificate>>, TError,{uuid: string;certificateid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof revokeCertificate>>,
        TError,
        {uuid: string;certificateid: number},
        TContext
      > => {
      return useMutation(getRevokeCertificateMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is company admin or the user himself
 * @summary Remove user from company
 */
export const removeFromCompany = (
    params: MaybeRefOrGetter<RemoveFromCompanyParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.put(
      `/service/api/users/remove-from-company`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getRemoveFromCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromCompany>>, TError,{params: RemoveFromCompanyParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeFromCompany>>, TError,{params: RemoveFromCompanyParams}, TContext> => {

const mutationKey = ['removeFromCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFromCompany>>, {params: RemoveFromCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  removeFromCompany(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFromCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof removeFromCompany>>>

    export type RemoveFromCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Remove user from company
 */
export const useRemoveFromCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromCompany>>, TError,{params: RemoveFromCompanyParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeFromCompany>>,
        TError,
        {params: RemoveFromCompanyParams},
        TContext
      > => {
      return useMutation(getRemoveFromCompanyMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Get the access token for the user
 */
export const getExternalUserAccessToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUserAccessToken>> => {


    return axios.get(
      `/service/api/users/access-tokens`,options
    );
  }




export const getGetExternalUserAccessTokenQueryKey = () => {
    return [
    'service','api','users','access-tokens'
    ] as const;
    }


export const getGetExternalUserAccessTokenQueryOptions = <TData = Awaited<ReturnType<typeof getExternalUserAccessToken>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalUserAccessToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetExternalUserAccessTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalUserAccessToken>>> = ({ signal }) => getExternalUserAccessToken({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalUserAccessToken>>, TError, TData>
}

export type GetExternalUserAccessTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalUserAccessToken>>>
export type GetExternalUserAccessTokenQueryError = AxiosError<unknown>


/**
 * @summary Get the access token for the user
 */

export function useGetExternalUserAccessToken<TData = Awaited<ReturnType<typeof getExternalUserAccessToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalUserAccessToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalUserAccessTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated.
 * @summary Update the access token for the user
 */
export const updateUserAccessToken = (
    webModelPutUserAccessToken: MaybeRefOrGetter<WebModelPutUserAccessToken>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUserAccessToken>> => {
    webModelPutUserAccessToken = toValue(webModelPutUserAccessToken);

    return axios.put(
      `/service/api/users/access-tokens`,
      webModelPutUserAccessToken,options
    );
  }




export const getUpdateUserAccessTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserAccessToken>>, TError,{data: WebModelPutUserAccessToken}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserAccessToken>>, TError,{data: WebModelPutUserAccessToken}, TContext> => {

const mutationKey = ['updateUserAccessToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserAccessToken>>, {data: WebModelPutUserAccessToken}> = (props) => {
          const {data} = props ?? {};

          return  updateUserAccessToken(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserAccessToken>>>
    export type UpdateUserAccessTokenMutationBody = WebModelPutUserAccessToken
    export type UpdateUserAccessTokenMutationError = AxiosError<unknown>

    /**
 * @summary Update the access token for the user
 */
export const useUpdateUserAccessToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserAccessToken>>, TError,{data: WebModelPutUserAccessToken}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserAccessToken>>,
        TError,
        {data: WebModelPutUserAccessToken},
        TContext
      > => {
      return useMutation(getUpdateUserAccessTokenMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Create an access token for the user
 */
export const createNewExternalUserAccessToken = (
    webModelPostNewUserAccessToken: MaybeRefOrGetter<WebModelPostNewUserAccessToken>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    webModelPostNewUserAccessToken = toValue(webModelPostNewUserAccessToken);

    return axios.post(
      `/service/api/users/access-tokens`,
      webModelPostNewUserAccessToken,{
    ...options,}
    );
  }




export const getCreateNewExternalUserAccessTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewExternalUserAccessToken>>, TError,{data: WebModelPostNewUserAccessToken}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createNewExternalUserAccessToken>>, TError,{data: WebModelPostNewUserAccessToken}, TContext> => {

const mutationKey = ['createNewExternalUserAccessToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewExternalUserAccessToken>>, {data: WebModelPostNewUserAccessToken}> = (props) => {
          const {data} = props ?? {};

          return  createNewExternalUserAccessToken(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewExternalUserAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createNewExternalUserAccessToken>>>
    export type CreateNewExternalUserAccessTokenMutationBody = WebModelPostNewUserAccessToken
    export type CreateNewExternalUserAccessTokenMutationError = AxiosError<unknown>

    /**
 * @summary Create an access token for the user
 */
export const useCreateNewExternalUserAccessToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewExternalUserAccessToken>>, TError,{data: WebModelPostNewUserAccessToken}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createNewExternalUserAccessToken>>,
        TError,
        {data: WebModelPostNewUserAccessToken},
        TContext
      > => {
      return useMutation(getCreateNewExternalUserAccessTokenMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Delete the access token for the user
 */
export const deleteUserAccessToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.delete(
      `/service/api/users/access-tokens`,options
    );
  }




export const getDeleteUserAccessTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccessToken>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccessToken>>, TError,void, TContext> => {

const mutationKey = ['deleteUserAccessToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserAccessToken>>, void> = () => {


          return  deleteUserAccessToken(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserAccessToken>>>

    export type DeleteUserAccessTokenMutationError = AxiosError<unknown>

    /**
 * @summary Delete the access token for the user
 */
export const useDeleteUserAccessToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccessToken>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteUserAccessToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteUserAccessTokenMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User uuid belongs to the requesting user.
 * @summary Reset user Roles to default role (ROLE_BUYER)
 */
export const resetToDefault = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Role[]>> => {
    uuid = toValue(uuid);

    return axios.put(
      `/service/api/user-principals/reset-to-default/${uuid}`,
      undefined,options
    );
  }




export const getResetToDefaultMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetToDefault>>, TError,{uuid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetToDefault>>, TError,{uuid: string}, TContext> => {

const mutationKey = ['resetToDefault'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetToDefault>>, {uuid: string}> = (props) => {
          const {uuid} = props ?? {};

          return  resetToDefault(uuid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetToDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof resetToDefault>>>

    export type ResetToDefaultMutationError = AxiosError<unknown>

    /**
 * @summary Reset user Roles to default role (ROLE_BUYER)
 */
export const useResetToDefault = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetToDefault>>, TError,{uuid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetToDefault>>,
        TError,
        {uuid: string},
        TContext
      > => {
      return useMutation(getResetToDefaultMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is a store admin.
 * @summary Download Invoice Html Template for Hub
 */
export const downloadInvoiceTemplateForHub = (
    hubid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    hubid = toValue(hubid);

    return axios.get(
      `/service/api/hubs/${hubid}/template/invoice`,{
        responseType: 'text',
    ...options,}
    );
  }




export const getDownloadInvoiceTemplateForHubQueryKey = (hubid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','hubs',hubid,'template','invoice'
    ] as const;
    }


export const getDownloadInvoiceTemplateForHubQueryOptions = <TData = Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>, TError = AxiosError<unknown>>(hubid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getDownloadInvoiceTemplateForHubQueryKey(hubid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>> = ({ signal }) => downloadInvoiceTemplateForHub(hubid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(hubid) !== null && toValue(hubid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>, TError, TData>
}

export type DownloadInvoiceTemplateForHubQueryResult = NonNullable<Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>>
export type DownloadInvoiceTemplateForHubQueryError = AxiosError<unknown>


/**
 * @summary Download Invoice Html Template for Hub
 */

export function useDownloadInvoiceTemplateForHub<TData = Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>, TError = AxiosError<unknown>>(
 hubid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadInvoiceTemplateForHub>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadInvoiceTemplateForHubQueryOptions(hubid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Upload Invoice Html Template for Hub
 */
export const updateInvoiceTemplateForHub = (
    hubid: MaybeRefOrGetter<string>,
    updateInvoiceTemplateForHubBody?: MaybeRefOrGetter<UpdateInvoiceTemplateForHubBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    hubid = toValue(hubid);
updateInvoiceTemplateForHubBody = toValue(updateInvoiceTemplateForHubBody);

    return axios.put(
      `/service/api/hubs/${hubid}/template/invoice`,
      updateInvoiceTemplateForHubBody,options
    );
  }




export const getUpdateInvoiceTemplateForHubMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceTemplateForHub>>, TError,{hubid: string;data?: UpdateInvoiceTemplateForHubBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceTemplateForHub>>, TError,{hubid: string;data?: UpdateInvoiceTemplateForHubBody}, TContext> => {

const mutationKey = ['updateInvoiceTemplateForHub'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoiceTemplateForHub>>, {hubid: string;data?: UpdateInvoiceTemplateForHubBody}> = (props) => {
          const {hubid,data} = props ?? {};

          return  updateInvoiceTemplateForHub(hubid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceTemplateForHubMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoiceTemplateForHub>>>
    export type UpdateInvoiceTemplateForHubMutationBody = UpdateInvoiceTemplateForHubBody | undefined
    export type UpdateInvoiceTemplateForHubMutationError = AxiosError<unknown>

    /**
 * @summary Upload Invoice Html Template for Hub
 */
export const useUpdateInvoiceTemplateForHub = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceTemplateForHub>>, TError,{hubid: string;data?: UpdateInvoiceTemplateForHubBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateInvoiceTemplateForHub>>,
        TError,
        {hubid: string;data?: UpdateInvoiceTemplateForHubBody},
        TContext
      > => {
      return useMutation(getUpdateInvoiceTemplateForHubMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is a store admin.
 * @summary Download Creditnote Html Template for Hub
 */
export const downloadCreditNoteTemplateForHub = (
    hubid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    hubid = toValue(hubid);

    return axios.get(
      `/service/api/hubs/${hubid}/template/creditnote`,{
        responseType: 'text',
    ...options,}
    );
  }




export const getDownloadCreditNoteTemplateForHubQueryKey = (hubid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','hubs',hubid,'template','creditnote'
    ] as const;
    }


export const getDownloadCreditNoteTemplateForHubQueryOptions = <TData = Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>, TError = AxiosError<unknown>>(hubid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getDownloadCreditNoteTemplateForHubQueryKey(hubid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>> = ({ signal }) => downloadCreditNoteTemplateForHub(hubid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(hubid) !== null && toValue(hubid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>, TError, TData>
}

export type DownloadCreditNoteTemplateForHubQueryResult = NonNullable<Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>>
export type DownloadCreditNoteTemplateForHubQueryError = AxiosError<unknown>


/**
 * @summary Download Creditnote Html Template for Hub
 */

export function useDownloadCreditNoteTemplateForHub<TData = Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>, TError = AxiosError<unknown>>(
 hubid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCreditNoteTemplateForHub>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadCreditNoteTemplateForHubQueryOptions(hubid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Upload Creditnote Html Template for Hub
 */
export const updateCreditNoteTemplateForHub = (
    hubid: MaybeRefOrGetter<string>,
    updateCreditNoteTemplateForHubBody?: MaybeRefOrGetter<UpdateCreditNoteTemplateForHubBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    hubid = toValue(hubid);
updateCreditNoteTemplateForHubBody = toValue(updateCreditNoteTemplateForHubBody);

    return axios.put(
      `/service/api/hubs/${hubid}/template/creditnote`,
      updateCreditNoteTemplateForHubBody,options
    );
  }




export const getUpdateCreditNoteTemplateForHubMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCreditNoteTemplateForHub>>, TError,{hubid: string;data?: UpdateCreditNoteTemplateForHubBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCreditNoteTemplateForHub>>, TError,{hubid: string;data?: UpdateCreditNoteTemplateForHubBody}, TContext> => {

const mutationKey = ['updateCreditNoteTemplateForHub'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCreditNoteTemplateForHub>>, {hubid: string;data?: UpdateCreditNoteTemplateForHubBody}> = (props) => {
          const {hubid,data} = props ?? {};

          return  updateCreditNoteTemplateForHub(hubid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCreditNoteTemplateForHubMutationResult = NonNullable<Awaited<ReturnType<typeof updateCreditNoteTemplateForHub>>>
    export type UpdateCreditNoteTemplateForHubMutationBody = UpdateCreditNoteTemplateForHubBody | undefined
    export type UpdateCreditNoteTemplateForHubMutationError = AxiosError<unknown>

    /**
 * @summary Upload Creditnote Html Template for Hub
 */
export const useUpdateCreditNoteTemplateForHub = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCreditNoteTemplateForHub>>, TError,{hubid: string;data?: UpdateCreditNoteTemplateForHubBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCreditNoteTemplateForHub>>,
        TError,
        {hubid: string;data?: UpdateCreditNoteTemplateForHubBody},
        TContext
      > => {
      return useMutation(getUpdateCreditNoteTemplateForHubMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Search all hardwaretypes
 */
export const findAllHardwareTypes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetHardwareType[]>> => {


    return axios.get(
      `/service/api/hardwaretype`,options
    );
  }




export const getFindAllHardwareTypesQueryKey = () => {
    return [
    'service','api','hardwaretype'
    ] as const;
    }


export const getFindAllHardwareTypesQueryOptions = <TData = Awaited<ReturnType<typeof findAllHardwareTypes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllHardwareTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAllHardwareTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllHardwareTypes>>> = ({ signal }) => findAllHardwareTypes({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllHardwareTypes>>, TError, TData>
}

export type FindAllHardwareTypesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllHardwareTypes>>>
export type FindAllHardwareTypesQueryError = AxiosError<unknown>


/**
 * @summary Search all hardwaretypes
 */

export function useFindAllHardwareTypes<TData = Awaited<ReturnType<typeof findAllHardwareTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllHardwareTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllHardwareTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Update a hardwaretype
 */
export const updateHardwareType = (
    webModelPutUpdateHardwareType: MaybeRefOrGetter<WebModelPutUpdateHardwareType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetHardwareType>> => {
    webModelPutUpdateHardwareType = toValue(webModelPutUpdateHardwareType);

    return axios.put(
      `/service/api/hardwaretype`,
      webModelPutUpdateHardwareType,options
    );
  }




export const getUpdateHardwareTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHardwareType>>, TError,{data: WebModelPutUpdateHardwareType}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateHardwareType>>, TError,{data: WebModelPutUpdateHardwareType}, TContext> => {

const mutationKey = ['updateHardwareType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHardwareType>>, {data: WebModelPutUpdateHardwareType}> = (props) => {
          const {data} = props ?? {};

          return  updateHardwareType(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHardwareTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateHardwareType>>>
    export type UpdateHardwareTypeMutationBody = WebModelPutUpdateHardwareType
    export type UpdateHardwareTypeMutationError = AxiosError<unknown>

    /**
 * @summary Update a hardwaretype
 */
export const useUpdateHardwareType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHardwareType>>, TError,{data: WebModelPutUpdateHardwareType}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHardwareType>>,
        TError,
        {data: WebModelPutUpdateHardwareType},
        TContext
      > => {
      return useMutation(getUpdateHardwareTypeMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is a store admin.
 * @summary Add a hardwaretype
 */
export const addHardwareType = (
    webModelPostNewHardwareType: MaybeRefOrGetter<WebModelPostNewHardwareType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetHardwareType>> => {
    webModelPostNewHardwareType = toValue(webModelPostNewHardwareType);

    return axios.post(
      `/service/api/hardwaretype`,
      webModelPostNewHardwareType,options
    );
  }




export const getAddHardwareTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addHardwareType>>, TError,{data: WebModelPostNewHardwareType}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addHardwareType>>, TError,{data: WebModelPostNewHardwareType}, TContext> => {

const mutationKey = ['addHardwareType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addHardwareType>>, {data: WebModelPostNewHardwareType}> = (props) => {
          const {data} = props ?? {};

          return  addHardwareType(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddHardwareTypeMutationResult = NonNullable<Awaited<ReturnType<typeof addHardwareType>>>
    export type AddHardwareTypeMutationBody = WebModelPostNewHardwareType
    export type AddHardwareTypeMutationError = AxiosError<unknown>

    /**
 * @summary Add a hardwaretype
 */
export const useAddHardwareType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addHardwareType>>, TError,{data: WebModelPostNewHardwareType}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addHardwareType>>,
        TError,
        {data: WebModelPostNewHardwareType},
        TContext
      > => {
      return useMutation(getAddHardwareTypeMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User can only access its own user-uuid path. User has to be the device owner.
 * @summary Search devices by user uuid
 */
export const findDevices = (
    params?: MaybeRefOrGetter<FindDevicesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDevice[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/devices`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindDevicesQueryKey = (params?: MaybeRefOrGetter<FindDevicesParams>,) => {
    return [
    'service','api','devices', ...(params ? [params] : [])
    ] as const;
    }


export const getFindDevicesQueryOptions = <TData = Awaited<ReturnType<typeof findDevices>>, TError = AxiosError<unknown>>(params?: MaybeRefOrGetter<FindDevicesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDevices>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDevices>>> = ({ signal }) => findDevices(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findDevices>>, TError, TData>
}

export type FindDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof findDevices>>>
export type FindDevicesQueryError = AxiosError<unknown>


/**
 * @summary Search devices by user uuid
 */

export function useFindDevices<TData = Awaited<ReturnType<typeof findDevices>>, TError = AxiosError<unknown>>(
 params?: MaybeRefOrGetter<FindDevicesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDevices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDevicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be the device owner.
 * @summary Update a device (firmwareVersion and onlineStatus read-only)
 */
export const updateDevice = (
    updateDeviceBody?: MaybeRefOrGetter<UpdateDeviceBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDevice>> => {
    updateDeviceBody = toValue(updateDeviceBody);
    const formData = new FormData();
if(updateDeviceBody?.iconFile !== undefined) {
 formData.append(`iconFile`, updateDeviceBody.iconFile);
 }
if(updateDeviceBody?.json !== undefined) {
 formData.append(`json`, JSON.stringify(updateDeviceBody.json));
 }

    return axios.put(
      `/service/api/devices`,
      formData,options
    );
  }




export const getUpdateDeviceMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{data?: UpdateDeviceBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{data?: UpdateDeviceBody}, TContext> => {

const mutationKey = ['updateDevice'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDevice>>, {data?: UpdateDeviceBody}> = (props) => {
          const {data} = props ?? {};

          return  updateDevice(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof updateDevice>>>
    export type UpdateDeviceMutationBody = UpdateDeviceBody | undefined
    export type UpdateDeviceMutationError = AxiosError<unknown>

    /**
 * @summary Update a device (firmwareVersion and onlineStatus read-only)
 */
export const useUpdateDevice = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{data?: UpdateDeviceBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateDevice>>,
        TError,
        {data?: UpdateDeviceBody},
        TContext
      > => {
      return useMutation(getUpdateDeviceMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated.
 * @summary Add a device
 */
export const addDevice = (
    addDeviceBody?: MaybeRefOrGetter<AddDeviceBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDevice>> => {
    addDeviceBody = toValue(addDeviceBody);
    const formData = new FormData();
if(addDeviceBody?.iconFile !== undefined) {
 formData.append(`iconFile`, addDeviceBody.iconFile);
 }
if(addDeviceBody?.json !== undefined) {
 formData.append(`json`, JSON.stringify(addDeviceBody.json));
 }

    return axios.post(
      `/service/api/devices`,
      formData,options
    );
  }




export const getAddDeviceMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDevice>>, TError,{data?: AddDeviceBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addDevice>>, TError,{data?: AddDeviceBody}, TContext> => {

const mutationKey = ['addDevice'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDevice>>, {data?: AddDeviceBody}> = (props) => {
          const {data} = props ?? {};

          return  addDevice(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof addDevice>>>
    export type AddDeviceMutationBody = AddDeviceBody | undefined
    export type AddDeviceMutationError = AxiosError<unknown>

    /**
 * @summary Add a device
 */
export const useAddDevice = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDevice>>, TError,{data?: AddDeviceBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addDevice>>,
        TError,
        {data?: AddDeviceBody},
        TContext
      > => {
      return useMutation(getAddDeviceMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner.
 * @summary Updates the binary of an installed app on a device
 */
export const updateInstalledAppBinary = (
    id: MaybeRefOrGetter<string>,
    installedAppId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
installedAppId = toValue(installedAppId);

    return axios.put(
      `/service/api/devices/${id}/installed-app/${installedAppId}/update-binary`,
      undefined,options
    );
  }




export const getUpdateInstalledAppBinaryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInstalledAppBinary>>, TError,{id: string;installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateInstalledAppBinary>>, TError,{id: string;installedAppId: number}, TContext> => {

const mutationKey = ['updateInstalledAppBinary'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInstalledAppBinary>>, {id: string;installedAppId: number}> = (props) => {
          const {id,installedAppId} = props ?? {};

          return  updateInstalledAppBinary(id,installedAppId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInstalledAppBinaryMutationResult = NonNullable<Awaited<ReturnType<typeof updateInstalledAppBinary>>>

    export type UpdateInstalledAppBinaryMutationError = AxiosError<unknown>

    /**
 * @summary Updates the binary of an installed app on a device
 */
export const useUpdateInstalledAppBinary = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInstalledAppBinary>>, TError,{id: string;installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateInstalledAppBinary>>,
        TError,
        {id: string;installedAppId: number},
        TContext
      > => {
      return useMutation(getUpdateInstalledAppBinaryMutationOptions(options), queryClient);
    }

/**
 * Security: No authentication required. Only variables with a matching required role are returned.
 * @summary Get Config Variables
 */
export const getConfigVariables = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetConfigVar[]>> => {


    return axios.get(
      `/service/api/configurations/config-vars`,options
    );
  }




export const getGetConfigVariablesQueryKey = () => {
    return [
    'service','api','configurations','config-vars'
    ] as const;
    }


export const getGetConfigVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getConfigVariables>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigVariables>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetConfigVariablesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigVariables>>> = ({ signal }) => getConfigVariables({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigVariables>>, TError, TData>
}

export type GetConfigVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigVariables>>>
export type GetConfigVariablesQueryError = AxiosError<unknown>


/**
 * @summary Get Config Variables
 */

export function useGetConfigVariables<TData = Awaited<ReturnType<typeof getConfigVariables>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigVariables>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigVariablesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be a store admin.
 * @summary Change Config Variable
 */
export const updateConfigVariable = (
    webModelPutConfigVar: MaybeRefOrGetter<WebModelPutConfigVar>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetConfigVar>> => {
    webModelPutConfigVar = toValue(webModelPutConfigVar);

    return axios.put(
      `/service/api/configurations/config-vars`,
      webModelPutConfigVar,options
    );
  }




export const getUpdateConfigVariableMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfigVariable>>, TError,{data: WebModelPutConfigVar}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateConfigVariable>>, TError,{data: WebModelPutConfigVar}, TContext> => {

const mutationKey = ['updateConfigVariable'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConfigVariable>>, {data: WebModelPutConfigVar}> = (props) => {
          const {data} = props ?? {};

          return  updateConfigVariable(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConfigVariableMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfigVariable>>>
    export type UpdateConfigVariableMutationBody = WebModelPutConfigVar
    export type UpdateConfigVariableMutationError = AxiosError<unknown>

    /**
 * @summary Change Config Variable
 */
export const useUpdateConfigVariable = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfigVariable>>, TError,{data: WebModelPutConfigVar}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateConfigVariable>>,
        TError,
        {data: WebModelPutConfigVar},
        TContext
      > => {
      return useMutation(getUpdateConfigVariableMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Search by company id
 */
export const findCompanyProfileByCompany = (
    params: MaybeRefOrGetter<FindCompanyProfileByCompanyParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/company-profiles`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindCompanyProfileByCompanyQueryKey = (params?: MaybeRefOrGetter<FindCompanyProfileByCompanyParams>,) => {
    return [
    'service','api','company-profiles', ...(params ? [params] : [])
    ] as const;
    }


export const getFindCompanyProfileByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyProfileByCompany>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindCompanyProfileByCompanyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyProfileByCompany>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindCompanyProfileByCompanyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyProfileByCompany>>> = ({ signal }) => findCompanyProfileByCompany(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyProfileByCompany>>, TError, TData>
}

export type FindCompanyProfileByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyProfileByCompany>>>
export type FindCompanyProfileByCompanyQueryError = AxiosError<unknown>


/**
 * @summary Search by company id
 */

export function useFindCompanyProfileByCompany<TData = Awaited<ReturnType<typeof findCompanyProfileByCompany>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindCompanyProfileByCompanyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyProfileByCompany>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyProfileByCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Update a company profile
 */
export const updateCompanyProfile = (
    updateCompanyProfileBody?: MaybeRefOrGetter<UpdateCompanyProfileBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile>> => {
    updateCompanyProfileBody = toValue(updateCompanyProfileBody);

    return axios.put(
      `/service/api/company-profiles`,
      updateCompanyProfileBody,options
    );
  }




export const getUpdateCompanyProfileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyProfile>>, TError,{data?: UpdateCompanyProfileBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyProfile>>, TError,{data?: UpdateCompanyProfileBody}, TContext> => {

const mutationKey = ['updateCompanyProfile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyProfile>>, {data?: UpdateCompanyProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCompanyProfile(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyProfile>>>
    export type UpdateCompanyProfileMutationBody = UpdateCompanyProfileBody | undefined
    export type UpdateCompanyProfileMutationError = AxiosError<unknown>

    /**
 * @summary Update a company profile
 */
export const useUpdateCompanyProfile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyProfile>>, TError,{data?: UpdateCompanyProfileBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCompanyProfile>>,
        TError,
        {data?: UpdateCompanyProfileBody},
        TContext
      > => {
      return useMutation(getUpdateCompanyProfileMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Add a company profile for a given company
 */
export const addCompanyProfile = (
    webModelPostCompanyProfile: MaybeRefOrGetter<WebModelPostCompanyProfile>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile>> => {
    webModelPostCompanyProfile = toValue(webModelPostCompanyProfile);

    return axios.post(
      `/service/api/company-profiles`,
      webModelPostCompanyProfile,options
    );
  }




export const getAddCompanyProfileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCompanyProfile>>, TError,{data: WebModelPostCompanyProfile}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addCompanyProfile>>, TError,{data: WebModelPostCompanyProfile}, TContext> => {

const mutationKey = ['addCompanyProfile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCompanyProfile>>, {data: WebModelPostCompanyProfile}> = (props) => {
          const {data} = props ?? {};

          return  addCompanyProfile(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCompanyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof addCompanyProfile>>>
    export type AddCompanyProfileMutationBody = WebModelPostCompanyProfile
    export type AddCompanyProfileMutationError = AxiosError<unknown>

    /**
 * @summary Add a company profile for a given company
 */
export const useAddCompanyProfile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCompanyProfile>>, TError,{data: WebModelPostCompanyProfile}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addCompanyProfile>>,
        TError,
        {data: WebModelPostCompanyProfile},
        TContext
      > => {
      return useMutation(getAddCompanyProfileMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Get all companies that the user should see
 */
export const getAllCompanies = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany[]>> => {


    return axios.get(
      `/service/api/companies`,options
    );
  }




export const getGetAllCompaniesQueryKey = () => {
    return [
    'service','api','companies'
    ] as const;
    }


export const getGetAllCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCompanies>>> = ({ signal }) => getAllCompanies({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>
}

export type GetAllCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCompanies>>>
export type GetAllCompaniesQueryError = AxiosError<unknown>


/**
 * @summary Get all companies that the user should see
 */

export function useGetAllCompanies<TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security:  User has to be authenticated. User has to be a company admin of the company
 * @summary Update a company
 */
export const updateCompany = (
    webModelPutUpdateCompany: MaybeRefOrGetter<WebModelPutUpdateCompany>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    webModelPutUpdateCompany = toValue(webModelPutUpdateCompany);

    return axios.put(
      `/service/api/companies`,
      webModelPutUpdateCompany,options
    );
  }




export const getUpdateCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: WebModelPutUpdateCompany}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: WebModelPutUpdateCompany}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {data: WebModelPutUpdateCompany}> = (props) => {
          const {data} = props ?? {};

          return  updateCompany(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = WebModelPutUpdateCompany
    export type UpdateCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Update a company
 */
export const useUpdateCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: WebModelPutUpdateCompany}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {data: WebModelPutUpdateCompany},
        TContext
      > => {
      return useMutation(getUpdateCompanyMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated.
 * @summary Add a company and sets the user as company admin
 */
export const createCompanyWithUserAndAddress = (
    webModelPostCompany: MaybeRefOrGetter<WebModelPostCompany>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    webModelPostCompany = toValue(webModelPostCompany);

    return axios.post(
      `/service/api/companies`,
      webModelPostCompany,options
    );
  }




export const getCreateCompanyWithUserAndAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyWithUserAndAddress>>, TError,{data: WebModelPostCompany}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyWithUserAndAddress>>, TError,{data: WebModelPostCompany}, TContext> => {

const mutationKey = ['createCompanyWithUserAndAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyWithUserAndAddress>>, {data: WebModelPostCompany}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyWithUserAndAddress(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyWithUserAndAddressMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyWithUserAndAddress>>>
    export type CreateCompanyWithUserAndAddressMutationBody = WebModelPostCompany
    export type CreateCompanyWithUserAndAddressMutationError = AxiosError<unknown>

    /**
 * @summary Add a company and sets the user as company admin
 */
export const useCreateCompanyWithUserAndAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyWithUserAndAddress>>, TError,{data: WebModelPostCompany}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCompanyWithUserAndAddress>>,
        TError,
        {data: WebModelPostCompany},
        TContext
      > => {
      return useMutation(getCreateCompanyWithUserAndAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Update a member of the given company
 */
export const updateCompanyMember = (
    id: MaybeRefOrGetter<string>,
    userid: MaybeRefOrGetter<string>,
    webModelPutUpdateCompanyMember: MaybeRefOrGetter<WebModelPutUpdateCompanyMember>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
userid = toValue(userid);
webModelPutUpdateCompanyMember = toValue(webModelPutUpdateCompanyMember);

    return axios.put(
      `/service/api/companies/${id}/company-members/${userid}`,
      webModelPutUpdateCompanyMember,options
    );
  }




export const getUpdateCompanyMemberMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyMember>>, TError,{id: string;userid: string;data: WebModelPutUpdateCompanyMember}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyMember>>, TError,{id: string;userid: string;data: WebModelPutUpdateCompanyMember}, TContext> => {

const mutationKey = ['updateCompanyMember'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyMember>>, {id: string;userid: string;data: WebModelPutUpdateCompanyMember}> = (props) => {
          const {id,userid,data} = props ?? {};

          return  updateCompanyMember(id,userid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyMember>>>
    export type UpdateCompanyMemberMutationBody = WebModelPutUpdateCompanyMember
    export type UpdateCompanyMemberMutationError = AxiosError<unknown>

    /**
 * @summary Update a member of the given company
 */
export const useUpdateCompanyMember = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyMember>>, TError,{id: string;userid: string;data: WebModelPutUpdateCompanyMember}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCompanyMember>>,
        TError,
        {id: string;userid: string;data: WebModelPutUpdateCompanyMember},
        TContext
      > => {
      return useMutation(getUpdateCompanyMemberMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Remove a member from a given company
 */
export const removeCompanyMember = (
    id: MaybeRefOrGetter<string>,
    userid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
userid = toValue(userid);

    return axios.delete(
      `/service/api/companies/${id}/company-members/${userid}`,options
    );
  }




export const getRemoveCompanyMemberMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCompanyMember>>, TError,{id: string;userid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeCompanyMember>>, TError,{id: string;userid: string}, TContext> => {

const mutationKey = ['removeCompanyMember'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCompanyMember>>, {id: string;userid: string}> = (props) => {
          const {id,userid} = props ?? {};

          return  removeCompanyMember(id,userid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCompanyMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeCompanyMember>>>

    export type RemoveCompanyMemberMutationError = AxiosError<unknown>

    /**
 * @summary Remove a member from a given company
 */
export const useRemoveCompanyMember = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCompanyMember>>, TError,{id: string;userid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeCompanyMember>>,
        TError,
        {id: string;userid: string},
        TContext
      > => {
      return useMutation(getRemoveCompanyMemberMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Update a CategoryGroup
 */
export const updateCategoryGroup = (
    id: MaybeRefOrGetter<number>,
    webModelPutCategoryGroup: MaybeRefOrGetter<WebModelPutCategoryGroup>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCategoryGroup>> => {
    id = toValue(id);
webModelPutCategoryGroup = toValue(webModelPutCategoryGroup);

    return axios.put(
      `/service/api/categorygroups/${id}`,
      webModelPutCategoryGroup,options
    );
  }




export const getUpdateCategoryGroupMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategoryGroup>>, TError,{id: number;data: WebModelPutCategoryGroup}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategoryGroup>>, TError,{id: number;data: WebModelPutCategoryGroup}, TContext> => {

const mutationKey = ['updateCategoryGroup'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategoryGroup>>, {id: number;data: WebModelPutCategoryGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategoryGroup(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategoryGroup>>>
    export type UpdateCategoryGroupMutationBody = WebModelPutCategoryGroup
    export type UpdateCategoryGroupMutationError = AxiosError<unknown>

    /**
 * @summary Update a CategoryGroup
 */
export const useUpdateCategoryGroup = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategoryGroup>>, TError,{id: number;data: WebModelPutCategoryGroup}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCategoryGroup>>,
        TError,
        {id: number;data: WebModelPutCategoryGroup},
        TContext
      > => {
      return useMutation(getUpdateCategoryGroupMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Delete a CategoryGroup
 */
export const deleteCategoryGroup = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/categorygroups/${id}`,options
    );
  }




export const getDeleteCategoryGroupMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategoryGroup>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategoryGroup>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCategoryGroup'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategoryGroup>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCategoryGroup(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategoryGroup>>>

    export type DeleteCategoryGroupMutationError = AxiosError<unknown>

    /**
 * @summary Delete a CategoryGroup
 */
export const useDeleteCategoryGroup = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategoryGroup>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCategoryGroup>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCategoryGroupMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Update a Category
 */
export const updateCategory = (
    id: MaybeRefOrGetter<number>,
    webModelPutCategorie: MaybeRefOrGetter<WebModelPutCategorie>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCategory>> => {
    id = toValue(id);
webModelPutCategorie = toValue(webModelPutCategorie);

    return axios.put(
      `/service/api/categories/${id}`,
      webModelPutCategorie,options
    );
  }




export const getUpdateCategoryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: WebModelPutCategorie}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: WebModelPutCategorie}, TContext> => {

const mutationKey = ['updateCategory'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, {id: number;data: WebModelPutCategorie}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategory(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
    export type UpdateCategoryMutationBody = WebModelPutCategorie
    export type UpdateCategoryMutationError = AxiosError<unknown>

    /**
 * @summary Update a Category
 */
export const useUpdateCategory = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: WebModelPutCategorie}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCategory>>,
        TError,
        {id: number;data: WebModelPutCategorie},
        TContext
      > => {
      return useMutation(getUpdateCategoryMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Delete a Category
 */
export const deleteCategory = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/categories/${id}`,options
    );
  }




export const getDeleteCategoryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCategory'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCategory(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>

    export type DeleteCategoryMutationError = AxiosError<unknown>

    /**
 * @summary Delete a Category
 */
export const useDeleteCategory = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCategory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCategoryMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Update app settings by id for fields only the store admin can update
 */
export const updateAppByIdAsAdmin = (
    id: MaybeRefOrGetter<number>,
    webModelPutAppSettingsAsAdmin: MaybeRefOrGetter<WebModelPutAppSettingsAsAdmin>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppSettings>> => {
    id = toValue(id);
webModelPutAppSettingsAsAdmin = toValue(webModelPutAppSettingsAsAdmin);

    return axios.put(
      `/service/api/appsettings/${id}/admin`,
      webModelPutAppSettingsAsAdmin,options
    );
  }




export const getUpdateAppByIdAsAdminMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppByIdAsAdmin>>, TError,{id: number;data: WebModelPutAppSettingsAsAdmin}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppByIdAsAdmin>>, TError,{id: number;data: WebModelPutAppSettingsAsAdmin}, TContext> => {

const mutationKey = ['updateAppByIdAsAdmin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppByIdAsAdmin>>, {id: number;data: WebModelPutAppSettingsAsAdmin}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAppByIdAsAdmin(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppByIdAsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppByIdAsAdmin>>>
    export type UpdateAppByIdAsAdminMutationBody = WebModelPutAppSettingsAsAdmin
    export type UpdateAppByIdAsAdminMutationError = AxiosError<unknown>

    /**
 * @summary Update app settings by id for fields only the store admin can update
 */
export const useUpdateAppByIdAsAdmin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppByIdAsAdmin>>, TError,{id: number;data: WebModelPutAppSettingsAsAdmin}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAppByIdAsAdmin>>,
        TError,
        {id: number;data: WebModelPutAppSettingsAsAdmin},
        TContext
      > => {
      return useMutation(getUpdateAppByIdAsAdminMutationOptions(options), queryClient);
    }

/**
 * Security: Apps in Status Draft are only visible for assigned developers and store admins.
 * @summary Search an app version by the id of that version
 */
export const getAppById = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/apps/id/${id}`,options
    );
  }




export const getGetAppByIdQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','id',id
    ] as const;
    }


export const getGetAppByIdQueryOptions = <TData = Awaited<ReturnType<typeof getAppById>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppById>>> = ({ signal }) => getAppById(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppById>>, TError, TData>
}

export type GetAppByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAppById>>>
export type GetAppByIdQueryError = AxiosError<unknown>


/**
 * @summary Search an app version by the id of that version
 */

export function useGetAppById<TData = Awaited<ReturnType<typeof getAppById>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be assigned developer.
 * @summary Update the version data of an app
 */
export const updateVersionData = (
    id: MaybeRefOrGetter<number>,
    updateVersionDataBody?: MaybeRefOrGetter<UpdateVersionDataBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    id = toValue(id);
updateVersionDataBody = toValue(updateVersionDataBody);
    const formData = new FormData();
if(updateVersionDataBody?.json !== undefined) {
 formData.append(`json`, JSON.stringify(updateVersionDataBody.json));
 }
if(updateVersionDataBody?.changelogFile !== undefined) {
 formData.append(`changelogFile`, updateVersionDataBody.changelogFile);
 }
if(updateVersionDataBody?.pictureVideoUsecaseFiles !== undefined) {
 updateVersionDataBody?.pictureVideoUsecaseFiles.forEach(value => formData.append(`pictureVideoUsecaseFiles`, value));
 }
if(updateVersionDataBody?.technicalDocumentationFiles !== undefined) {
 updateVersionDataBody?.technicalDocumentationFiles.forEach(value => formData.append(`technicalDocumentationFiles`, value));
 }

    return axios.put(
      `/service/api/apps/id/${id}`,
      formData,options
    );
  }




export const getUpdateVersionDataMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVersionData>>, TError,{id: number;data?: UpdateVersionDataBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateVersionData>>, TError,{id: number;data?: UpdateVersionDataBody}, TContext> => {

const mutationKey = ['updateVersionData'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVersionData>>, {id: number;data?: UpdateVersionDataBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVersionData(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVersionDataMutationResult = NonNullable<Awaited<ReturnType<typeof updateVersionData>>>
    export type UpdateVersionDataMutationBody = UpdateVersionDataBody | undefined
    export type UpdateVersionDataMutationError = AxiosError<unknown>

    /**
 * @summary Update the version data of an app
 */
export const useUpdateVersionData = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVersionData>>, TError,{id: number;data?: UpdateVersionDataBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVersionData>>,
        TError,
        {id: number;data?: UpdateVersionDataBody},
        TContext
      > => {
      return useMutation(getUpdateVersionDataMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be assigned developer to the app.
 * @summary Update an app status by appId (status can be: DRAFT, RELEASED, ARCHIVED)
 */
export const updateAppStatus = (
    id: MaybeRefOrGetter<number>,
    webModelPutUpdateAppStatus: MaybeRefOrGetter<WebModelPutUpdateAppStatus>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    id = toValue(id);
webModelPutUpdateAppStatus = toValue(webModelPutUpdateAppStatus);

    return axios.put(
      `/service/api/apps/id/${id}/status`,
      webModelPutUpdateAppStatus,options
    );
  }




export const getUpdateAppStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppStatus>>, TError,{id: number;data: WebModelPutUpdateAppStatus}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppStatus>>, TError,{id: number;data: WebModelPutUpdateAppStatus}, TContext> => {

const mutationKey = ['updateAppStatus'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppStatus>>, {id: number;data: WebModelPutUpdateAppStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAppStatus(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppStatus>>>
    export type UpdateAppStatusMutationBody = WebModelPutUpdateAppStatus
    export type UpdateAppStatusMutationError = AxiosError<unknown>

    /**
 * @summary Update an app status by appId (status can be: DRAFT, RELEASED, ARCHIVED)
 */
export const useUpdateAppStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppStatus>>, TError,{id: number;data: WebModelPutUpdateAppStatus}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAppStatus>>,
        TError,
        {id: number;data: WebModelPutUpdateAppStatus},
        TContext
      > => {
      return useMutation(getUpdateAppStatusMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be assigned developer to the app.
 * @summary Activate/Deactivate an AppVersion.
 */
export const deactivate = (
    id: MaybeRefOrGetter<number>,
    boolean: MaybeRefOrGetter<boolean>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
boolean = toValue(boolean);

    return axios.put(
      `/service/api/apps/id/${id}/deactivate`,
      boolean,options
    );
  }




export const getDeactivateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,{id: number;data: boolean}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,{id: number;data: boolean}, TContext> => {

const mutationKey = ['deactivate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivate>>, {id: number;data: boolean}> = (props) => {
          const {id,data} = props ?? {};

          return  deactivate(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof deactivate>>>
    export type DeactivateMutationBody = boolean
    export type DeactivateMutationError = AxiosError<unknown>

    /**
 * @summary Activate/Deactivate an AppVersion.
 */
export const useDeactivate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,{id: number;data: boolean}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivate>>,
        TError,
        {id: number;data: boolean},
        TContext
      > => {
      return useMutation(getDeactivateMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be store admin.
 * @summary As an store admin: Certify/Uncertify an app (default value for 'certified' is true)
 */
export const certify = (
    id: MaybeRefOrGetter<number>,
    boolean?: MaybeRefOrGetter<boolean>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
boolean = toValue(boolean);

    return axios.put(
      `/service/api/apps/id/${id}/certify`,
      boolean,options
    );
  }




export const getCertifyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof certify>>, TError,{id: number;data?: boolean}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof certify>>, TError,{id: number;data?: boolean}, TContext> => {

const mutationKey = ['certify'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof certify>>, {id: number;data?: boolean}> = (props) => {
          const {id,data} = props ?? {};

          return  certify(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CertifyMutationResult = NonNullable<Awaited<ReturnType<typeof certify>>>
    export type CertifyMutationBody = boolean | undefined
    export type CertifyMutationError = AxiosError<unknown>

    /**
 * @summary As an store admin: Certify/Uncertify an app (default value for 'certified' is true)
 */
export const useCertify = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof certify>>, TError,{id: number;data?: boolean}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof certify>>,
        TError,
        {id: number;data?: boolean},
        TContext
      > => {
      return useMutation(getCertifyMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Search an app by APP_ID
 */
export const getLatestAppByAppId = (
    appId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    appId = toValue(appId);

    return axios.get(
      `/service/api/apps/app-id/${appId}`,options
    );
  }




export const getGetLatestAppByAppIdQueryKey = (appId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','app-id',appId
    ] as const;
    }


export const getGetLatestAppByAppIdQueryOptions = <TData = Awaited<ReturnType<typeof getLatestAppByAppId>>, TError = AxiosError<unknown>>(appId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestAppByAppId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetLatestAppByAppIdQueryKey(appId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestAppByAppId>>> = ({ signal }) => getLatestAppByAppId(appId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appId) !== null && toValue(appId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestAppByAppId>>, TError, TData>
}

export type GetLatestAppByAppIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestAppByAppId>>>
export type GetLatestAppByAppIdQueryError = AxiosError<unknown>


/**
 * @summary Search an app by APP_ID
 */

export function useGetLatestAppByAppId<TData = Awaited<ReturnType<typeof getLatestAppByAppId>>, TError = AxiosError<unknown>>(
 appId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestAppByAppId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestAppByAppIdQueryOptions(appId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be assigned developer to the app.
 * @summary Update an app (the core data, properties for all versions of this app)
 */
export const updateCoreData = (
    appId: MaybeRefOrGetter<number>,
    updateCoreDataBody?: MaybeRefOrGetter<UpdateCoreDataBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    appId = toValue(appId);
updateCoreDataBody = toValue(updateCoreDataBody);
    const formData = new FormData();
if(updateCoreDataBody?.json !== undefined) {
 formData.append(`json`, JSON.stringify(updateCoreDataBody.json));
 }
if(updateCoreDataBody?.file !== undefined) {
 formData.append(`file`, updateCoreDataBody.file);
 }

    return axios.put(
      `/service/api/apps/app-id/${appId}`,
      formData,options
    );
  }




export const getUpdateCoreDataMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoreData>>, TError,{appId: number;data?: UpdateCoreDataBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateCoreData>>, TError,{appId: number;data?: UpdateCoreDataBody}, TContext> => {

const mutationKey = ['updateCoreData'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCoreData>>, {appId: number;data?: UpdateCoreDataBody}> = (props) => {
          const {appId,data} = props ?? {};

          return  updateCoreData(appId,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCoreDataMutationResult = NonNullable<Awaited<ReturnType<typeof updateCoreData>>>
    export type UpdateCoreDataMutationBody = UpdateCoreDataBody | undefined
    export type UpdateCoreDataMutationError = AxiosError<unknown>

    /**
 * @summary Update an app (the core data, properties for all versions of this app)
 */
export const useUpdateCoreData = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoreData>>, TError,{appId: number;data?: UpdateCoreDataBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCoreData>>,
        TError,
        {appId: number;data?: UpdateCoreDataBody},
        TContext
      > => {
      return useMutation(getUpdateCoreDataMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is assigned to the app. The license options belongs to the app.
 * @summary Update a license option for an app
 */
export const updateLicenseOption = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    webModelPutLicenseOption: MaybeRefOrGetter<WebModelPutLicenseOption>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicenseOption>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);
webModelPutLicenseOption = toValue(webModelPutLicenseOption);

    return axios.put(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}`,
      webModelPutLicenseOption,options
    );
  }




export const getUpdateLicenseOptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicenseOption>>, TError,{appId: number;licenseOptionId: number;data: WebModelPutLicenseOption}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateLicenseOption>>, TError,{appId: number;licenseOptionId: number;data: WebModelPutLicenseOption}, TContext> => {

const mutationKey = ['updateLicenseOption'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLicenseOption>>, {appId: number;licenseOptionId: number;data: WebModelPutLicenseOption}> = (props) => {
          const {appId,licenseOptionId,data} = props ?? {};

          return  updateLicenseOption(appId,licenseOptionId,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLicenseOptionMutationResult = NonNullable<Awaited<ReturnType<typeof updateLicenseOption>>>
    export type UpdateLicenseOptionMutationBody = WebModelPutLicenseOption
    export type UpdateLicenseOptionMutationError = AxiosError<unknown>

    /**
 * @summary Update a license option for an app
 */
export const useUpdateLicenseOption = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicenseOption>>, TError,{appId: number;licenseOptionId: number;data: WebModelPutLicenseOption}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateLicenseOption>>,
        TError,
        {appId: number;licenseOptionId: number;data: WebModelPutLicenseOption},
        TContext
      > => {
      return useMutation(getUpdateLicenseOptionMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is assigned to the app
 * @summary Update a license option status
 */
export const updateLicenseOptionStatus = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    webModelPutLicenseOptionStatus: MaybeRefOrGetter<WebModelPutLicenseOptionStatus>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicenseOption>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);
webModelPutLicenseOptionStatus = toValue(webModelPutLicenseOptionStatus);

    return axios.put(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}/status`,
      webModelPutLicenseOptionStatus,options
    );
  }




export const getUpdateLicenseOptionStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicenseOptionStatus>>, TError,{appId: number;licenseOptionId: number;data: WebModelPutLicenseOptionStatus}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateLicenseOptionStatus>>, TError,{appId: number;licenseOptionId: number;data: WebModelPutLicenseOptionStatus}, TContext> => {

const mutationKey = ['updateLicenseOptionStatus'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLicenseOptionStatus>>, {appId: number;licenseOptionId: number;data: WebModelPutLicenseOptionStatus}> = (props) => {
          const {appId,licenseOptionId,data} = props ?? {};

          return  updateLicenseOptionStatus(appId,licenseOptionId,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLicenseOptionStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateLicenseOptionStatus>>>
    export type UpdateLicenseOptionStatusMutationBody = WebModelPutLicenseOptionStatus
    export type UpdateLicenseOptionStatusMutationError = AxiosError<unknown>

    /**
 * @summary Update a license option status
 */
export const useUpdateLicenseOptionStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicenseOptionStatus>>, TError,{appId: number;licenseOptionId: number;data: WebModelPutLicenseOptionStatus}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateLicenseOptionStatus>>,
        TError,
        {appId: number;licenseOptionId: number;data: WebModelPutLicenseOptionStatus},
        TContext
      > => {
      return useMutation(getUpdateLicenseOptionStatusMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Update app types
 */
export const updateAppTypeById = (
    id: MaybeRefOrGetter<number>,
    webModelPutAppType: MaybeRefOrGetter<WebModelPutAppType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppType>> => {
    id = toValue(id);
webModelPutAppType = toValue(webModelPutAppType);

    return axios.put(
      `/service/api/app-types/${id}`,
      webModelPutAppType,options
    );
  }




export const getUpdateAppTypeByIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppTypeById>>, TError,{id: number;data: WebModelPutAppType}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppTypeById>>, TError,{id: number;data: WebModelPutAppType}, TContext> => {

const mutationKey = ['updateAppTypeById'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppTypeById>>, {id: number;data: WebModelPutAppType}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAppTypeById(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppTypeByIdMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppTypeById>>>
    export type UpdateAppTypeByIdMutationBody = WebModelPutAppType
    export type UpdateAppTypeByIdMutationError = AxiosError<unknown>

    /**
 * @summary Update app types
 */
export const useUpdateAppTypeById = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppTypeById>>, TError,{id: number;data: WebModelPutAppType}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAppTypeById>>,
        TError,
        {id: number;data: WebModelPutAppType},
        TContext
      > => {
      return useMutation(getUpdateAppTypeByIdMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Confirm that a RaU-File was downloaded in the frontend
 */
export const confirmOfflineUpdateFileDownload = (
    params: MaybeRefOrGetter<ConfirmOfflineUpdateFileDownloadParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.put(
      `/service/api/app-licenses/confirmOfflineUpdateFileDownload`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getConfirmOfflineUpdateFileDownloadMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineUpdateFileDownload>>, TError,{params: ConfirmOfflineUpdateFileDownloadParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineUpdateFileDownload>>, TError,{params: ConfirmOfflineUpdateFileDownloadParams}, TContext> => {

const mutationKey = ['confirmOfflineUpdateFileDownload'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOfflineUpdateFileDownload>>, {params: ConfirmOfflineUpdateFileDownloadParams}> = (props) => {
          const {params} = props ?? {};

          return  confirmOfflineUpdateFileDownload(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOfflineUpdateFileDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOfflineUpdateFileDownload>>>

    export type ConfirmOfflineUpdateFileDownloadMutationError = AxiosError<unknown>

    /**
 * @summary Confirm that a RaU-File was downloaded in the frontend
 */
export const useConfirmOfflineUpdateFileDownload = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineUpdateFileDownload>>, TError,{params: ConfirmOfflineUpdateFileDownloadParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmOfflineUpdateFileDownload>>,
        TError,
        {params: ConfirmOfflineUpdateFileDownloadParams},
        TContext
      > => {
      return useMutation(getConfirmOfflineUpdateFileDownloadMutationOptions(options), queryClient);
    }

/**
 * Security:  User is authenticated.
 * @summary Confirm that a RaU-File was downloaded in the frontend
 */
export const confirmOfflineRarRequested = (
    params: MaybeRefOrGetter<ConfirmOfflineRarRequestedParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.put(
      `/service/api/app-licenses/confirmOfflineRarRequested`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getConfirmOfflineRarRequestedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineRarRequested>>, TError,{params: ConfirmOfflineRarRequestedParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineRarRequested>>, TError,{params: ConfirmOfflineRarRequestedParams}, TContext> => {

const mutationKey = ['confirmOfflineRarRequested'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOfflineRarRequested>>, {params: ConfirmOfflineRarRequestedParams}> = (props) => {
          const {params} = props ?? {};

          return  confirmOfflineRarRequested(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOfflineRarRequestedMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOfflineRarRequested>>>

    export type ConfirmOfflineRarRequestedMutationError = AxiosError<unknown>

    /**
 * @summary Confirm that a RaU-File was downloaded in the frontend
 */
export const useConfirmOfflineRarRequested = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineRarRequested>>, TError,{params: ConfirmOfflineRarRequestedParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmOfflineRarRequested>>,
        TError,
        {params: ConfirmOfflineRarRequestedParams},
        TContext
      > => {
      return useMutation(getConfirmOfflineRarRequestedMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and owner of the license.
 * @summary Upload a Rar-File to confirm a license operation
 */
export const confirmOfflineProcess = (
    cmContainerContextFile: MaybeRefOrGetter<CmContainerContextFile>,
    params: MaybeRefOrGetter<ConfirmOfflineProcessParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    cmContainerContextFile = toValue(cmContainerContextFile);
params = toValue(params);

    return axios.put(
      `/service/api/app-licenses/confirmOfflineProcess`,
      cmContainerContextFile,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getConfirmOfflineProcessMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineProcess>>, TError,{data: CmContainerContextFile;params: ConfirmOfflineProcessParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineProcess>>, TError,{data: CmContainerContextFile;params: ConfirmOfflineProcessParams}, TContext> => {

const mutationKey = ['confirmOfflineProcess'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOfflineProcess>>, {data: CmContainerContextFile;params: ConfirmOfflineProcessParams}> = (props) => {
          const {data,params} = props ?? {};

          return  confirmOfflineProcess(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOfflineProcessMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOfflineProcess>>>
    export type ConfirmOfflineProcessMutationBody = CmContainerContextFile
    export type ConfirmOfflineProcessMutationError = AxiosError<unknown>

    /**
 * @summary Upload a Rar-File to confirm a license operation
 */
export const useConfirmOfflineProcess = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineProcess>>, TError,{data: CmContainerContextFile;params: ConfirmOfflineProcessParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmOfflineProcess>>,
        TError,
        {data: CmContainerContextFile;params: ConfirmOfflineProcessParams},
        TContext
      > => {
      return useMutation(getConfirmOfflineProcessMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and owner of the device.
 * @summary Upload a Rar-File to confirm a license operation
 */
export const confirmOfflineProcessAfterwards = (
    cmContainerContextFile: MaybeRefOrGetter<CmContainerContextFile>,
    params: MaybeRefOrGetter<ConfirmOfflineProcessAfterwardsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    cmContainerContextFile = toValue(cmContainerContextFile);
params = toValue(params);

    return axios.put(
      `/service/api/app-licenses/confirmOfflineLicense`,
      cmContainerContextFile,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getConfirmOfflineProcessAfterwardsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineProcessAfterwards>>, TError,{data: CmContainerContextFile;params: ConfirmOfflineProcessAfterwardsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineProcessAfterwards>>, TError,{data: CmContainerContextFile;params: ConfirmOfflineProcessAfterwardsParams}, TContext> => {

const mutationKey = ['confirmOfflineProcessAfterwards'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOfflineProcessAfterwards>>, {data: CmContainerContextFile;params: ConfirmOfflineProcessAfterwardsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  confirmOfflineProcessAfterwards(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOfflineProcessAfterwardsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOfflineProcessAfterwards>>>
    export type ConfirmOfflineProcessAfterwardsMutationBody = CmContainerContextFile
    export type ConfirmOfflineProcessAfterwardsMutationError = AxiosError<unknown>

    /**
 * @summary Upload a Rar-File to confirm a license operation
 */
export const useConfirmOfflineProcessAfterwards = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOfflineProcessAfterwards>>, TError,{data: CmContainerContextFile;params: ConfirmOfflineProcessAfterwardsParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmOfflineProcessAfterwards>>,
        TError,
        {data: CmContainerContextFile;params: ConfirmOfflineProcessAfterwardsParams},
        TContext
      > => {
      return useMutation(getConfirmOfflineProcessAfterwardsMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is requested user himself
 * @summary Update the country of an user
 */
export const updateUserCountry = (
    uuid: MaybeRefOrGetter<string>,
    webModelUpdateUserCountry: MaybeRefOrGetter<WebModelUpdateUserCountry>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
webModelUpdateUserCountry = toValue(webModelUpdateUserCountry);

    return axios.post(
      `/service/api/users/${uuid}/update/country`,
      webModelUpdateUserCountry,options
    );
  }




export const getUpdateUserCountryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserCountry>>, TError,{uuid: string;data: WebModelUpdateUserCountry}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserCountry>>, TError,{uuid: string;data: WebModelUpdateUserCountry}, TContext> => {

const mutationKey = ['updateUserCountry'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserCountry>>, {uuid: string;data: WebModelUpdateUserCountry}> = (props) => {
          const {uuid,data} = props ?? {};

          return  updateUserCountry(uuid,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserCountryMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserCountry>>>
    export type UpdateUserCountryMutationBody = WebModelUpdateUserCountry
    export type UpdateUserCountryMutationError = AxiosError<unknown>

    /**
 * @summary Update the country of an user
 */
export const useUpdateUserCountry = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserCountry>>, TError,{uuid: string;data: WebModelUpdateUserCountry}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserCountry>>,
        TError,
        {uuid: string;data: WebModelUpdateUserCountry},
        TContext
      > => {
      return useMutation(getUpdateUserCountryMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Creates a new app update subscription for the tuple (user,app)
 */
export const addAppUpdateSubscription = (
    uuid: MaybeRefOrGetter<string>,
    appid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
appid = toValue(appid);

    return axios.post(
      `/service/api/users/${uuid}/subscriptions/app/${appid}/update`,
      undefined,options
    );
  }




export const getAddAppUpdateSubscriptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppUpdateSubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addAppUpdateSubscription>>, TError,{uuid: string;appid: number}, TContext> => {

const mutationKey = ['addAppUpdateSubscription'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAppUpdateSubscription>>, {uuid: string;appid: number}> = (props) => {
          const {uuid,appid} = props ?? {};

          return  addAppUpdateSubscription(uuid,appid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAppUpdateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof addAppUpdateSubscription>>>

    export type AddAppUpdateSubscriptionMutationError = AxiosError<unknown>

    /**
 * @summary Creates a new app update subscription for the tuple (user,app)
 */
export const useAddAppUpdateSubscription = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppUpdateSubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addAppUpdateSubscription>>,
        TError,
        {uuid: string;appid: number},
        TContext
      > => {
      return useMutation(getAddAppUpdateSubscriptionMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Removes the app update subscription for the tuple (user,app)
 */
export const removeAppUpdateSubscription = (
    uuid: MaybeRefOrGetter<string>,
    appid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
appid = toValue(appid);

    return axios.delete(
      `/service/api/users/${uuid}/subscriptions/app/${appid}/update`,options
    );
  }




export const getRemoveAppUpdateSubscriptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAppUpdateSubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeAppUpdateSubscription>>, TError,{uuid: string;appid: number}, TContext> => {

const mutationKey = ['removeAppUpdateSubscription'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAppUpdateSubscription>>, {uuid: string;appid: number}> = (props) => {
          const {uuid,appid} = props ?? {};

          return  removeAppUpdateSubscription(uuid,appid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAppUpdateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof removeAppUpdateSubscription>>>

    export type RemoveAppUpdateSubscriptionMutationError = AxiosError<unknown>

    /**
 * @summary Removes the app update subscription for the tuple (user,app)
 */
export const useRemoveAppUpdateSubscription = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAppUpdateSubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeAppUpdateSubscription>>,
        TError,
        {uuid: string;appid: number},
        TContext
      > => {
      return useMutation(getRemoveAppUpdateSubscriptionMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Creates a new app safety subscription for the tuple (user,app)
 */
export const addAppSafetySubscription = (
    uuid: MaybeRefOrGetter<string>,
    appid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
appid = toValue(appid);

    return axios.post(
      `/service/api/users/${uuid}/subscriptions/app/${appid}/safety`,
      undefined,options
    );
  }




export const getAddAppSafetySubscriptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppSafetySubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addAppSafetySubscription>>, TError,{uuid: string;appid: number}, TContext> => {

const mutationKey = ['addAppSafetySubscription'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAppSafetySubscription>>, {uuid: string;appid: number}> = (props) => {
          const {uuid,appid} = props ?? {};

          return  addAppSafetySubscription(uuid,appid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAppSafetySubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof addAppSafetySubscription>>>

    export type AddAppSafetySubscriptionMutationError = AxiosError<unknown>

    /**
 * @summary Creates a new app safety subscription for the tuple (user,app)
 */
export const useAddAppSafetySubscription = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppSafetySubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addAppSafetySubscription>>,
        TError,
        {uuid: string;appid: number},
        TContext
      > => {
      return useMutation(getAddAppSafetySubscriptionMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated.
 * @summary Removes the app safety subscription for the tuple (user,app)
 */
export const removeAppSafetySubscription = (
    uuid: MaybeRefOrGetter<string>,
    appid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);
appid = toValue(appid);

    return axios.delete(
      `/service/api/users/${uuid}/subscriptions/app/${appid}/safety`,options
    );
  }




export const getRemoveAppSafetySubscriptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAppSafetySubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeAppSafetySubscription>>, TError,{uuid: string;appid: number}, TContext> => {

const mutationKey = ['removeAppSafetySubscription'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAppSafetySubscription>>, {uuid: string;appid: number}> = (props) => {
          const {uuid,appid} = props ?? {};

          return  removeAppSafetySubscription(uuid,appid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAppSafetySubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof removeAppSafetySubscription>>>

    export type RemoveAppSafetySubscriptionMutationError = AxiosError<unknown>

    /**
 * @summary Removes the app safety subscription for the tuple (user,app)
 */
export const useRemoveAppSafetySubscription = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAppSafetySubscription>>, TError,{uuid: string;appid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeAppSafetySubscription>>,
        TError,
        {uuid: string;appid: number},
        TContext
      > => {
      return useMutation(getRemoveAppSafetySubscriptionMutationOptions(options), queryClient);
    }

/**
 * @summary Get certificates for a user
 */
export const getCertificates = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCertificate[]>> => {
    uuid = toValue(uuid);

    return axios.get(
      `/service/api/users/${uuid}/certificates`,options
    );
  }




export const getGetCertificatesQueryKey = (uuid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','users',uuid,'certificates'
    ] as const;
    }


export const getGetCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof getCertificates>>, TError = AxiosError<unknown>>(uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCertificatesQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertificates>>> = ({ signal }) => getCertificates(uuid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uuid) !== null && toValue(uuid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>
}

export type GetCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCertificates>>>
export type GetCertificatesQueryError = AxiosError<unknown>


/**
 * @summary Get certificates for a user
 */

export function useGetCertificates<TData = Awaited<ReturnType<typeof getCertificates>>, TError = AxiosError<unknown>>(
 uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificates>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCertificatesQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * @summary Create a new certificate for a user, create a new certificate for a user by posting a certificate signing request (CSR) file. The certificate will be signed by the CA. The certificate will be returned in the response.
 */
export const createCertificate = (
    uuid: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<CreateCertificateParams>,
    createCertificateBody?: MaybeRefOrGetter<CreateCertificateBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCertificate>> => {
    uuid = toValue(uuid);
params = toValue(params);
createCertificateBody = toValue(createCertificateBody);
    const formData = new FormData();
if(createCertificateBody?.csrFile !== undefined) {
 formData.append(`csrFile`, createCertificateBody.csrFile);
 }

    return axios.post(
      `/service/api/users/${uuid}/certificates`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getCreateCertificateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{uuid: string;params: CreateCertificateParams;data?: CreateCertificateBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{uuid: string;params: CreateCertificateParams;data?: CreateCertificateBody}, TContext> => {

const mutationKey = ['createCertificate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCertificate>>, {uuid: string;params: CreateCertificateParams;data?: CreateCertificateBody}> = (props) => {
          const {uuid,params,data} = props ?? {};

          return  createCertificate(uuid,params,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof createCertificate>>>
    export type CreateCertificateMutationBody = CreateCertificateBody | undefined
    export type CreateCertificateMutationError = AxiosError<unknown>

    /**
 * @summary Create a new certificate for a user, create a new certificate for a user by posting a certificate signing request (CSR) file. The certificate will be signed by the CA. The certificate will be returned in the response.
 */
export const useCreateCertificate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificate>>, TError,{uuid: string;params: CreateCertificateParams;data?: CreateCertificateBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCertificate>>,
        TError,
        {uuid: string;params: CreateCertificateParams;data?: CreateCertificateBody},
        TContext
      > => {
      return useMutation(getCreateCertificateMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary triggers a proficloud password reset
 */
export const triggerPasswordReset = (
    webModelPasswordReset: MaybeRefOrGetter<WebModelPasswordReset>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelPasswordReset = toValue(webModelPasswordReset);

    return axios.post(
      `/service/api/users/reset-password`,
      webModelPasswordReset,options
    );
  }




export const getTriggerPasswordResetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerPasswordReset>>, TError,{data: WebModelPasswordReset}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof triggerPasswordReset>>, TError,{data: WebModelPasswordReset}, TContext> => {

const mutationKey = ['triggerPasswordReset'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerPasswordReset>>, {data: WebModelPasswordReset}> = (props) => {
          const {data} = props ?? {};

          return  triggerPasswordReset(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof triggerPasswordReset>>>
    export type TriggerPasswordResetMutationBody = WebModelPasswordReset
    export type TriggerPasswordResetMutationError = AxiosError<unknown>

    /**
 * @summary triggers a proficloud password reset
 */
export const useTriggerPasswordReset = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerPasswordReset>>, TError,{data: WebModelPasswordReset}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof triggerPasswordReset>>,
        TError,
        {data: WebModelPasswordReset},
        TContext
      > => {
      return useMutation(getTriggerPasswordResetMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary confirms a password reset
 */
export const confirmPasswordReset = (
    webModelPasswordResetConfirm: MaybeRefOrGetter<WebModelPasswordResetConfirm>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelPasswordResetConfirm = toValue(webModelPasswordResetConfirm);

    return axios.post(
      `/service/api/users/reset-password/confirm`,
      webModelPasswordResetConfirm,options
    );
  }




export const getConfirmPasswordResetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,{data: WebModelPasswordResetConfirm}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,{data: WebModelPasswordResetConfirm}, TContext> => {

const mutationKey = ['confirmPasswordReset'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPasswordReset>>, {data: WebModelPasswordResetConfirm}> = (props) => {
          const {data} = props ?? {};

          return  confirmPasswordReset(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPasswordReset>>>
    export type ConfirmPasswordResetMutationBody = WebModelPasswordResetConfirm
    export type ConfirmPasswordResetMutationError = AxiosError<unknown>

    /**
 * @summary confirms a password reset
 */
export const useConfirmPasswordReset = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,{data: WebModelPasswordResetConfirm}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmPasswordReset>>,
        TError,
        {data: WebModelPasswordResetConfirm},
        TContext
      > => {
      return useMutation(getConfirmPasswordResetMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary registers a new user to the proficloud
 */
export const registerUser = (
    webModelCreateUser: MaybeRefOrGetter<WebModelCreateUser>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelCreateUser = toValue(webModelCreateUser);

    return axios.post(
      `/service/api/users/register`,
      webModelCreateUser,options
    );
  }




export const getRegisterUserMutationOptions = <TError = AxiosError<StoreApiError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: WebModelCreateUser}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: WebModelCreateUser}, TContext> => {

const mutationKey = ['registerUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerUser>>, {data: WebModelCreateUser}> = (props) => {
          const {data} = props ?? {};

          return  registerUser(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterUserMutationResult = NonNullable<Awaited<ReturnType<typeof registerUser>>>
    export type RegisterUserMutationBody = WebModelCreateUser
    export type RegisterUserMutationError = AxiosError<StoreApiError | void>

    /**
 * @summary registers a new user to the proficloud
 */
export const useRegisterUser = <TError = AxiosError<StoreApiError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: WebModelCreateUser}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof registerUser>>,
        TError,
        {data: WebModelCreateUser},
        TContext
      > => {
      return useMutation(getRegisterUserMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary confirms a proficloud registration
 */
export const confirmRegister = (
    webModelConfirmUser: MaybeRefOrGetter<WebModelConfirmUser>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelConfirmUser = toValue(webModelConfirmUser);

    return axios.post(
      `/service/api/users/register/confirm`,
      webModelConfirmUser,options
    );
  }




export const getConfirmRegisterMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmRegister>>, TError,{data: WebModelConfirmUser}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmRegister>>, TError,{data: WebModelConfirmUser}, TContext> => {

const mutationKey = ['confirmRegister'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmRegister>>, {data: WebModelConfirmUser}> = (props) => {
          const {data} = props ?? {};

          return  confirmRegister(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof confirmRegister>>>
    export type ConfirmRegisterMutationBody = WebModelConfirmUser
    export type ConfirmRegisterMutationError = AxiosError<unknown>

    /**
 * @summary confirms a proficloud registration
 */
export const useConfirmRegister = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmRegister>>, TError,{data: WebModelConfirmUser}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmRegister>>,
        TError,
        {data: WebModelConfirmUser},
        TContext
      > => {
      return useMutation(getConfirmRegisterMutationOptions(options), queryClient);
    }

/**
 * Security: User requests mfa deactivation by recovery code for its own account
 * @summary Deactivate the mfa login for an account by recovery code
 */
export const resetMfaByRecoveryCode = (
    webModelMfaResetByRecoveryCodeRequest: MaybeRefOrGetter<WebModelMfaResetByRecoveryCodeRequest>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelMfaResetByRecoveryCodeResponse>> => {
    webModelMfaResetByRecoveryCodeRequest = toValue(webModelMfaResetByRecoveryCodeRequest);

    return axios.post(
      `/service/api/users/mfa/reset/recovery-code`,
      webModelMfaResetByRecoveryCodeRequest,options
    );
  }




export const getResetMfaByRecoveryCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMfaByRecoveryCode>>, TError,{data: WebModelMfaResetByRecoveryCodeRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetMfaByRecoveryCode>>, TError,{data: WebModelMfaResetByRecoveryCodeRequest}, TContext> => {

const mutationKey = ['resetMfaByRecoveryCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetMfaByRecoveryCode>>, {data: WebModelMfaResetByRecoveryCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  resetMfaByRecoveryCode(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetMfaByRecoveryCodeMutationResult = NonNullable<Awaited<ReturnType<typeof resetMfaByRecoveryCode>>>
    export type ResetMfaByRecoveryCodeMutationBody = WebModelMfaResetByRecoveryCodeRequest
    export type ResetMfaByRecoveryCodeMutationError = AxiosError<unknown>

    /**
 * @summary Deactivate the mfa login for an account by recovery code
 */
export const useResetMfaByRecoveryCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMfaByRecoveryCode>>, TError,{data: WebModelMfaResetByRecoveryCodeRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetMfaByRecoveryCode>>,
        TError,
        {data: WebModelMfaResetByRecoveryCodeRequest},
        TContext
      > => {
      return useMutation(getResetMfaByRecoveryCodeMutationOptions(options), queryClient);
    }

/**
 * Security: None
 * @summary Returns information about an mfa recovery code
 */
export const getMfaRecoveryCodeInfo = (
    params: MaybeRefOrGetter<GetMfaRecoveryCodeInfoParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelMfaResetRequestCodeInfoResponse>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/users/mfa/reset/recovery-code/confirm`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetMfaRecoveryCodeInfoQueryKey = (params?: MaybeRefOrGetter<GetMfaRecoveryCodeInfoParams>,) => {
    return [
    'service','api','users','mfa','reset','recovery-code','confirm', ...(params ? [params] : [])
    ] as const;
    }


export const getGetMfaRecoveryCodeInfoQueryOptions = <TData = Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetMfaRecoveryCodeInfoParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetMfaRecoveryCodeInfoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>> = ({ signal }) => getMfaRecoveryCodeInfo(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>, TError, TData>
}

export type GetMfaRecoveryCodeInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>>
export type GetMfaRecoveryCodeInfoQueryError = AxiosError<unknown>


/**
 * @summary Returns information about an mfa recovery code
 */

export function useGetMfaRecoveryCodeInfo<TData = Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetMfaRecoveryCodeInfoParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaRecoveryCodeInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMfaRecoveryCodeInfoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: None
 * @summary Send an mfa recovery code by e-mail to the user
 */
export const issueMfaRecoveryCode = (
    params: MaybeRefOrGetter<IssueMfaRecoveryCodeParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.post(
      `/service/api/users/mfa/reset/recovery-code/confirm`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getIssueMfaRecoveryCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueMfaRecoveryCode>>, TError,{params: IssueMfaRecoveryCodeParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof issueMfaRecoveryCode>>, TError,{params: IssueMfaRecoveryCodeParams}, TContext> => {

const mutationKey = ['issueMfaRecoveryCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof issueMfaRecoveryCode>>, {params: IssueMfaRecoveryCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  issueMfaRecoveryCode(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IssueMfaRecoveryCodeMutationResult = NonNullable<Awaited<ReturnType<typeof issueMfaRecoveryCode>>>

    export type IssueMfaRecoveryCodeMutationError = AxiosError<unknown>

    /**
 * @summary Send an mfa recovery code by e-mail to the user
 */
export const useIssueMfaRecoveryCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueMfaRecoveryCode>>, TError,{params: IssueMfaRecoveryCodeParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof issueMfaRecoveryCode>>,
        TError,
        {params: IssueMfaRecoveryCodeParams},
        TContext
      > => {
      return useMutation(getIssueMfaRecoveryCodeMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User requests mfa deactivation for its own account
 * @summary Deactivate the mfa login for an account
 */
export const deactivateMfa = (
    webModelMfaDeactivationRequest: MaybeRefOrGetter<WebModelMfaDeactivationRequest>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelMfaDeactivationResponse>> => {
    webModelMfaDeactivationRequest = toValue(webModelMfaDeactivationRequest);

    return axios.post(
      `/service/api/users/mfa/deactivate`,
      webModelMfaDeactivationRequest,options
    );
  }




export const getDeactivateMfaMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateMfa>>, TError,{data: WebModelMfaDeactivationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateMfa>>, TError,{data: WebModelMfaDeactivationRequest}, TContext> => {

const mutationKey = ['deactivateMfa'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateMfa>>, {data: WebModelMfaDeactivationRequest}> = (props) => {
          const {data} = props ?? {};

          return  deactivateMfa(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateMfaMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateMfa>>>
    export type DeactivateMfaMutationBody = WebModelMfaDeactivationRequest
    export type DeactivateMfaMutationError = AxiosError<unknown>

    /**
 * @summary Deactivate the mfa login for an account
 */
export const useDeactivateMfa = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateMfa>>, TError,{data: WebModelMfaDeactivationRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivateMfa>>,
        TError,
        {data: WebModelMfaDeactivationRequest},
        TContext
      > => {
      return useMutation(getDeactivateMfaMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User requests mfa confirmation for its own account
 * @summary Confirms the mfa login for an account
 */
export const confirmMfa = (
    webModelMfaConfirmRequest: MaybeRefOrGetter<WebModelMfaConfirmRequest>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelMfaConfirmResponse>> => {
    webModelMfaConfirmRequest = toValue(webModelMfaConfirmRequest);

    return axios.post(
      `/service/api/users/mfa/confirm`,
      webModelMfaConfirmRequest,options
    );
  }




export const getConfirmMfaMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmMfa>>, TError,{data: WebModelMfaConfirmRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmMfa>>, TError,{data: WebModelMfaConfirmRequest}, TContext> => {

const mutationKey = ['confirmMfa'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmMfa>>, {data: WebModelMfaConfirmRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmMfa(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmMfaMutationResult = NonNullable<Awaited<ReturnType<typeof confirmMfa>>>
    export type ConfirmMfaMutationBody = WebModelMfaConfirmRequest
    export type ConfirmMfaMutationError = AxiosError<unknown>

    /**
 * @summary Confirms the mfa login for an account
 */
export const useConfirmMfa = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmMfa>>, TError,{data: WebModelMfaConfirmRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmMfa>>,
        TError,
        {data: WebModelMfaConfirmRequest},
        TContext
      > => {
      return useMutation(getConfirmMfaMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is store admin
 * @summary Trigger an mfa recovery code reset by sending an e-mail to the user
 */
export const triggerMfaRecoveryCodeReset = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    uuid = toValue(uuid);

    return axios.post(
      `/service/api/users/mfa/admin/reset/recovery-code/${uuid}`,
      undefined,options
    );
  }




export const getTriggerMfaRecoveryCodeResetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerMfaRecoveryCodeReset>>, TError,{uuid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof triggerMfaRecoveryCodeReset>>, TError,{uuid: string}, TContext> => {

const mutationKey = ['triggerMfaRecoveryCodeReset'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerMfaRecoveryCodeReset>>, {uuid: string}> = (props) => {
          const {uuid} = props ?? {};

          return  triggerMfaRecoveryCodeReset(uuid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerMfaRecoveryCodeResetMutationResult = NonNullable<Awaited<ReturnType<typeof triggerMfaRecoveryCodeReset>>>

    export type TriggerMfaRecoveryCodeResetMutationError = AxiosError<unknown>

    /**
 * @summary Trigger an mfa recovery code reset by sending an e-mail to the user
 */
export const useTriggerMfaRecoveryCodeReset = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerMfaRecoveryCodeReset>>, TError,{uuid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof triggerMfaRecoveryCodeReset>>,
        TError,
        {uuid: string},
        TContext
      > => {
      return useMutation(getTriggerMfaRecoveryCodeResetMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User requests mfa activation for its own account
 * @summary Activate the mfa login for an account
 */
export const activateMfa = (
    webModelMfaActivationRequest: MaybeRefOrGetter<WebModelMfaActivationRequest>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelMfaActivationResponse>> => {
    webModelMfaActivationRequest = toValue(webModelMfaActivationRequest);

    return axios.post(
      `/service/api/users/mfa/activate`,
      webModelMfaActivationRequest,options
    );
  }




export const getActivateMfaMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateMfa>>, TError,{data: WebModelMfaActivationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof activateMfa>>, TError,{data: WebModelMfaActivationRequest}, TContext> => {

const mutationKey = ['activateMfa'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateMfa>>, {data: WebModelMfaActivationRequest}> = (props) => {
          const {data} = props ?? {};

          return  activateMfa(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateMfaMutationResult = NonNullable<Awaited<ReturnType<typeof activateMfa>>>
    export type ActivateMfaMutationBody = WebModelMfaActivationRequest
    export type ActivateMfaMutationError = AxiosError<unknown>

    /**
 * @summary Activate the mfa login for an account
 */
export const useActivateMfa = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateMfa>>, TError,{data: WebModelMfaActivationRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateMfa>>,
        TError,
        {data: WebModelMfaActivationRequest},
        TContext
      > => {
      return useMutation(getActivateMfaMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated
 * @summary Saves in database that the user wants to become developer
 */
export const createDeveloperRequest = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.post(
      `/service/api/users/developer-request`,
      undefined,options
    );
  }




export const getCreateDeveloperRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeveloperRequest>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createDeveloperRequest>>, TError,void, TContext> => {

const mutationKey = ['createDeveloperRequest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDeveloperRequest>>, void> = () => {


          return  createDeveloperRequest(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDeveloperRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createDeveloperRequest>>>

    export type CreateDeveloperRequestMutationError = AxiosError<unknown>

    /**
 * @summary Saves in database that the user wants to become developer
 */
export const useCreateDeveloperRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeveloperRequest>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDeveloperRequest>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateDeveloperRequestMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated
 * @summary The user does not want to become developer anymore - cancel request
 */
export const cancelDeveloperRequest = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.delete(
      `/service/api/users/developer-request`,options
    );
  }




export const getCancelDeveloperRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDeveloperRequest>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof cancelDeveloperRequest>>, TError,void, TContext> => {

const mutationKey = ['cancelDeveloperRequest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelDeveloperRequest>>, void> = () => {


          return  cancelDeveloperRequest(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelDeveloperRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDeveloperRequest>>>

    export type CancelDeveloperRequestMutationError = AxiosError<unknown>

    /**
 * @summary The user does not want to become developer anymore - cancel request
 */
export const useCancelDeveloperRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDeveloperRequest>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelDeveloperRequest>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCancelDeveloperRequestMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is store admin.
 * @summary Add admin role to user
 */
export const addRole = (
    params: MaybeRefOrGetter<AddRoleParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.post(
      `/service/api/user-principals/admin-role`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getAddRoleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError,{params: AddRoleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError,{params: AddRoleParams}, TContext> => {

const mutationKey = ['addRole'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addRole>>, {params: AddRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  addRole(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddRoleMutationResult = NonNullable<Awaited<ReturnType<typeof addRole>>>

    export type AddRoleMutationError = AxiosError<unknown>

    /**
 * @summary Add admin role to user
 */
export const useAddRole = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError,{params: AddRoleParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addRole>>,
        TError,
        {params: AddRoleParams},
        TContext
      > => {
      return useMutation(getAddRoleMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is store admin.
 * @summary Remove admin role from user
 */
export const removeRole = (
    params: MaybeRefOrGetter<RemoveRoleParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.delete(
      `/service/api/user-principals/admin-role`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getRemoveRoleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeRole>>, TError,{params: RemoveRoleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeRole>>, TError,{params: RemoveRoleParams}, TContext> => {

const mutationKey = ['removeRole'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeRole>>, {params: RemoveRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  removeRole(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveRoleMutationResult = NonNullable<Awaited<ReturnType<typeof removeRole>>>

    export type RemoveRoleMutationError = AxiosError<unknown>

    /**
 * @summary Remove admin role from user
 */
export const useRemoveRole = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeRole>>, TError,{params: RemoveRoleParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeRole>>,
        TError,
        {params: RemoveRoleParams},
        TContext
      > => {
      return useMutation(getRemoveRoleMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is the owner of the order.
 * @summary Register for payment (response provides fields 'paymentRedirectUrl' and 'requestId')
 */
export const registerPayment = (
    paymentRegisterRequest: MaybeRefOrGetter<PaymentRegisterRequest>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RegisterPayment200>> => {
    paymentRegisterRequest = toValue(paymentRegisterRequest);

    return axios.post(
      `/service/api/payments/register`,
      paymentRegisterRequest,options
    );
  }




export const getRegisterPaymentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPayment>>, TError,{data: PaymentRegisterRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof registerPayment>>, TError,{data: PaymentRegisterRequest}, TContext> => {

const mutationKey = ['registerPayment'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerPayment>>, {data: PaymentRegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  registerPayment(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof registerPayment>>>
    export type RegisterPaymentMutationBody = PaymentRegisterRequest
    export type RegisterPaymentMutationError = AxiosError<unknown>

    /**
 * @summary Register for payment (response provides fields 'paymentRedirectUrl' and 'requestId')
 */
export const useRegisterPayment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPayment>>, TError,{data: PaymentRegisterRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof registerPayment>>,
        TError,
        {data: PaymentRegisterRequest},
        TContext
      > => {
      return useMutation(getRegisterPaymentMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and belongs to the company.
 * @summary Get payment account related to a company
 */
export const findPaymentAccountsByCompany = (
    params: MaybeRefOrGetter<FindPaymentAccountsByCompanyParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelPaymentAccount[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/payments/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindPaymentAccountsByCompanyQueryKey = (params?: MaybeRefOrGetter<FindPaymentAccountsByCompanyParams>,) => {
    return [
    'service','api','payments','accounts', ...(params ? [params] : [])
    ] as const;
    }


export const getFindPaymentAccountsByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof findPaymentAccountsByCompany>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindPaymentAccountsByCompanyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPaymentAccountsByCompany>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindPaymentAccountsByCompanyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPaymentAccountsByCompany>>> = ({ signal }) => findPaymentAccountsByCompany(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPaymentAccountsByCompany>>, TError, TData>
}

export type FindPaymentAccountsByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof findPaymentAccountsByCompany>>>
export type FindPaymentAccountsByCompanyQueryError = AxiosError<unknown>


/**
 * @summary Get payment account related to a company
 */

export function useFindPaymentAccountsByCompany<TData = Awaited<ReturnType<typeof findPaymentAccountsByCompany>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindPaymentAccountsByCompanyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPaymentAccountsByCompany>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPaymentAccountsByCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a company admin of this approved contributor company.
 * @summary Create payment account related to a company
 */
export const createPaymentAccount = (
    params: MaybeRefOrGetter<CreatePaymentAccountParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelPaymentAccount>> => {
    params = toValue(params);

    return axios.post(
      `/service/api/payments/accounts`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getCreatePaymentAccountMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentAccount>>, TError,{params: CreatePaymentAccountParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentAccount>>, TError,{params: CreatePaymentAccountParams}, TContext> => {

const mutationKey = ['createPaymentAccount'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentAccount>>, {params: CreatePaymentAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  createPaymentAccount(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentAccount>>>

    export type CreatePaymentAccountMutationError = AxiosError<unknown>

    /**
 * @summary Create payment account related to a company
 */
export const useCreatePaymentAccount = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentAccount>>, TError,{params: CreatePaymentAccountParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPaymentAccount>>,
        TError,
        {params: CreatePaymentAccountParams},
        TContext
      > => {
      return useMutation(getCreatePaymentAccountMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and admin of the company.
 * @summary Refresh payment account data for a stripe payment account
 */
export const refreshPaymentAccountData = (
    companyid: MaybeRefOrGetter<string>,
    hubid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelPaymentAccount>> => {
    companyid = toValue(companyid);
hubid = toValue(hubid);

    return axios.post(
      `/service/api/payments/accounts/companys/${companyid}/hubs/${hubid}/refresh`,
      undefined,options
    );
  }




export const getRefreshPaymentAccountDataMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPaymentAccountData>>, TError,{companyid: string;hubid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof refreshPaymentAccountData>>, TError,{companyid: string;hubid: string}, TContext> => {

const mutationKey = ['refreshPaymentAccountData'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshPaymentAccountData>>, {companyid: string;hubid: string}> = (props) => {
          const {companyid,hubid} = props ?? {};

          return  refreshPaymentAccountData(companyid,hubid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshPaymentAccountDataMutationResult = NonNullable<Awaited<ReturnType<typeof refreshPaymentAccountData>>>

    export type RefreshPaymentAccountDataMutationError = AxiosError<unknown>

    /**
 * @summary Refresh payment account data for a stripe payment account
 */
export const useRefreshPaymentAccountData = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPaymentAccountData>>, TError,{companyid: string;hubid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof refreshPaymentAccountData>>,
        TError,
        {companyid: string;hubid: string},
        TContext
      > => {
      return useMutation(getRefreshPaymentAccountDataMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and admin of the company.
 * @summary Create payment account link for a stripe payment account
 */
export const createPaymentAccountLink = (
    companyid: MaybeRefOrGetter<string>,
    hubid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    companyid = toValue(companyid);
hubid = toValue(hubid);

    return axios.post(
      `/service/api/payments/accounts/companys/${companyid}/hubs/${hubid}/link`,
      undefined,{
    ...options,}
    );
  }




export const getCreatePaymentAccountLinkMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentAccountLink>>, TError,{companyid: string;hubid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentAccountLink>>, TError,{companyid: string;hubid: string}, TContext> => {

const mutationKey = ['createPaymentAccountLink'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentAccountLink>>, {companyid: string;hubid: string}> = (props) => {
          const {companyid,hubid} = props ?? {};

          return  createPaymentAccountLink(companyid,hubid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentAccountLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentAccountLink>>>

    export type CreatePaymentAccountLinkMutationError = AxiosError<unknown>

    /**
 * @summary Create payment account link for a stripe payment account
 */
export const useCreatePaymentAccountLink = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentAccountLink>>, TError,{companyid: string;hubid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPaymentAccountLink>>,
        TError,
        {companyid: string;hubid: string},
        TContext
      > => {
      return useMutation(getCreatePaymentAccountLinkMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated
 * @summary Create an order
 */
export const createOrder = (
    webModelCreateOrder: MaybeRefOrGetter<WebModelCreateOrder>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetOrder>> => {
    webModelCreateOrder = toValue(webModelCreateOrder);

    return axios.post(
      `/service/api/orders/create`,
      webModelCreateOrder,options
    );
  }




export const getCreateOrderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: WebModelCreateOrder}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: WebModelCreateOrder}, TContext> => {

const mutationKey = ['createOrder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrder>>, {data: WebModelCreateOrder}> = (props) => {
          const {data} = props ?? {};

          return  createOrder(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createOrder>>>
    export type CreateOrderMutationBody = WebModelCreateOrder
    export type CreateOrderMutationError = AxiosError<unknown>

    /**
 * @summary Create an order
 */
export const useCreateOrder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: WebModelCreateOrder}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createOrder>>,
        TError,
        {data: WebModelCreateOrder},
        TContext
      > => {
      return useMutation(getCreateOrderMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is a store admin
 * @summary send an email to all users
 */
export const sendEmailToAllUsers = (
    webModelPostEmailToAllUsers: MaybeRefOrGetter<WebModelPostEmailToAllUsers>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelPostEmailToAllUsers = toValue(webModelPostEmailToAllUsers);

    return axios.post(
      `/service/api/messages/users`,
      webModelPostEmailToAllUsers,options
    );
  }




export const getSendEmailToAllUsersMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToAllUsers>>, TError,{data: WebModelPostEmailToAllUsers}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailToAllUsers>>, TError,{data: WebModelPostEmailToAllUsers}, TContext> => {

const mutationKey = ['sendEmailToAllUsers'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailToAllUsers>>, {data: WebModelPostEmailToAllUsers}> = (props) => {
          const {data} = props ?? {};

          return  sendEmailToAllUsers(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailToAllUsersMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailToAllUsers>>>
    export type SendEmailToAllUsersMutationBody = WebModelPostEmailToAllUsers
    export type SendEmailToAllUsersMutationError = AxiosError<unknown>

    /**
 * @summary send an email to all users
 */
export const useSendEmailToAllUsers = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToAllUsers>>, TError,{data: WebModelPostEmailToAllUsers}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendEmailToAllUsers>>,
        TError,
        {data: WebModelPostEmailToAllUsers},
        TContext
      > => {
      return useMutation(getSendEmailToAllUsersMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Send a support message
 */
export const sendSupportMessage = (
    sendSupportMessageBody?: MaybeRefOrGetter<SendSupportMessageBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    sendSupportMessageBody = toValue(sendSupportMessageBody);
    const formData = new FormData();
if(sendSupportMessageBody?.json !== undefined) {
 formData.append(`json`, JSON.stringify(sendSupportMessageBody.json));
 }
if(sendSupportMessageBody?.files !== undefined) {
 sendSupportMessageBody?.files.forEach(value => formData.append(`files`, value));
 }

    return axios.post(
      `/service/api/messages/support`,
      formData,options
    );
  }




export const getSendSupportMessageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSupportMessage>>, TError,{data?: SendSupportMessageBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendSupportMessage>>, TError,{data?: SendSupportMessageBody}, TContext> => {

const mutationKey = ['sendSupportMessage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSupportMessage>>, {data?: SendSupportMessageBody}> = (props) => {
          const {data} = props ?? {};

          return  sendSupportMessage(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendSupportMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendSupportMessage>>>
    export type SendSupportMessageMutationBody = SendSupportMessageBody | undefined
    export type SendSupportMessageMutationError = AxiosError<unknown>

    /**
 * @summary Send a support message
 */
export const useSendSupportMessage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSupportMessage>>, TError,{data?: SendSupportMessageBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendSupportMessage>>,
        TError,
        {data?: SendSupportMessageBody},
        TContext
      > => {
      return useMutation(getSendSupportMessageMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Report illegal content
 */
export const sendReportForIllegalContent = (
    webModelPostIllegalContentReport: MaybeRefOrGetter<WebModelPostIllegalContentReport>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelPostIllegalContentReport = toValue(webModelPostIllegalContentReport);

    return axios.post(
      `/service/api/messages/report`,
      webModelPostIllegalContentReport,options
    );
  }




export const getSendReportForIllegalContentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReportForIllegalContent>>, TError,{data: WebModelPostIllegalContentReport}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendReportForIllegalContent>>, TError,{data: WebModelPostIllegalContentReport}, TContext> => {

const mutationKey = ['sendReportForIllegalContent'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReportForIllegalContent>>, {data: WebModelPostIllegalContentReport}> = (props) => {
          const {data} = props ?? {};

          return  sendReportForIllegalContent(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendReportForIllegalContentMutationResult = NonNullable<Awaited<ReturnType<typeof sendReportForIllegalContent>>>
    export type SendReportForIllegalContentMutationBody = WebModelPostIllegalContentReport
    export type SendReportForIllegalContentMutationError = AxiosError<unknown>

    /**
 * @summary Report illegal content
 */
export const useSendReportForIllegalContent = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReportForIllegalContent>>, TError,{data: WebModelPostIllegalContentReport}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendReportForIllegalContent>>,
        TError,
        {data: WebModelPostIllegalContentReport},
        TContext
      > => {
      return useMutation(getSendReportForIllegalContentMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated
 * @summary send a message to a company
 */
export const sendEmailToCompany = (
    id: MaybeRefOrGetter<string>,
    webModelPostMessage: MaybeRefOrGetter<WebModelPostMessage>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
webModelPostMessage = toValue(webModelPostMessage);

    return axios.post(
      `/service/api/messages/companys/${id}`,
      webModelPostMessage,options
    );
  }




export const getSendEmailToCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToCompany>>, TError,{id: string;data: WebModelPostMessage}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailToCompany>>, TError,{id: string;data: WebModelPostMessage}, TContext> => {

const mutationKey = ['sendEmailToCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailToCompany>>, {id: string;data: WebModelPostMessage}> = (props) => {
          const {id,data} = props ?? {};

          return  sendEmailToCompany(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailToCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailToCompany>>>
    export type SendEmailToCompanyMutationBody = WebModelPostMessage
    export type SendEmailToCompanyMutationError = AxiosError<unknown>

    /**
 * @summary send a message to a company
 */
export const useSendEmailToCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToCompany>>, TError,{id: string;data: WebModelPostMessage}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendEmailToCompany>>,
        TError,
        {id: string;data: WebModelPostMessage},
        TContext
      > => {
      return useMutation(getSendEmailToCompanyMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated
 * @summary send a message to an app
 */
export const sendEmailToApp = (
    id: MaybeRefOrGetter<number>,
    webModelPostMessage: MaybeRefOrGetter<WebModelPostMessage>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
webModelPostMessage = toValue(webModelPostMessage);

    return axios.post(
      `/service/api/messages/apps/${id}`,
      webModelPostMessage,options
    );
  }




export const getSendEmailToAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToApp>>, TError,{id: number;data: WebModelPostMessage}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailToApp>>, TError,{id: number;data: WebModelPostMessage}, TContext> => {

const mutationKey = ['sendEmailToApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailToApp>>, {id: number;data: WebModelPostMessage}> = (props) => {
          const {id,data} = props ?? {};

          return  sendEmailToApp(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailToAppMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailToApp>>>
    export type SendEmailToAppMutationBody = WebModelPostMessage
    export type SendEmailToAppMutationError = AxiosError<unknown>

    /**
 * @summary send a message to an app
 */
export const useSendEmailToApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToApp>>, TError,{id: number;data: WebModelPostMessage}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendEmailToApp>>,
        TError,
        {id: number;data: WebModelPostMessage},
        TContext
      > => {
      return useMutation(getSendEmailToAppMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated
 * @summary report an harmful app
 */
export const sendReportForHarmfulApp = (
    id: MaybeRefOrGetter<number>,
    webModelPostReportApp: MaybeRefOrGetter<WebModelPostReportApp>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
webModelPostReportApp = toValue(webModelPostReportApp);

    return axios.post(
      `/service/api/messages/apps/${id}/report`,
      webModelPostReportApp,options
    );
  }




export const getSendReportForHarmfulAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReportForHarmfulApp>>, TError,{id: number;data: WebModelPostReportApp}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendReportForHarmfulApp>>, TError,{id: number;data: WebModelPostReportApp}, TContext> => {

const mutationKey = ['sendReportForHarmfulApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReportForHarmfulApp>>, {id: number;data: WebModelPostReportApp}> = (props) => {
          const {id,data} = props ?? {};

          return  sendReportForHarmfulApp(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendReportForHarmfulAppMutationResult = NonNullable<Awaited<ReturnType<typeof sendReportForHarmfulApp>>>
    export type SendReportForHarmfulAppMutationBody = WebModelPostReportApp
    export type SendReportForHarmfulAppMutationError = AxiosError<unknown>

    /**
 * @summary report an harmful app
 */
export const useSendReportForHarmfulApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReportForHarmfulApp>>, TError,{id: number;data: WebModelPostReportApp}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendReportForHarmfulApp>>,
        TError,
        {id: number;data: WebModelPostReportApp},
        TContext
      > => {
      return useMutation(getSendReportForHarmfulAppMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Login for a user
 */
export const login = (
    webModelUserLogin: MaybeRefOrGetter<WebModelUserLogin>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelUserLogin = toValue(webModelUserLogin);

    return axios.post(
      `/service/api/login`,
      webModelUserLogin,options
    );
  }




export const getLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: WebModelUserLogin}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: WebModelUserLogin}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: WebModelUserLogin}> = (props) => {
          const {data} = props ?? {};

          return  login(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = WebModelUserLogin
    export type LoginMutationError = AxiosError<unknown>

    /**
 * @summary Login for a user
 */
export const useLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: WebModelUserLogin}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: WebModelUserLogin},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Log a frontend error
 */
export const logJavascriptError = (
    webModelCreateReportJSError: MaybeRefOrGetter<WebModelCreateReportJSError>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelCreateReportJSError = toValue(webModelCreateReportJSError);

    return axios.post(
      `/service/api/js-error-report`,
      webModelCreateReportJSError,options
    );
  }




export const getLogJavascriptErrorMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logJavascriptError>>, TError,{data: WebModelCreateReportJSError}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof logJavascriptError>>, TError,{data: WebModelCreateReportJSError}, TContext> => {

const mutationKey = ['logJavascriptError'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logJavascriptError>>, {data: WebModelCreateReportJSError}> = (props) => {
          const {data} = props ?? {};

          return  logJavascriptError(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogJavascriptErrorMutationResult = NonNullable<Awaited<ReturnType<typeof logJavascriptError>>>
    export type LogJavascriptErrorMutationBody = WebModelCreateReportJSError
    export type LogJavascriptErrorMutationError = AxiosError<unknown>

    /**
 * @summary Log a frontend error
 */
export const useLogJavascriptError = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logJavascriptError>>, TError,{data: WebModelCreateReportJSError}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof logJavascriptError>>,
        TError,
        {data: WebModelCreateReportJSError},
        TContext
      > => {
      return useMutation(getLogJavascriptErrorMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. The user is company admin of the company to be added.
 * @summary Add / Enable a company in a given hub
 */
export const addContributingCompanyToHub = (
    hubid: MaybeRefOrGetter<string>,
    companyid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    hubid = toValue(hubid);
companyid = toValue(companyid);

    return axios.post(
      `/service/api/hubs/${hubid}/companys/${companyid}`,
      undefined,options
    );
  }




export const getAddContributingCompanyToHubMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addContributingCompanyToHub>>, TError,{hubid: string;companyid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addContributingCompanyToHub>>, TError,{hubid: string;companyid: string}, TContext> => {

const mutationKey = ['addContributingCompanyToHub'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addContributingCompanyToHub>>, {hubid: string;companyid: string}> = (props) => {
          const {hubid,companyid} = props ?? {};

          return  addContributingCompanyToHub(hubid,companyid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddContributingCompanyToHubMutationResult = NonNullable<Awaited<ReturnType<typeof addContributingCompanyToHub>>>

    export type AddContributingCompanyToHubMutationError = AxiosError<unknown>

    /**
 * @summary Add / Enable a company in a given hub
 */
export const useAddContributingCompanyToHub = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addContributingCompanyToHub>>, TError,{hubid: string;companyid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addContributingCompanyToHub>>,
        TError,
        {hubid: string;companyid: string},
        TContext
      > => {
      return useMutation(getAddContributingCompanyToHubMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Search all major minor firmware versions
 */
export const findAllMajorMinorVersions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetMajorMinorFirmwareVersion[]>> => {


    return axios.get(
      `/service/api/firmware/major-minor`,options
    );
  }




export const getFindAllMajorMinorVersionsQueryKey = () => {
    return [
    'service','api','firmware','major-minor'
    ] as const;
    }


export const getFindAllMajorMinorVersionsQueryOptions = <TData = Awaited<ReturnType<typeof findAllMajorMinorVersions>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllMajorMinorVersions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAllMajorMinorVersionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllMajorMinorVersions>>> = ({ signal }) => findAllMajorMinorVersions({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllMajorMinorVersions>>, TError, TData>
}

export type FindAllMajorMinorVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllMajorMinorVersions>>>
export type FindAllMajorMinorVersionsQueryError = AxiosError<unknown>


/**
 * @summary Search all major minor firmware versions
 */

export function useFindAllMajorMinorVersions<TData = Awaited<ReturnType<typeof findAllMajorMinorVersions>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllMajorMinorVersions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllMajorMinorVersionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be a store admin.
 * @summary Create a new major.minor firmware version as a store admin
 */
export const createMajorMinorVersion = (
    webModelPostMajorMinorFirmwareVersion: MaybeRefOrGetter<WebModelPostMajorMinorFirmwareVersion>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetMajorMinorFirmwareVersion>> => {
    webModelPostMajorMinorFirmwareVersion = toValue(webModelPostMajorMinorFirmwareVersion);

    return axios.post(
      `/service/api/firmware/major-minor`,
      webModelPostMajorMinorFirmwareVersion,options
    );
  }




export const getCreateMajorMinorVersionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMajorMinorVersion>>, TError,{data: WebModelPostMajorMinorFirmwareVersion}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createMajorMinorVersion>>, TError,{data: WebModelPostMajorMinorFirmwareVersion}, TContext> => {

const mutationKey = ['createMajorMinorVersion'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMajorMinorVersion>>, {data: WebModelPostMajorMinorFirmwareVersion}> = (props) => {
          const {data} = props ?? {};

          return  createMajorMinorVersion(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMajorMinorVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createMajorMinorVersion>>>
    export type CreateMajorMinorVersionMutationBody = WebModelPostMajorMinorFirmwareVersion
    export type CreateMajorMinorVersionMutationError = AxiosError<unknown>

    /**
 * @summary Create a new major.minor firmware version as a store admin
 */
export const useCreateMajorMinorVersion = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMajorMinorVersion>>, TError,{data: WebModelPostMajorMinorFirmwareVersion}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMajorMinorVersion>>,
        TError,
        {data: WebModelPostMajorMinorFirmwareVersion},
        TContext
      > => {
      return useMutation(getCreateMajorMinorVersionMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. Device is public and in the same company as the user.
 * @summary Make device private (set the private flag)
 */
export const makeDevicePrivate = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDevice>> => {
    id = toValue(id);

    return axios.post(
      `/service/api/devices/${id}/private`,
      undefined,options
    );
  }




export const getMakeDevicePrivateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeDevicePrivate>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof makeDevicePrivate>>, TError,{id: string}, TContext> => {

const mutationKey = ['makeDevicePrivate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeDevicePrivate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  makeDevicePrivate(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MakeDevicePrivateMutationResult = NonNullable<Awaited<ReturnType<typeof makeDevicePrivate>>>

    export type MakeDevicePrivateMutationError = AxiosError<unknown>

    /**
 * @summary Make device private (set the private flag)
 */
export const useMakeDevicePrivate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeDevicePrivate>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof makeDevicePrivate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMakeDevicePrivateMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner or a company admin of the same company.
 * @summary Make device public (delete the private flag)
 */
export const makeDevicePublic = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDevice>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/devices/${id}/private`,options
    );
  }




export const getMakeDevicePublicMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeDevicePublic>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof makeDevicePublic>>, TError,{id: string}, TContext> => {

const mutationKey = ['makeDevicePublic'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeDevicePublic>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  makeDevicePublic(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MakeDevicePublicMutationResult = NonNullable<Awaited<ReturnType<typeof makeDevicePublic>>>

    export type MakeDevicePublicMutationError = AxiosError<unknown>

    /**
 * @summary Make device public (delete the private flag)
 */
export const useMakeDevicePublic = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeDevicePublic>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof makeDevicePublic>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMakeDevicePublicMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and owner of the device.
 * @summary Upload a Rac-File for license activation
 */
export const uploadStoreFileToSetContainerId = (
    id: MaybeRefOrGetter<string>,
    uploadStoreFileToSetContainerIdBody?: MaybeRefOrGetter<UploadStoreFileToSetContainerIdBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
uploadStoreFileToSetContainerIdBody = toValue(uploadStoreFileToSetContainerIdBody);
    const formData = new FormData();
if(uploadStoreFileToSetContainerIdBody?.racFile !== undefined) {
 formData.append(`racFile`, uploadStoreFileToSetContainerIdBody.racFile);
 }

    return axios.post(
      `/service/api/devices/${id}/licenses/container`,
      formData,options
    );
  }




export const getUploadStoreFileToSetContainerIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadStoreFileToSetContainerId>>, TError,{id: string;data?: UploadStoreFileToSetContainerIdBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadStoreFileToSetContainerId>>, TError,{id: string;data?: UploadStoreFileToSetContainerIdBody}, TContext> => {

const mutationKey = ['uploadStoreFileToSetContainerId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadStoreFileToSetContainerId>>, {id: string;data?: UploadStoreFileToSetContainerIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  uploadStoreFileToSetContainerId(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadStoreFileToSetContainerIdMutationResult = NonNullable<Awaited<ReturnType<typeof uploadStoreFileToSetContainerId>>>
    export type UploadStoreFileToSetContainerIdMutationBody = UploadStoreFileToSetContainerIdBody | undefined
    export type UploadStoreFileToSetContainerIdMutationError = AxiosError<unknown>

    /**
 * @summary Upload a Rac-File for license activation
 */
export const useUploadStoreFileToSetContainerId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadStoreFileToSetContainerId>>, TError,{id: string;data?: UploadStoreFileToSetContainerIdBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadStoreFileToSetContainerId>>,
        TError,
        {id: string;data?: UploadStoreFileToSetContainerIdBody},
        TContext
      > => {
      return useMutation(getUploadStoreFileToSetContainerIdMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner.
 * @summary Activate / Start an app
 */
export const activateApp = (
    id: MaybeRefOrGetter<string>,
    installedAppId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
installedAppId = toValue(installedAppId);

    return axios.post(
      `/service/api/devices/${id}/installed-app/${installedAppId}/start-stop`,
      undefined,options
    );
  }




export const getActivateAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateApp>>, TError,{id: string;installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof activateApp>>, TError,{id: string;installedAppId: number}, TContext> => {

const mutationKey = ['activateApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateApp>>, {id: string;installedAppId: number}> = (props) => {
          const {id,installedAppId} = props ?? {};

          return  activateApp(id,installedAppId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateAppMutationResult = NonNullable<Awaited<ReturnType<typeof activateApp>>>

    export type ActivateAppMutationError = AxiosError<unknown>

    /**
 * @summary Activate / Start an app
 */
export const useActivateApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateApp>>, TError,{id: string;installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateApp>>,
        TError,
        {id: string;installedAppId: number},
        TContext
      > => {
      return useMutation(getActivateAppMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner.
 * @summary Deactivate / Stop an app
 */
export const deactivateApp = (
    id: MaybeRefOrGetter<string>,
    installedAppId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
installedAppId = toValue(installedAppId);

    return axios.delete(
      `/service/api/devices/${id}/installed-app/${installedAppId}/start-stop`,options
    );
  }




export const getDeactivateAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateApp>>, TError,{id: string;installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateApp>>, TError,{id: string;installedAppId: number}, TContext> => {

const mutationKey = ['deactivateApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateApp>>, {id: string;installedAppId: number}> = (props) => {
          const {id,installedAppId} = props ?? {};

          return  deactivateApp(id,installedAppId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateAppMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateApp>>>

    export type DeactivateAppMutationError = AxiosError<unknown>

    /**
 * @summary Deactivate / Stop an app
 */
export const useDeactivateApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateApp>>, TError,{id: string;installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivateApp>>,
        TError,
        {id: string;installedAppId: number},
        TContext
      > => {
      return useMutation(getDeactivateAppMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User can only access its own user-uuid path. User has to be the device owner.
 * @summary Get a detailed device information by id
 */
export const getDeviceStatus = (
    params: MaybeRefOrGetter<GetDeviceStatusParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeviceDetails>> => {
    params = toValue(params);

    return axios.post(
      `/service/api/devices/online-status`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDeviceStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDeviceStatus>>, TError,{params: GetDeviceStatusParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getDeviceStatus>>, TError,{params: GetDeviceStatusParams}, TContext> => {

const mutationKey = ['getDeviceStatus'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDeviceStatus>>, {params: GetDeviceStatusParams}> = (props) => {
          const {params} = props ?? {};

          return  getDeviceStatus(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDeviceStatusMutationResult = NonNullable<Awaited<ReturnType<typeof getDeviceStatus>>>

    export type GetDeviceStatusMutationError = AxiosError<unknown>

    /**
 * @summary Get a detailed device information by id
 */
export const useGetDeviceStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDeviceStatus>>, TError,{params: GetDeviceStatusParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof getDeviceStatus>>,
        TError,
        {params: GetDeviceStatusParams},
        TContext
      > => {
      return useMutation(getGetDeviceStatusMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Handle a Content Security Policy report
 */
export const handleReport = (
    handleReportBody: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    handleReportBody = toValue(handleReportBody);

    return axios.post(
      `/service/api/csp-report`,
      handleReportBody,{
    ...options,}
    );
  }




export const getHandleReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleReport>>, TError,{data: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof handleReport>>, TError,{data: string}, TContext> => {

const mutationKey = ['handleReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleReport>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  handleReport(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandleReportMutationResult = NonNullable<Awaited<ReturnType<typeof handleReport>>>
    export type HandleReportMutationBody = string
    export type HandleReportMutationError = AxiosError<unknown>

    /**
 * @summary Handle a Content Security Policy report
 */
export const useHandleReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleReport>>, TError,{data: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handleReport>>,
        TError,
        {data: string},
        TContext
      > => {
      return useMutation(getHandleReportMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary create a new credit note email address for a developer company
 */
export const postCompanyCreditNoteEmailAddress = (
    id: MaybeRefOrGetter<number>,
    webModelCreditNoteEmailAddress: MaybeRefOrGetter<WebModelCreditNoteEmailAddress>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile>> => {
    id = toValue(id);
webModelCreditNoteEmailAddress = toValue(webModelCreditNoteEmailAddress);

    return axios.post(
      `/service/api/company-profiles/${id}/creditnote_email`,
      webModelCreditNoteEmailAddress,options
    );
  }




export const getPostCompanyCreditNoteEmailAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyCreditNoteEmailAddress>>, TError,{id: number;data: WebModelCreditNoteEmailAddress}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyCreditNoteEmailAddress>>, TError,{id: number;data: WebModelCreditNoteEmailAddress}, TContext> => {

const mutationKey = ['postCompanyCreditNoteEmailAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyCreditNoteEmailAddress>>, {id: number;data: WebModelCreditNoteEmailAddress}> = (props) => {
          const {id,data} = props ?? {};

          return  postCompanyCreditNoteEmailAddress(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyCreditNoteEmailAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyCreditNoteEmailAddress>>>
    export type PostCompanyCreditNoteEmailAddressMutationBody = WebModelCreditNoteEmailAddress
    export type PostCompanyCreditNoteEmailAddressMutationError = AxiosError<unknown>

    /**
 * @summary create a new credit note email address for a developer company
 */
export const usePostCompanyCreditNoteEmailAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyCreditNoteEmailAddress>>, TError,{id: number;data: WebModelCreditNoteEmailAddress}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof postCompanyCreditNoteEmailAddress>>,
        TError,
        {id: number;data: WebModelCreditNoteEmailAddress},
        TContext
      > => {
      return useMutation(getPostCompanyCreditNoteEmailAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary delete the credit note email address for a developer company
 */
export const deleteCompanyCreditNoteEmailAddress = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/company-profiles/${id}/creditnote_email`,options
    );
  }




export const getDeleteCompanyCreditNoteEmailAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyCreditNoteEmailAddress>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyCreditNoteEmailAddress>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCompanyCreditNoteEmailAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyCreditNoteEmailAddress>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanyCreditNoteEmailAddress(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyCreditNoteEmailAddressMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyCreditNoteEmailAddress>>>

    export type DeleteCompanyCreditNoteEmailAddressMutationError = AxiosError<unknown>

    /**
 * @summary delete the credit note email address for a developer company
 */
export const useDeleteCompanyCreditNoteEmailAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyCreditNoteEmailAddress>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompanyCreditNoteEmailAddress>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCompanyCreditNoteEmailAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary resend the verification link for the credit note email address of a company
 */
export const resendCompanyCreditNoteEmailVerificationLink = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/company-profiles/${id}/creditnote_email/verify`,options
    );
  }




export const getResendCompanyCreditNoteEmailVerificationLinkQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','company-profiles',id,'creditnote_email','verify'
    ] as const;
    }


export const getResendCompanyCreditNoteEmailVerificationLinkQueryOptions = <TData = Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getResendCompanyCreditNoteEmailVerificationLinkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>> = ({ signal }) => resendCompanyCreditNoteEmailVerificationLink(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>, TError, TData>
}

export type ResendCompanyCreditNoteEmailVerificationLinkQueryResult = NonNullable<Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>>
export type ResendCompanyCreditNoteEmailVerificationLinkQueryError = AxiosError<unknown>


/**
 * @summary resend the verification link for the credit note email address of a company
 */

export function useResendCompanyCreditNoteEmailVerificationLink<TData = Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resendCompanyCreditNoteEmailVerificationLink>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResendCompanyCreditNoteEmailVerificationLinkQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary verify the credit note email address of a company
 */
export const verifyCreditNoteEmailAddress = (
    id: MaybeRefOrGetter<number>,
    webModelCreditNoteEmailAddressVerify: MaybeRefOrGetter<WebModelCreditNoteEmailAddressVerify>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
webModelCreditNoteEmailAddressVerify = toValue(webModelCreditNoteEmailAddressVerify);

    return axios.post(
      `/service/api/company-profiles/${id}/creditnote_email/verify`,
      webModelCreditNoteEmailAddressVerify,options
    );
  }




export const getVerifyCreditNoteEmailAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCreditNoteEmailAddress>>, TError,{id: number;data: WebModelCreditNoteEmailAddressVerify}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCreditNoteEmailAddress>>, TError,{id: number;data: WebModelCreditNoteEmailAddressVerify}, TContext> => {

const mutationKey = ['verifyCreditNoteEmailAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCreditNoteEmailAddress>>, {id: number;data: WebModelCreditNoteEmailAddressVerify}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyCreditNoteEmailAddress(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCreditNoteEmailAddressMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCreditNoteEmailAddress>>>
    export type VerifyCreditNoteEmailAddressMutationBody = WebModelCreditNoteEmailAddressVerify
    export type VerifyCreditNoteEmailAddressMutationError = AxiosError<unknown>

    /**
 * @summary verify the credit note email address of a company
 */
export const useVerifyCreditNoteEmailAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCreditNoteEmailAddress>>, TError,{id: number;data: WebModelCreditNoteEmailAddressVerify}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof verifyCreditNoteEmailAddress>>,
        TError,
        {id: number;data: WebModelCreditNoteEmailAddressVerify},
        TContext
      > => {
      return useMutation(getVerifyCreditNoteEmailAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Edit the admin note for a company profile
 */
export const postAdminNoteForCompanyProfile = (
    id: MaybeRefOrGetter<number>,
    webModelPostAdminNote: MaybeRefOrGetter<WebModelPostAdminNote>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile>> => {
    id = toValue(id);
webModelPostAdminNote = toValue(webModelPostAdminNote);

    return axios.post(
      `/service/api/company-profiles/${id}/adminnote`,
      webModelPostAdminNote,options
    );
  }




export const getPostAdminNoteForCompanyProfileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminNoteForCompanyProfile>>, TError,{id: number;data: WebModelPostAdminNote}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminNoteForCompanyProfile>>, TError,{id: number;data: WebModelPostAdminNote}, TContext> => {

const mutationKey = ['postAdminNoteForCompanyProfile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminNoteForCompanyProfile>>, {id: number;data: WebModelPostAdminNote}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminNoteForCompanyProfile(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminNoteForCompanyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminNoteForCompanyProfile>>>
    export type PostAdminNoteForCompanyProfileMutationBody = WebModelPostAdminNote
    export type PostAdminNoteForCompanyProfileMutationError = AxiosError<unknown>

    /**
 * @summary Edit the admin note for a company profile
 */
export const usePostAdminNoteForCompanyProfile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminNoteForCompanyProfile>>, TError,{id: number;data: WebModelPostAdminNote}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof postAdminNoteForCompanyProfile>>,
        TError,
        {id: number;data: WebModelPostAdminNote},
        TContext
      > => {
      return useMutation(getPostAdminNoteForCompanyProfileMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Get a single company invite by code/id
 */
export const getCompanyInviteByCode = (
    inviteCode: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyInvite>> => {
    inviteCode = toValue(inviteCode);

    return axios.get(
      `/service/api/company-invites/${inviteCode}`,options
    );
  }




export const getGetCompanyInviteByCodeQueryKey = (inviteCode: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','company-invites',inviteCode
    ] as const;
    }


export const getGetCompanyInviteByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyInviteByCode>>, TError = AxiosError<unknown>>(inviteCode: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyInviteByCode>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCompanyInviteByCodeQueryKey(inviteCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyInviteByCode>>> = ({ signal }) => getCompanyInviteByCode(inviteCode, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(inviteCode) !== null && toValue(inviteCode) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyInviteByCode>>, TError, TData>
}

export type GetCompanyInviteByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyInviteByCode>>>
export type GetCompanyInviteByCodeQueryError = AxiosError<unknown>


/**
 * @summary Get a single company invite by code/id
 */

export function useGetCompanyInviteByCode<TData = Awaited<ReturnType<typeof getCompanyInviteByCode>>, TError = AxiosError<unknown>>(
 inviteCode: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyInviteByCode>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyInviteByCodeQueryOptions(inviteCode,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User does not have a company yet.
 * @summary Accept a company invite by code/id
 */
export const acceptCompanyInviteByCode = (
    inviteCode: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    inviteCode = toValue(inviteCode);

    return axios.post(
      `/service/api/company-invites/${inviteCode}`,
      undefined,options
    );
  }




export const getAcceptCompanyInviteByCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptCompanyInviteByCode>>, TError,{inviteCode: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof acceptCompanyInviteByCode>>, TError,{inviteCode: string}, TContext> => {

const mutationKey = ['acceptCompanyInviteByCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptCompanyInviteByCode>>, {inviteCode: string}> = (props) => {
          const {inviteCode} = props ?? {};

          return  acceptCompanyInviteByCode(inviteCode,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptCompanyInviteByCodeMutationResult = NonNullable<Awaited<ReturnType<typeof acceptCompanyInviteByCode>>>

    export type AcceptCompanyInviteByCodeMutationError = AxiosError<unknown>

    /**
 * @summary Accept a company invite by code/id
 */
export const useAcceptCompanyInviteByCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptCompanyInviteByCode>>, TError,{inviteCode: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptCompanyInviteByCode>>,
        TError,
        {inviteCode: string},
        TContext
      > => {
      return useMutation(getAcceptCompanyInviteByCodeMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin
 * @summary Edit the pxc number note for a company
 */
export const postPxCNumberNoteForCompany = (
    id: MaybeRefOrGetter<string>,
    webModelPostPxCNumberAdminNote: MaybeRefOrGetter<WebModelPostPxCNumberAdminNote>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);
webModelPostPxCNumberAdminNote = toValue(webModelPostPxCNumberAdminNote);

    return axios.post(
      `/service/api/companies/${id}/pxc_number_note`,
      webModelPostPxCNumberAdminNote,options
    );
  }




export const getPostPxCNumberNoteForCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPxCNumberNoteForCompany>>, TError,{id: string;data: WebModelPostPxCNumberAdminNote}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postPxCNumberNoteForCompany>>, TError,{id: string;data: WebModelPostPxCNumberAdminNote}, TContext> => {

const mutationKey = ['postPxCNumberNoteForCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPxCNumberNoteForCompany>>, {id: string;data: WebModelPostPxCNumberAdminNote}> = (props) => {
          const {id,data} = props ?? {};

          return  postPxCNumberNoteForCompany(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPxCNumberNoteForCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof postPxCNumberNoteForCompany>>>
    export type PostPxCNumberNoteForCompanyMutationBody = WebModelPostPxCNumberAdminNote
    export type PostPxCNumberNoteForCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Edit the pxc number note for a company
 */
export const usePostPxCNumberNoteForCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPxCNumberNoteForCompany>>, TError,{id: string;data: WebModelPostPxCNumberAdminNote}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof postPxCNumberNoteForCompany>>,
        TError,
        {id: string;data: WebModelPostPxCNumberAdminNote},
        TContext
      > => {
      return useMutation(getPostPxCNumberNoteForCompanyMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be a company admin of the company
 * @summary create a new ebilling address for a company
 */
export const postCompanyEBillingAddress = (
    id: MaybeRefOrGetter<string>,
    webModelEBillingAddress: MaybeRefOrGetter<WebModelEBillingAddress>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);
webModelEBillingAddress = toValue(webModelEBillingAddress);

    return axios.post(
      `/service/api/companies/${id}/ebilling`,
      webModelEBillingAddress,options
    );
  }




export const getPostCompanyEBillingAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyEBillingAddress>>, TError,{id: string;data: WebModelEBillingAddress}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyEBillingAddress>>, TError,{id: string;data: WebModelEBillingAddress}, TContext> => {

const mutationKey = ['postCompanyEBillingAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyEBillingAddress>>, {id: string;data: WebModelEBillingAddress}> = (props) => {
          const {id,data} = props ?? {};

          return  postCompanyEBillingAddress(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyEBillingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyEBillingAddress>>>
    export type PostCompanyEBillingAddressMutationBody = WebModelEBillingAddress
    export type PostCompanyEBillingAddressMutationError = AxiosError<unknown>

    /**
 * @summary create a new ebilling address for a company
 */
export const usePostCompanyEBillingAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyEBillingAddress>>, TError,{id: string;data: WebModelEBillingAddress}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof postCompanyEBillingAddress>>,
        TError,
        {id: string;data: WebModelEBillingAddress},
        TContext
      > => {
      return useMutation(getPostCompanyEBillingAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be a company admin of the company
 * @summary delete the ebilling address for a company
 */
export const deleteCompanyEBillingAddress = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/companies/${id}/ebilling`,options
    );
  }




export const getDeleteCompanyEBillingAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyEBillingAddress>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyEBillingAddress>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCompanyEBillingAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyEBillingAddress>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanyEBillingAddress(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyEBillingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyEBillingAddress>>>

    export type DeleteCompanyEBillingAddressMutationError = AxiosError<unknown>

    /**
 * @summary delete the ebilling address for a company
 */
export const useDeleteCompanyEBillingAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyEBillingAddress>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompanyEBillingAddress>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCompanyEBillingAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be a company admin of the company
 * @summary resend the verification link for the ebilling address of a company
 */
export const resendCompanyEBillingVerificationLink = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/companies/${id}/ebilling/verify`,options
    );
  }




export const getResendCompanyEBillingVerificationLinkQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','companies',id,'ebilling','verify'
    ] as const;
    }


export const getResendCompanyEBillingVerificationLinkQueryOptions = <TData = Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getResendCompanyEBillingVerificationLinkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>> = ({ signal }) => resendCompanyEBillingVerificationLink(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>, TError, TData>
}

export type ResendCompanyEBillingVerificationLinkQueryResult = NonNullable<Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>>
export type ResendCompanyEBillingVerificationLinkQueryError = AxiosError<unknown>


/**
 * @summary resend the verification link for the ebilling address of a company
 */

export function useResendCompanyEBillingVerificationLink<TData = Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resendCompanyEBillingVerificationLink>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResendCompanyEBillingVerificationLinkQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Verify the ebilling address of a company
 */
export const verifyEBillingAddress = (
    id: MaybeRefOrGetter<string>,
    webModelEBillingAddressVerify: MaybeRefOrGetter<WebModelEBillingAddressVerify>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
webModelEBillingAddressVerify = toValue(webModelEBillingAddressVerify);

    return axios.post(
      `/service/api/companies/${id}/ebilling/verify`,
      webModelEBillingAddressVerify,options
    );
  }




export const getVerifyEBillingAddressMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEBillingAddress>>, TError,{id: string;data: WebModelEBillingAddressVerify}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEBillingAddress>>, TError,{id: string;data: WebModelEBillingAddressVerify}, TContext> => {

const mutationKey = ['verifyEBillingAddress'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEBillingAddress>>, {id: string;data: WebModelEBillingAddressVerify}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyEBillingAddress(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyEBillingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEBillingAddress>>>
    export type VerifyEBillingAddressMutationBody = WebModelEBillingAddressVerify
    export type VerifyEBillingAddressMutationError = AxiosError<unknown>

    /**
 * @summary Verify the ebilling address of a company
 */
export const useVerifyEBillingAddress = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEBillingAddress>>, TError,{id: string;data: WebModelEBillingAddressVerify}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof verifyEBillingAddress>>,
        TError,
        {id: string;data: WebModelEBillingAddressVerify},
        TContext
      > => {
      return useMutation(getVerifyEBillingAddressMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Get all company invites
 */
export const getAllCompanyInvites = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyInvite[]>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/companies/${id}/company-invites`,options
    );
  }




export const getGetAllCompanyInvitesQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','companies',id,'company-invites'
    ] as const;
    }


export const getGetAllCompanyInvitesQueryOptions = <TData = Awaited<ReturnType<typeof getAllCompanyInvites>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanyInvites>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllCompanyInvitesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCompanyInvites>>> = ({ signal }) => getAllCompanyInvites(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCompanyInvites>>, TError, TData>
}

export type GetAllCompanyInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCompanyInvites>>>
export type GetAllCompanyInvitesQueryError = AxiosError<unknown>


/**
 * @summary Get all company invites
 */

export function useGetAllCompanyInvites<TData = Awaited<ReturnType<typeof getAllCompanyInvites>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanyInvites>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCompanyInvitesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Create and send a company invite
 */
export const postCompanyInvite = (
    id: MaybeRefOrGetter<string>,
    webModelPostCompanyInvite: MaybeRefOrGetter<WebModelPostCompanyInvite>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyInvite>> => {
    id = toValue(id);
webModelPostCompanyInvite = toValue(webModelPostCompanyInvite);

    return axios.post(
      `/service/api/companies/${id}/company-invites`,
      webModelPostCompanyInvite,options
    );
  }




export const getPostCompanyInviteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyInvite>>, TError,{id: string;data: WebModelPostCompanyInvite}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyInvite>>, TError,{id: string;data: WebModelPostCompanyInvite}, TContext> => {

const mutationKey = ['postCompanyInvite'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyInvite>>, {id: string;data: WebModelPostCompanyInvite}> = (props) => {
          const {id,data} = props ?? {};

          return  postCompanyInvite(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyInvite>>>
    export type PostCompanyInviteMutationBody = WebModelPostCompanyInvite
    export type PostCompanyInviteMutationError = AxiosError<unknown>

    /**
 * @summary Create and send a company invite
 */
export const usePostCompanyInvite = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyInvite>>, TError,{id: string;data: WebModelPostCompanyInvite}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof postCompanyInvite>>,
        TError,
        {id: string;data: WebModelPostCompanyInvite},
        TContext
      > => {
      return useMutation(getPostCompanyInviteMutationOptions(options), queryClient);
    }

/**
 * Security:  User has to be authenticated. User has to be store admin
 * @summary Approve a company pxc number
 */
export const approvePxCNumberForCompany = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);

    return axios.post(
      `/service/api/companies/${id}/approve_pxcnumber`,
      undefined,options
    );
  }




export const getApprovePxCNumberForCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePxCNumberForCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approvePxCNumberForCompany>>, TError,{id: string}, TContext> => {

const mutationKey = ['approvePxCNumberForCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePxCNumberForCompany>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approvePxCNumberForCompany(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePxCNumberForCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof approvePxCNumberForCompany>>>

    export type ApprovePxCNumberForCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Approve a company pxc number
 */
export const useApprovePxCNumberForCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePxCNumberForCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof approvePxCNumberForCompany>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApprovePxCNumberForCompanyMutationOptions(options), queryClient);
    }

/**
 * Security:  User has to be authenticated. User has to be store admin
 * @summary Disapprove a company pxc number.
 */
export const disapprovePxCNumberForCompany = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/companies/${id}/approve_pxcnumber`,options
    );
  }




export const getDisapprovePxCNumberForCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disapprovePxCNumberForCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof disapprovePxCNumberForCompany>>, TError,{id: string}, TContext> => {

const mutationKey = ['disapprovePxCNumberForCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disapprovePxCNumberForCompany>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  disapprovePxCNumberForCompany(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisapprovePxCNumberForCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof disapprovePxCNumberForCompany>>>

    export type DisapprovePxCNumberForCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Disapprove a company pxc number.
 */
export const useDisapprovePxCNumberForCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disapprovePxCNumberForCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disapprovePxCNumberForCompany>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDisapprovePxCNumberForCompanyMutationOptions(options), queryClient);
    }

/**
 * Security:  User has to be authenticated. User has to be store admin
 * @summary Approve a company as contributor
 */
export const approveCompany = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);

    return axios.post(
      `/service/api/companies/${id}/approve`,
      undefined,options
    );
  }




export const getApproveCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof approveCompany>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCompany>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveCompany(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof approveCompany>>>

    export type ApproveCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Approve a company as contributor
 */
export const useApproveCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof approveCompany>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApproveCompanyMutationOptions(options), queryClient);
    }

/**
 * Security:  User has to be authenticated. User has to be store admin
 * @summary Disapprove a company as contributor
 */
export const disapproveCompany = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/companies/${id}/approve`,options
    );
  }




export const getDisapproveCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disapproveCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof disapproveCompany>>, TError,{id: string}, TContext> => {

const mutationKey = ['disapproveCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disapproveCompany>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  disapproveCompany(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisapproveCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof disapproveCompany>>>

    export type DisapproveCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Disapprove a company as contributor
 */
export const useDisapproveCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disapproveCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disapproveCompany>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDisapproveCompanyMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Get all CategoryGroups
 */
export const findAllCategoryGroups = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCategoryGroup[]>> => {


    return axios.get(
      `/service/api/categorygroups`,options
    );
  }




export const getFindAllCategoryGroupsQueryKey = () => {
    return [
    'service','api','categorygroups'
    ] as const;
    }


export const getFindAllCategoryGroupsQueryOptions = <TData = Awaited<ReturnType<typeof findAllCategoryGroups>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCategoryGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAllCategoryGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllCategoryGroups>>> = ({ signal }) => findAllCategoryGroups({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllCategoryGroups>>, TError, TData>
}

export type FindAllCategoryGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllCategoryGroups>>>
export type FindAllCategoryGroupsQueryError = AxiosError<unknown>


/**
 * @summary Get all CategoryGroups
 */

export function useFindAllCategoryGroups<TData = Awaited<ReturnType<typeof findAllCategoryGroups>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCategoryGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllCategoryGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Add a Category Group
 */
export const addNewCategoryGroup = (
    webModelPostCategoryGroup: MaybeRefOrGetter<WebModelPostCategoryGroup>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCategoryGroup>> => {
    webModelPostCategoryGroup = toValue(webModelPostCategoryGroup);

    return axios.post(
      `/service/api/categorygroups`,
      webModelPostCategoryGroup,options
    );
  }




export const getAddNewCategoryGroupMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewCategoryGroup>>, TError,{data: WebModelPostCategoryGroup}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addNewCategoryGroup>>, TError,{data: WebModelPostCategoryGroup}, TContext> => {

const mutationKey = ['addNewCategoryGroup'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNewCategoryGroup>>, {data: WebModelPostCategoryGroup}> = (props) => {
          const {data} = props ?? {};

          return  addNewCategoryGroup(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddNewCategoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof addNewCategoryGroup>>>
    export type AddNewCategoryGroupMutationBody = WebModelPostCategoryGroup
    export type AddNewCategoryGroupMutationError = AxiosError<unknown>

    /**
 * @summary Add a Category Group
 */
export const useAddNewCategoryGroup = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewCategoryGroup>>, TError,{data: WebModelPostCategoryGroup}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addNewCategoryGroup>>,
        TError,
        {data: WebModelPostCategoryGroup},
        TContext
      > => {
      return useMutation(getAddNewCategoryGroupMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Get all Categories
 */
export const findAllCategories = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCategory[]>> => {


    return axios.get(
      `/service/api/categories`,options
    );
  }




export const getFindAllCategoriesQueryKey = () => {
    return [
    'service','api','categories'
    ] as const;
    }


export const getFindAllCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof findAllCategories>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAllCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllCategories>>> = ({ signal }) => findAllCategories({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllCategories>>, TError, TData>
}

export type FindAllCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllCategories>>>
export type FindAllCategoriesQueryError = AxiosError<unknown>


/**
 * @summary Get all Categories
 */

export function useFindAllCategories<TData = Awaited<ReturnType<typeof findAllCategories>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCategories>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Add a Category
 */
export const addNewCategory = (
    webModelPostCategory: MaybeRefOrGetter<WebModelPostCategory>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCategory>> => {
    webModelPostCategory = toValue(webModelPostCategory);

    return axios.post(
      `/service/api/categories`,
      webModelPostCategory,options
    );
  }




export const getAddNewCategoryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewCategory>>, TError,{data: WebModelPostCategory}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addNewCategory>>, TError,{data: WebModelPostCategory}, TContext> => {

const mutationKey = ['addNewCategory'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNewCategory>>, {data: WebModelPostCategory}> = (props) => {
          const {data} = props ?? {};

          return  addNewCategory(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddNewCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof addNewCategory>>>
    export type AddNewCategoryMutationBody = WebModelPostCategory
    export type AddNewCategoryMutationError = AxiosError<unknown>

    /**
 * @summary Add a Category
 */
export const useAddNewCategory = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewCategory>>, TError,{data: WebModelPostCategory}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addNewCategory>>,
        TError,
        {data: WebModelPostCategory},
        TContext
      > => {
      return useMutation(getAddNewCategoryMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be authenticated. User needs to have a company. The company has to be an approved developer company.
 * @summary Create a new app
 */
export const createNewApp = (
    appTypeId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    appTypeId = toValue(appTypeId);

    return axios.post(
      `/service/api/apps/${appTypeId}`,
      undefined,options
    );
  }




export const getCreateNewAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewApp>>, TError,{appTypeId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createNewApp>>, TError,{appTypeId: number}, TContext> => {

const mutationKey = ['createNewApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewApp>>, {appTypeId: number}> = (props) => {
          const {appTypeId} = props ?? {};

          return  createNewApp(appTypeId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewAppMutationResult = NonNullable<Awaited<ReturnType<typeof createNewApp>>>

    export type CreateNewAppMutationError = AxiosError<unknown>

    /**
 * @summary Create a new app
 */
export const useCreateNewApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewApp>>, TError,{appTypeId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createNewApp>>,
        TError,
        {appTypeId: number},
        TContext
      > => {
      return useMutation(getCreateNewAppMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be a store admin.
 * @summary Create a new app for a developer as admin. Used to import products that are already available in the license central
 */
export const createNewAppAsAdmin = (
    appTypeId: MaybeRefOrGetter<number>,
    webModelPostNewAppAsAdmin: MaybeRefOrGetter<WebModelPostNewAppAsAdmin>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    appTypeId = toValue(appTypeId);
webModelPostNewAppAsAdmin = toValue(webModelPostNewAppAsAdmin);

    return axios.post(
      `/service/api/apps/${appTypeId}/admin`,
      webModelPostNewAppAsAdmin,options
    );
  }




export const getCreateNewAppAsAdminMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewAppAsAdmin>>, TError,{appTypeId: number;data: WebModelPostNewAppAsAdmin}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createNewAppAsAdmin>>, TError,{appTypeId: number;data: WebModelPostNewAppAsAdmin}, TContext> => {

const mutationKey = ['createNewAppAsAdmin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewAppAsAdmin>>, {appTypeId: number;data: WebModelPostNewAppAsAdmin}> = (props) => {
          const {appTypeId,data} = props ?? {};

          return  createNewAppAsAdmin(appTypeId,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewAppAsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof createNewAppAsAdmin>>>
    export type CreateNewAppAsAdminMutationBody = WebModelPostNewAppAsAdmin
    export type CreateNewAppAsAdminMutationError = AxiosError<unknown>

    /**
 * @summary Create a new app for a developer as admin. Used to import products that are already available in the license central
 */
export const useCreateNewAppAsAdmin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewAppAsAdmin>>, TError,{appTypeId: number;data: WebModelPostNewAppAsAdmin}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createNewAppAsAdmin>>,
        TError,
        {appTypeId: number;data: WebModelPostNewAppAsAdmin},
        TContext
      > => {
      return useMutation(getCreateNewAppAsAdminMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be owner of the device.
 * @summary Install an app binary only (without license/requires license to be on the device and known to appstore). Installs the latest app version.
 */
export const installAppWithoutLicense = (
    proficloudAppId: MaybeRefOrGetter<string>,
    deviceid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    proficloudAppId = toValue(proficloudAppId);
deviceid = toValue(deviceid);

    return axios.post(
      `/service/api/apps/proficloud-app-id/${proficloudAppId}/devices/${deviceid}/binary`,
      undefined,options
    );
  }




export const getInstallAppWithoutLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installAppWithoutLicense>>, TError,{proficloudAppId: string;deviceid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof installAppWithoutLicense>>, TError,{proficloudAppId: string;deviceid: string}, TContext> => {

const mutationKey = ['installAppWithoutLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof installAppWithoutLicense>>, {proficloudAppId: string;deviceid: string}> = (props) => {
          const {proficloudAppId,deviceid} = props ?? {};

          return  installAppWithoutLicense(proficloudAppId,deviceid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstallAppWithoutLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof installAppWithoutLicense>>>

    export type InstallAppWithoutLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Install an app binary only (without license/requires license to be on the device and known to appstore). Installs the latest app version.
 */
export const useInstallAppWithoutLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installAppWithoutLicense>>, TError,{proficloudAppId: string;deviceid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof installAppWithoutLicense>>,
        TError,
        {proficloudAppId: string;deviceid: string},
        TContext
      > => {
      return useMutation(getInstallAppWithoutLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be assigned developer to the app.
 * @summary Create a new version (draft) of an app (by appId).
 */
export const createNewDraftForApp = (
    id: MaybeRefOrGetter<number>,
    webModelPostNewRelease: MaybeRefOrGetter<WebModelPostNewRelease>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    id = toValue(id);
webModelPostNewRelease = toValue(webModelPostNewRelease);

    return axios.post(
      `/service/api/apps/id/${id}/new-release`,
      webModelPostNewRelease,options
    );
  }




export const getCreateNewDraftForAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewDraftForApp>>, TError,{id: number;data: WebModelPostNewRelease}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createNewDraftForApp>>, TError,{id: number;data: WebModelPostNewRelease}, TContext> => {

const mutationKey = ['createNewDraftForApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewDraftForApp>>, {id: number;data: WebModelPostNewRelease}> = (props) => {
          const {id,data} = props ?? {};

          return  createNewDraftForApp(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNewDraftForAppMutationResult = NonNullable<Awaited<ReturnType<typeof createNewDraftForApp>>>
    export type CreateNewDraftForAppMutationBody = WebModelPostNewRelease
    export type CreateNewDraftForAppMutationError = AxiosError<unknown>

    /**
 * @summary Create a new version (draft) of an app (by appId).
 */
export const useCreateNewDraftForApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewDraftForApp>>, TError,{id: number;data: WebModelPostNewRelease}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createNewDraftForApp>>,
        TError,
        {id: number;data: WebModelPostNewRelease},
        TContext
      > => {
      return useMutation(getCreateNewDraftForAppMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be owner of the device.
 * @summary Install an app binary only by id of specific app version.
 */
export const installAppVersionWithoutLicense = (
    id: MaybeRefOrGetter<number>,
    deviceid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
deviceid = toValue(deviceid);

    return axios.post(
      `/service/api/apps/id/${id}/devices/${deviceid}/binary`,
      undefined,options
    );
  }




export const getInstallAppVersionWithoutLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installAppVersionWithoutLicense>>, TError,{id: number;deviceid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof installAppVersionWithoutLicense>>, TError,{id: number;deviceid: string}, TContext> => {

const mutationKey = ['installAppVersionWithoutLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof installAppVersionWithoutLicense>>, {id: number;deviceid: string}> = (props) => {
          const {id,deviceid} = props ?? {};

          return  installAppVersionWithoutLicense(id,deviceid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstallAppVersionWithoutLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof installAppVersionWithoutLicense>>>

    export type InstallAppVersionWithoutLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Install an app binary only by id of specific app version.
 */
export const useInstallAppVersionWithoutLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installAppVersionWithoutLicense>>, TError,{id: number;deviceid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof installAppVersionWithoutLicense>>,
        TError,
        {id: number;deviceid: string},
        TContext
      > => {
      return useMutation(getInstallAppVersionWithoutLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be developer which is assigned to the app.
 * @summary Add a binary file for the app version
 */
export const addAppBinary = (
    id: MaybeRefOrGetter<number>,
    addAppBinaryBody?: MaybeRefOrGetter<AddAppBinaryBody>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppBinary>> => {
    id = toValue(id);
addAppBinaryBody = toValue(addAppBinaryBody);
    const formData = new FormData();
if(addAppBinaryBody?.json !== undefined) {
 formData.append(`json`, JSON.stringify(addAppBinaryBody.json));
 }
if(addAppBinaryBody?.appFile !== undefined) {
 formData.append(`appFile`, addAppBinaryBody.appFile);
 }

    return axios.post(
      `/service/api/apps/id/${id}/binaries`,
      formData,options
    );
  }




export const getAddAppBinaryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppBinary>>, TError,{id: number;data?: AddAppBinaryBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addAppBinary>>, TError,{id: number;data?: AddAppBinaryBody}, TContext> => {

const mutationKey = ['addAppBinary'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAppBinary>>, {id: number;data?: AddAppBinaryBody}> = (props) => {
          const {id,data} = props ?? {};

          return  addAppBinary(id,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAppBinaryMutationResult = NonNullable<Awaited<ReturnType<typeof addAppBinary>>>
    export type AddAppBinaryMutationBody = AddAppBinaryBody | undefined
    export type AddAppBinaryMutationError = AxiosError<unknown>

    /**
 * @summary Add a binary file for the app version
 */
export const useAddAppBinary = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppBinary>>, TError,{id: number;data?: AddAppBinaryBody}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addAppBinary>>,
        TError,
        {id: number;data?: AddAppBinaryBody},
        TContext
      > => {
      return useMutation(getAddAppBinaryMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is assigned to the app
 * @summary Create a new license option for an app
 */
export const createLicenseOption = (
    appId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicenseOption>> => {
    appId = toValue(appId);

    return axios.post(
      `/service/api/apps/app-id/${appId}/license-options`,
      undefined,options
    );
  }




export const getCreateLicenseOptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLicenseOption>>, TError,{appId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createLicenseOption>>, TError,{appId: number}, TContext> => {

const mutationKey = ['createLicenseOption'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLicenseOption>>, {appId: number}> = (props) => {
          const {appId} = props ?? {};

          return  createLicenseOption(appId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLicenseOptionMutationResult = NonNullable<Awaited<ReturnType<typeof createLicenseOption>>>

    export type CreateLicenseOptionMutationError = AxiosError<unknown>

    /**
 * @summary Create a new license option for an app
 */
export const useCreateLicenseOption = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLicenseOption>>, TError,{appId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createLicenseOption>>,
        TError,
        {appId: number},
        TContext
      > => {
      return useMutation(getCreateLicenseOptionMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is assigned to the app.
 * @summary Get all trial codes for license option
 */
export const getAllTrialCodesForLicenseOption = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetTrialCode[]>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);

    return axios.get(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}/trial-codes`,options
    );
  }




export const getGetAllTrialCodesForLicenseOptionQueryKey = (appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','app-id',appId,'license-options',licenseOptionId,'trial-codes'
    ] as const;
    }


export const getGetAllTrialCodesForLicenseOptionQueryOptions = <TData = Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>, TError = AxiosError<unknown>>(appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllTrialCodesForLicenseOptionQueryKey(appId,licenseOptionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>> = ({ signal }) => getAllTrialCodesForLicenseOption(appId,licenseOptionId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appId) !== null && toValue(appId) !== undefined && toValue(licenseOptionId) !== null && toValue(licenseOptionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>, TError, TData>
}

export type GetAllTrialCodesForLicenseOptionQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>>
export type GetAllTrialCodesForLicenseOptionQueryError = AxiosError<unknown>


/**
 * @summary Get all trial codes for license option
 */

export function useGetAllTrialCodesForLicenseOption<TData = Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>, TError = AxiosError<unknown>>(
 appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTrialCodesForLicenseOption>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllTrialCodesForLicenseOptionQueryOptions(appId,licenseOptionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is assigned to the app.
 * @summary Create a new trial code for the given license option
 */
export const createTrialCodeForLicenseOption = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    webModelPostNewTrialCode: MaybeRefOrGetter<WebModelPostNewTrialCode>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetTrialCode>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);
webModelPostNewTrialCode = toValue(webModelPostNewTrialCode);

    return axios.post(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}/trial-codes`,
      webModelPostNewTrialCode,options
    );
  }




export const getCreateTrialCodeForLicenseOptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrialCodeForLicenseOption>>, TError,{appId: number;licenseOptionId: number;data: WebModelPostNewTrialCode}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createTrialCodeForLicenseOption>>, TError,{appId: number;licenseOptionId: number;data: WebModelPostNewTrialCode}, TContext> => {

const mutationKey = ['createTrialCodeForLicenseOption'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrialCodeForLicenseOption>>, {appId: number;licenseOptionId: number;data: WebModelPostNewTrialCode}> = (props) => {
          const {appId,licenseOptionId,data} = props ?? {};

          return  createTrialCodeForLicenseOption(appId,licenseOptionId,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrialCodeForLicenseOptionMutationResult = NonNullable<Awaited<ReturnType<typeof createTrialCodeForLicenseOption>>>
    export type CreateTrialCodeForLicenseOptionMutationBody = WebModelPostNewTrialCode
    export type CreateTrialCodeForLicenseOptionMutationError = AxiosError<unknown>

    /**
 * @summary Create a new trial code for the given license option
 */
export const useCreateTrialCodeForLicenseOption = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrialCodeForLicenseOption>>, TError,{appId: number;licenseOptionId: number;data: WebModelPostNewTrialCode}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTrialCodeForLicenseOption>>,
        TError,
        {appId: number;licenseOptionId: number;data: WebModelPostNewTrialCode},
        TContext
      > => {
      return useMutation(getCreateTrialCodeForLicenseOptionMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is assigned to the app. The license option belongs to the app. The license option belongs to the app.
 * @summary Generate a developer license for the given license option
 */
export const generateDeveloperLicense = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);

    return axios.post(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}/developer-license`,
      undefined,options
    );
  }




export const getGenerateDeveloperLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDeveloperLicense>>, TError,{appId: number;licenseOptionId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof generateDeveloperLicense>>, TError,{appId: number;licenseOptionId: number}, TContext> => {

const mutationKey = ['generateDeveloperLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDeveloperLicense>>, {appId: number;licenseOptionId: number}> = (props) => {
          const {appId,licenseOptionId} = props ?? {};

          return  generateDeveloperLicense(appId,licenseOptionId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDeveloperLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof generateDeveloperLicense>>>

    export type GenerateDeveloperLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Generate a developer license for the given license option
 */
export const useGenerateDeveloperLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDeveloperLicense>>, TError,{appId: number;licenseOptionId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof generateDeveloperLicense>>,
        TError,
        {appId: number;licenseOptionId: number},
        TContext
      > => {
      return useMutation(getGenerateDeveloperLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be assigned to the app or be an store admin.
 * @summary Get a List of all developers assigned to a specific app
 */
export const getAppUsers = (
    params: MaybeRefOrGetter<GetAppUsersParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/app-users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAppUsersQueryKey = (params?: MaybeRefOrGetter<GetAppUsersParams>,) => {
    return [
    'service','api','app-users', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAppUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAppUsers>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetAppUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppUsers>>> = ({ signal }) => getAppUsers(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppUsers>>, TError, TData>
}

export type GetAppUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAppUsers>>>
export type GetAppUsersQueryError = AxiosError<unknown>


/**
 * @summary Get a List of all developers assigned to a specific app
 */

export function useGetAppUsers<TData = Awaited<ReturnType<typeof getAppUsers>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetAppUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be assigned to the app or be an store admin.
 * @summary Add Developers to an App
 */
export const addAppUsers = (
    addAppUsersBody: MaybeRefOrGetter<string[]>,
    params: MaybeRefOrGetter<AddAppUsersParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    addAppUsersBody = toValue(addAppUsersBody);
params = toValue(params);

    return axios.post(
      `/service/api/app-users`,
      addAppUsersBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getAddAppUsersMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppUsers>>, TError,{data: string[];params: AddAppUsersParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addAppUsers>>, TError,{data: string[];params: AddAppUsersParams}, TContext> => {

const mutationKey = ['addAppUsers'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAppUsers>>, {data: string[];params: AddAppUsersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  addAppUsers(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAppUsersMutationResult = NonNullable<Awaited<ReturnType<typeof addAppUsers>>>
    export type AddAppUsersMutationBody = string[]
    export type AddAppUsersMutationError = AxiosError<unknown>

    /**
 * @summary Add Developers to an App
 */
export const useAddAppUsers = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppUsers>>, TError,{data: string[];params: AddAppUsersParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addAppUsers>>,
        TError,
        {data: string[];params: AddAppUsersParams},
        TContext
      > => {
      return useMutation(getAddAppUsersMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be assigned to the app or be an store admin.
 * @summary Remove Users from assignment to a specific app
 */
export const deleteAppUsers = (
    deleteAppUsersBody: MaybeRefOrGetter<string[]>,
    params: MaybeRefOrGetter<DeleteAppUsersParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    deleteAppUsersBody = toValue(deleteAppUsersBody);
params = toValue(params);

    return axios.delete(
      `/service/api/app-users`,{data: deleteAppUsersBody,
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getDeleteAppUsersMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppUsers>>, TError,{data: string[];params: DeleteAppUsersParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAppUsers>>, TError,{data: string[];params: DeleteAppUsersParams}, TContext> => {

const mutationKey = ['deleteAppUsers'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAppUsers>>, {data: string[];params: DeleteAppUsersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteAppUsers(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAppUsersMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAppUsers>>>
    export type DeleteAppUsersMutationBody = string[]
    export type DeleteAppUsersMutationError = AxiosError<unknown>

    /**
 * @summary Remove Users from assignment to a specific app
 */
export const useDeleteAppUsers = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppUsers>>, TError,{data: string[];params: DeleteAppUsersParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAppUsers>>,
        TError,
        {data: string[];params: DeleteAppUsersParams},
        TContext
      > => {
      return useMutation(getDeleteAppUsersMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be assigned to the app or be an store admin. User is store admin or requesting its own user id
 * @summary Adds an app to the list of favorite apps of a developer
 */
export const addAppToDeveloperFavorites = (
    params: MaybeRefOrGetter<AddAppToDeveloperFavoritesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.post(
      `/service/api/app-users/favorites`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getAddAppToDeveloperFavoritesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppToDeveloperFavorites>>, TError,{params: AddAppToDeveloperFavoritesParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addAppToDeveloperFavorites>>, TError,{params: AddAppToDeveloperFavoritesParams}, TContext> => {

const mutationKey = ['addAppToDeveloperFavorites'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAppToDeveloperFavorites>>, {params: AddAppToDeveloperFavoritesParams}> = (props) => {
          const {params} = props ?? {};

          return  addAppToDeveloperFavorites(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAppToDeveloperFavoritesMutationResult = NonNullable<Awaited<ReturnType<typeof addAppToDeveloperFavorites>>>

    export type AddAppToDeveloperFavoritesMutationError = AxiosError<unknown>

    /**
 * @summary Adds an app to the list of favorite apps of a developer
 */
export const useAddAppToDeveloperFavorites = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAppToDeveloperFavorites>>, TError,{params: AddAppToDeveloperFavoritesParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addAppToDeveloperFavorites>>,
        TError,
        {params: AddAppToDeveloperFavoritesParams},
        TContext
      > => {
      return useMutation(getAddAppToDeveloperFavoritesMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be assigned to the app or be an store admin. User is store admin or requesting its own user id
 * @summary Remove an app from the list of favorite apps of a developer
 */
export const deleteAppFromDeveloperFavorites = (
    params: MaybeRefOrGetter<DeleteAppFromDeveloperFavoritesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.delete(
      `/service/api/app-users/favorites`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getDeleteAppFromDeveloperFavoritesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppFromDeveloperFavorites>>, TError,{params: DeleteAppFromDeveloperFavoritesParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAppFromDeveloperFavorites>>, TError,{params: DeleteAppFromDeveloperFavoritesParams}, TContext> => {

const mutationKey = ['deleteAppFromDeveloperFavorites'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAppFromDeveloperFavorites>>, {params: DeleteAppFromDeveloperFavoritesParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAppFromDeveloperFavorites(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAppFromDeveloperFavoritesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAppFromDeveloperFavorites>>>

    export type DeleteAppFromDeveloperFavoritesMutationError = AxiosError<unknown>

    /**
 * @summary Remove an app from the list of favorite apps of a developer
 */
export const useDeleteAppFromDeveloperFavorites = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppFromDeveloperFavorites>>, TError,{params: DeleteAppFromDeveloperFavoritesParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAppFromDeveloperFavorites>>,
        TError,
        {params: DeleteAppFromDeveloperFavoritesParams},
        TContext
      > => {
      return useMutation(getDeleteAppFromDeveloperFavoritesMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be owner of the license or company admin of the same company.
 * @summary Make license private (set the private flag)
 */
export const makeLicensePrivate = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicense>> => {
    id = toValue(id);

    return axios.post(
      `/service/api/app-licenses/${id}/private`,
      undefined,options
    );
  }




export const getMakeLicensePrivateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeLicensePrivate>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof makeLicensePrivate>>, TError,{id: number}, TContext> => {

const mutationKey = ['makeLicensePrivate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeLicensePrivate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  makeLicensePrivate(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MakeLicensePrivateMutationResult = NonNullable<Awaited<ReturnType<typeof makeLicensePrivate>>>

    export type MakeLicensePrivateMutationError = AxiosError<unknown>

    /**
 * @summary Make license private (set the private flag)
 */
export const useMakeLicensePrivate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeLicensePrivate>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof makeLicensePrivate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMakeLicensePrivateMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be owner of the license or company admin of the same company.
 * @summary Make a license public (delete the private flag)
 */
export const makeLicensePublic = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicense>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/app-licenses/${id}/private`,options
    );
  }




export const getMakeLicensePublicMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeLicensePublic>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof makeLicensePublic>>, TError,{id: number}, TContext> => {

const mutationKey = ['makeLicensePublic'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeLicensePublic>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  makeLicensePublic(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MakeLicensePublicMutationResult = NonNullable<Awaited<ReturnType<typeof makeLicensePublic>>>

    export type MakeLicensePublicMutationError = AxiosError<unknown>

    /**
 * @summary Make a license public (delete the private flag)
 */
export const useMakeLicensePublic = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeLicensePublic>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof makeLicensePublic>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMakeLicensePublicMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User can only access his own path (userid).
 * @summary Get the task status for the last refresh task of the calling user
 */
export const getUserRefreshTaskStatus = (
    userid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserRefreshTaskStatus200>> => {
    userid = toValue(userid);

    return axios.get(
      `/service/api/app-licenses/refresh/users/${userid}`,options
    );
  }




export const getGetUserRefreshTaskStatusQueryKey = (userid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','app-licenses','refresh','users',userid
    ] as const;
    }


export const getGetUserRefreshTaskStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserRefreshTaskStatus>>, TError = AxiosError<unknown>>(userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRefreshTaskStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetUserRefreshTaskStatusQueryKey(userid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserRefreshTaskStatus>>> = ({ signal }) => getUserRefreshTaskStatus(userid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userid) !== null && toValue(userid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserRefreshTaskStatus>>, TError, TData>
}

export type GetUserRefreshTaskStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserRefreshTaskStatus>>>
export type GetUserRefreshTaskStatusQueryError = AxiosError<unknown>


/**
 * @summary Get the task status for the last refresh task of the calling user
 */

export function useGetUserRefreshTaskStatus<TData = Awaited<ReturnType<typeof getUserRefreshTaskStatus>>, TError = AxiosError<unknown>>(
 userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRefreshTaskStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserRefreshTaskStatusQueryOptions(userid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access his own path (userid).
 * @summary As user have all my license information refreshed asynchronously, by creating a task
 */
export const createUserRefreshTask = (
    userid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    userid = toValue(userid);

    return axios.post(
      `/service/api/app-licenses/refresh/users/${userid}`,
      undefined,options
    );
  }




export const getCreateUserRefreshTaskMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserRefreshTask>>, TError,{userid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createUserRefreshTask>>, TError,{userid: string}, TContext> => {

const mutationKey = ['createUserRefreshTask'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserRefreshTask>>, {userid: string}> = (props) => {
          const {userid} = props ?? {};

          return  createUserRefreshTask(userid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserRefreshTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createUserRefreshTask>>>

    export type CreateUserRefreshTaskMutationError = AxiosError<unknown>

    /**
 * @summary As user have all my license information refreshed asynchronously, by creating a task
 */
export const useCreateUserRefreshTask = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserRefreshTask>>, TError,{userid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createUserRefreshTask>>,
        TError,
        {userid: string},
        TContext
      > => {
      return useMutation(getCreateUserRefreshTaskMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be owner of the host device
 * @summary link a license to host device and sends license pdf
 */
export const linkLicenseToHostDevice = (
    webModelPostLinkLicensesToHostDevice: MaybeRefOrGetter<WebModelPostLinkLicensesToHostDevice>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelPostLinkLicensesToHostDevice = toValue(webModelPostLinkLicensesToHostDevice);

    return axios.post(
      `/service/api/app-licenses/link-to-device`,
      webModelPostLinkLicensesToHostDevice,options
    );
  }




export const getLinkLicenseToHostDeviceMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkLicenseToHostDevice>>, TError,{data: WebModelPostLinkLicensesToHostDevice}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof linkLicenseToHostDevice>>, TError,{data: WebModelPostLinkLicensesToHostDevice}, TContext> => {

const mutationKey = ['linkLicenseToHostDevice'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkLicenseToHostDevice>>, {data: WebModelPostLinkLicensesToHostDevice}> = (props) => {
          const {data} = props ?? {};

          return  linkLicenseToHostDevice(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkLicenseToHostDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof linkLicenseToHostDevice>>>
    export type LinkLicenseToHostDeviceMutationBody = WebModelPostLinkLicensesToHostDevice
    export type LinkLicenseToHostDeviceMutationError = AxiosError<unknown>

    /**
 * @summary link a license to host device and sends license pdf
 */
export const useLinkLicenseToHostDevice = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkLicenseToHostDevice>>, TError,{data: WebModelPostLinkLicensesToHostDevice}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof linkLicenseToHostDevice>>,
        TError,
        {data: WebModelPostLinkLicensesToHostDevice},
        TContext
      > => {
      return useMutation(getLinkLicenseToHostDeviceMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be owner of the device.
 * @summary Install licenses or app and licenses
 */
export const installAppAndLicensesOnDevice = (
    webModelPostInstallAppAndLicenses: MaybeRefOrGetter<WebModelPostInstallAppAndLicenses>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    webModelPostInstallAppAndLicenses = toValue(webModelPostInstallAppAndLicenses);

    return axios.post(
      `/service/api/app-licenses/install`,
      webModelPostInstallAppAndLicenses,options
    );
  }




export const getInstallAppAndLicensesOnDeviceMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installAppAndLicensesOnDevice>>, TError,{data: WebModelPostInstallAppAndLicenses}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof installAppAndLicensesOnDevice>>, TError,{data: WebModelPostInstallAppAndLicenses}, TContext> => {

const mutationKey = ['installAppAndLicensesOnDevice'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof installAppAndLicensesOnDevice>>, {data: WebModelPostInstallAppAndLicenses}> = (props) => {
          const {data} = props ?? {};

          return  installAppAndLicensesOnDevice(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstallAppAndLicensesOnDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof installAppAndLicensesOnDevice>>>
    export type InstallAppAndLicensesOnDeviceMutationBody = WebModelPostInstallAppAndLicenses
    export type InstallAppAndLicensesOnDeviceMutationError = AxiosError<unknown>

    /**
 * @summary Install licenses or app and licenses
 */
export const useInstallAppAndLicensesOnDevice = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installAppAndLicensesOnDevice>>, TError,{data: WebModelPostInstallAppAndLicenses}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof installAppAndLicensesOnDevice>>,
        TError,
        {data: WebModelPostInstallAppAndLicenses},
        TContext
      > => {
      return useMutation(getInstallAppAndLicensesOnDeviceMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, authorize the reactivate of a license/container
 */
export const authorizeReactivation = (
    params: MaybeRefOrGetter<AuthorizeReactivationParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelReactivation>> => {
    params = toValue(params);

    return axios.post(
      `/service/api/app-licenses/errors/reactivate`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getAuthorizeReactivationMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizeReactivation>>, TError,{params: AuthorizeReactivationParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof authorizeReactivation>>, TError,{params: AuthorizeReactivationParams}, TContext> => {

const mutationKey = ['authorizeReactivation'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authorizeReactivation>>, {params: AuthorizeReactivationParams}> = (props) => {
          const {params} = props ?? {};

          return  authorizeReactivation(params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthorizeReactivationMutationResult = NonNullable<Awaited<ReturnType<typeof authorizeReactivation>>>

    export type AuthorizeReactivationMutationError = AxiosError<unknown>

    /**
 * @summary As an admin user, authorize the reactivate of a license/container
 */
export const useAuthorizeReactivation = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizeReactivation>>, TError,{params: AuthorizeReactivationParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof authorizeReactivation>>,
        TError,
        {params: AuthorizeReactivationParams},
        TContext
      > => {
      return useMutation(getAuthorizeReactivationMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated.
 * @summary Create an AppLicense from xml license order file
 */
export const importLicensesViaLicenseOrderXmlFile = (
    importLicensesViaLicenseOrderXmlFileBody: MaybeRefOrGetter<Blob>,
    params?: MaybeRefOrGetter<ImportLicensesViaLicenseOrderXmlFileParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetLicenseImportResult>> => {
    importLicensesViaLicenseOrderXmlFileBody = toValue(importLicensesViaLicenseOrderXmlFileBody);
params = toValue(params);

    return axios.post(
      `/service/api/app-licenses/create`,
      importLicensesViaLicenseOrderXmlFileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getImportLicensesViaLicenseOrderXmlFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLicensesViaLicenseOrderXmlFile>>, TError,{data: Blob;params?: ImportLicensesViaLicenseOrderXmlFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importLicensesViaLicenseOrderXmlFile>>, TError,{data: Blob;params?: ImportLicensesViaLicenseOrderXmlFileParams}, TContext> => {

const mutationKey = ['importLicensesViaLicenseOrderXmlFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importLicensesViaLicenseOrderXmlFile>>, {data: Blob;params?: ImportLicensesViaLicenseOrderXmlFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importLicensesViaLicenseOrderXmlFile(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportLicensesViaLicenseOrderXmlFileMutationResult = NonNullable<Awaited<ReturnType<typeof importLicensesViaLicenseOrderXmlFile>>>
    export type ImportLicensesViaLicenseOrderXmlFileMutationBody = Blob
    export type ImportLicensesViaLicenseOrderXmlFileMutationError = AxiosError<unknown>

    /**
 * @summary Create an AppLicense from xml license order file
 */
export const useImportLicensesViaLicenseOrderXmlFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLicensesViaLicenseOrderXmlFile>>, TError,{data: Blob;params?: ImportLicensesViaLicenseOrderXmlFileParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof importLicensesViaLicenseOrderXmlFile>>,
        TError,
        {data: Blob;params?: ImportLicensesViaLicenseOrderXmlFileParams},
        TContext
      > => {
      return useMutation(getImportLicensesViaLicenseOrderXmlFileMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated.
 * @summary Create an AppLicense from ticketId
 */
export const createAppLicenseFromTicketId = (
    ticketid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicense>> => {
    ticketid = toValue(ticketid);

    return axios.post(
      `/service/api/app-licenses/create/ticketid/${ticketid}`,
      undefined,options
    );
  }




export const getCreateAppLicenseFromTicketIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppLicenseFromTicketId>>, TError,{ticketid: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createAppLicenseFromTicketId>>, TError,{ticketid: string}, TContext> => {

const mutationKey = ['createAppLicenseFromTicketId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAppLicenseFromTicketId>>, {ticketid: string}> = (props) => {
          const {ticketid} = props ?? {};

          return  createAppLicenseFromTicketId(ticketid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAppLicenseFromTicketIdMutationResult = NonNullable<Awaited<ReturnType<typeof createAppLicenseFromTicketId>>>

    export type CreateAppLicenseFromTicketIdMutationError = AxiosError<unknown>

    /**
 * @summary Create an AppLicense from ticketId
 */
export const useCreateAppLicenseFromTicketId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppLicenseFromTicketId>>, TError,{ticketid: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAppLicenseFromTicketId>>,
        TError,
        {ticketid: string},
        TContext
      > => {
      return useMutation(getCreateAppLicenseFromTicketIdMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and owner of the device.
 * @summary Upload a Rac-File for license activation
 */
export const activateOfflineLicense = (
    cmContainerContextFile: MaybeRefOrGetter<CmContainerContextFile>,
    params: MaybeRefOrGetter<ActivateOfflineLicenseParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CmContainerUpdateFile>> => {
    cmContainerContextFile = toValue(cmContainerContextFile);
params = toValue(params);

    return axios.post(
      `/service/api/app-licenses/activateOfflineLicense`,
      cmContainerContextFile,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getActivateOfflineLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateOfflineLicense>>, TError,{data: CmContainerContextFile;params: ActivateOfflineLicenseParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof activateOfflineLicense>>, TError,{data: CmContainerContextFile;params: ActivateOfflineLicenseParams}, TContext> => {

const mutationKey = ['activateOfflineLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateOfflineLicense>>, {data: CmContainerContextFile;params: ActivateOfflineLicenseParams}> = (props) => {
          const {data,params} = props ?? {};

          return  activateOfflineLicense(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateOfflineLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof activateOfflineLicense>>>
    export type ActivateOfflineLicenseMutationBody = CmContainerContextFile
    export type ActivateOfflineLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Upload a Rac-File for license activation
 */
export const useActivateOfflineLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateOfflineLicense>>, TError,{data: CmContainerContextFile;params: ActivateOfflineLicenseParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateOfflineLicense>>,
        TError,
        {data: CmContainerContextFile;params: ActivateOfflineLicenseParams},
        TContext
      > => {
      return useMutation(getActivateOfflineLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is store admin
 * @summary Search users by role
 */
export const findUsersByRole = (
    params?: MaybeRefOrGetter<FindUsersByRoleParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUser[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindUsersByRoleQueryKey = (params?: MaybeRefOrGetter<FindUsersByRoleParams>,) => {
    return [
    'service','api','users', ...(params ? [params] : [])
    ] as const;
    }


export const getFindUsersByRoleQueryOptions = <TData = Awaited<ReturnType<typeof findUsersByRole>>, TError = AxiosError<unknown>>(params?: MaybeRefOrGetter<FindUsersByRoleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUsersByRole>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindUsersByRoleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUsersByRole>>> = ({ signal }) => findUsersByRole(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUsersByRole>>, TError, TData>
}

export type FindUsersByRoleQueryResult = NonNullable<Awaited<ReturnType<typeof findUsersByRole>>>
export type FindUsersByRoleQueryError = AxiosError<unknown>


/**
 * @summary Search users by role
 */

export function useFindUsersByRole<TData = Awaited<ReturnType<typeof findUsersByRole>>, TError = AxiosError<unknown>>(
 params?: MaybeRefOrGetter<FindUsersByRoleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUsersByRole>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUsersByRoleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated.
 * @summary List the apps a user is subscribed to
 */
export const getAppSubscriptions = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUserAppSubscription[]>> => {
    uuid = toValue(uuid);

    return axios.get(
      `/service/api/users/${uuid}/subscriptions/app`,options
    );
  }




export const getGetAppSubscriptionsQueryKey = (uuid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','users',uuid,'subscriptions','app'
    ] as const;
    }


export const getGetAppSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAppSubscriptions>>, TError = AxiosError<unknown>>(uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppSubscriptionsQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppSubscriptions>>> = ({ signal }) => getAppSubscriptions(uuid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uuid) !== null && toValue(uuid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppSubscriptions>>, TError, TData>
}

export type GetAppSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppSubscriptions>>>
export type GetAppSubscriptionsQueryError = AxiosError<unknown>


/**
 * @summary List the apps a user is subscribed to
 */

export function useGetAppSubscriptions<TData = Awaited<ReturnType<typeof getAppSubscriptions>>, TError = AxiosError<unknown>>(
 uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppSubscriptionsQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated.
 * @summary Get all company invites that have not expired for a user
 */
export const getAllUserCompanyInvites = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyInvite[]>> => {
    uuid = toValue(uuid);

    return axios.get(
      `/service/api/users/${uuid}/company-invites`,options
    );
  }




export const getGetAllUserCompanyInvitesQueryKey = (uuid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','users',uuid,'company-invites'
    ] as const;
    }


export const getGetAllUserCompanyInvitesQueryOptions = <TData = Awaited<ReturnType<typeof getAllUserCompanyInvites>>, TError = AxiosError<unknown>>(uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUserCompanyInvites>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllUserCompanyInvitesQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUserCompanyInvites>>> = ({ signal }) => getAllUserCompanyInvites(uuid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uuid) !== null && toValue(uuid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllUserCompanyInvites>>, TError, TData>
}

export type GetAllUserCompanyInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUserCompanyInvites>>>
export type GetAllUserCompanyInvitesQueryError = AxiosError<unknown>


/**
 * @summary Get all company invites that have not expired for a user
 */

export function useGetAllUserCompanyInvites<TData = Awaited<ReturnType<typeof getAllUserCompanyInvites>>, TError = AxiosError<unknown>>(
 uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUserCompanyInvites>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllUserCompanyInvitesQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: No need to be authenticated.
 * @summary Returns app info based on a unsubscribe token
 */
export const getAppInfoByUnsubscribeToken = (
    token: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUserAppSubscription>> => {
    token = toValue(token);

    return axios.get(
      `/service/api/users/unsubscribe/app/${token}`,options
    );
  }




export const getGetAppInfoByUnsubscribeTokenQueryKey = (token: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','users','unsubscribe','app',token
    ] as const;
    }


export const getGetAppInfoByUnsubscribeTokenQueryOptions = <TData = Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>, TError = AxiosError<unknown>>(token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppInfoByUnsubscribeTokenQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>> = ({ signal }) => getAppInfoByUnsubscribeToken(token, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(token) !== null && toValue(token) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>, TError, TData>
}

export type GetAppInfoByUnsubscribeTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>>
export type GetAppInfoByUnsubscribeTokenQueryError = AxiosError<unknown>


/**
 * @summary Returns app info based on a unsubscribe token
 */

export function useGetAppInfoByUnsubscribeToken<TData = Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>, TError = AxiosError<unknown>>(
 token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppInfoByUnsubscribeToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppInfoByUnsubscribeTokenQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: No need to be authenticated.
 * @summary Removes the app update subscription referenced by a token
 */
export const removeAppUpdateSubscriptionByToken = (
    token: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    token = toValue(token);

    return axios.delete(
      `/service/api/users/unsubscribe/app/${token}`,options
    );
  }




export const getRemoveAppUpdateSubscriptionByTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAppUpdateSubscriptionByToken>>, TError,{token: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeAppUpdateSubscriptionByToken>>, TError,{token: string}, TContext> => {

const mutationKey = ['removeAppUpdateSubscriptionByToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAppUpdateSubscriptionByToken>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  removeAppUpdateSubscriptionByToken(token,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAppUpdateSubscriptionByTokenMutationResult = NonNullable<Awaited<ReturnType<typeof removeAppUpdateSubscriptionByToken>>>

    export type RemoveAppUpdateSubscriptionByTokenMutationError = AxiosError<unknown>

    /**
 * @summary Removes the app update subscription referenced by a token
 */
export const useRemoveAppUpdateSubscriptionByToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAppUpdateSubscriptionByToken>>, TError,{token: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeAppUpdateSubscriptionByToken>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getRemoveAppUpdateSubscriptionByTokenMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User is store admin or user is requested user himself
 * @summary Get a list of invalid sections (invalidSection: 1 = User_Data, 2 = Company_Data, 3 = Company_Profile)
 */
export const getUserStatus = (
    params: MaybeRefOrGetter<GetUserStatusParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserStatus200Item[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/users/status`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetUserStatusQueryKey = (params?: MaybeRefOrGetter<GetUserStatusParams>,) => {
    return [
    'service','api','users','status', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetUserStatusParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetUserStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatus>>> = ({ signal }) => getUserStatus(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>
}

export type GetUserStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStatus>>>
export type GetUserStatusQueryError = AxiosError<unknown>


/**
 * @summary Get a list of invalid sections (invalidSection: 1 = User_Data, 2 = Company_Data, 3 = Company_Profile)
 */

export function useGetUserStatus<TData = Awaited<ReturnType<typeof getUserStatus>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetUserStatusParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatus>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is in the requested company
 * @summary Search users by company (public profile)
 */
export const findPublicCompanyUsers = (
    params: MaybeRefOrGetter<FindPublicCompanyUsersParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PublicUser[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/users/public-profile`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindPublicCompanyUsersQueryKey = (params?: MaybeRefOrGetter<FindPublicCompanyUsersParams>,) => {
    return [
    'service','api','users','public-profile', ...(params ? [params] : [])
    ] as const;
    }


export const getFindPublicCompanyUsersQueryOptions = <TData = Awaited<ReturnType<typeof findPublicCompanyUsers>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindPublicCompanyUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPublicCompanyUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindPublicCompanyUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPublicCompanyUsers>>> = ({ signal }) => findPublicCompanyUsers(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPublicCompanyUsers>>, TError, TData>
}

export type FindPublicCompanyUsersQueryResult = NonNullable<Awaited<ReturnType<typeof findPublicCompanyUsers>>>
export type FindPublicCompanyUsersQueryError = AxiosError<unknown>


/**
 * @summary Search users by company (public profile)
 */

export function useFindPublicCompanyUsers<TData = Awaited<ReturnType<typeof findPublicCompanyUsers>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindPublicCompanyUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPublicCompanyUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPublicCompanyUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Search a public user by uuid
 */
export const findPublicUser = (
    uuid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PublicUser>> => {
    uuid = toValue(uuid);

    return axios.get(
      `/service/api/users/public-profile/${uuid}`,options
    );
  }




export const getFindPublicUserQueryKey = (uuid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','users','public-profile',uuid
    ] as const;
    }


export const getFindPublicUserQueryOptions = <TData = Awaited<ReturnType<typeof findPublicUser>>, TError = AxiosError<unknown>>(uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPublicUser>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindPublicUserQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPublicUser>>> = ({ signal }) => findPublicUser(uuid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uuid) !== null && toValue(uuid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPublicUser>>, TError, TData>
}

export type FindPublicUserQueryResult = NonNullable<Awaited<ReturnType<typeof findPublicUser>>>
export type FindPublicUserQueryError = AxiosError<unknown>


/**
 * @summary Search a public user by uuid
 */

export function useFindPublicUser<TData = Awaited<ReturnType<typeof findPublicUser>>, TError = AxiosError<unknown>>(
 uuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPublicUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPublicUserQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: No auth required
 * @summary Returns information from the mfa-token cookie
 */
export const getMfaDeviceTokenInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelMfaDeviceTokenInfoResponse>> => {


    return axios.get(
      `/service/api/users/mfa/device-token`,options
    );
  }




export const getGetMfaDeviceTokenInfoQueryKey = () => {
    return [
    'service','api','users','mfa','device-token'
    ] as const;
    }


export const getGetMfaDeviceTokenInfoQueryOptions = <TData = Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetMfaDeviceTokenInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>> = ({ signal }) => getMfaDeviceTokenInfo({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>, TError, TData>
}

export type GetMfaDeviceTokenInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>>
export type GetMfaDeviceTokenInfoQueryError = AxiosError<unknown>


/**
 * @summary Returns information from the mfa-token cookie
 */

export function useGetMfaDeviceTokenInfo<TData = Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaDeviceTokenInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMfaDeviceTokenInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated.
 * @summary Refresh the JWT authentication token cookie from the DB
 */
export const refreshJwtAuthToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.get(
      `/service/api/users/jwt/refresh`,options
    );
  }




export const getRefreshJwtAuthTokenQueryKey = () => {
    return [
    'service','api','users','jwt','refresh'
    ] as const;
    }


export const getRefreshJwtAuthTokenQueryOptions = <TData = Awaited<ReturnType<typeof refreshJwtAuthToken>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshJwtAuthToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getRefreshJwtAuthTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof refreshJwtAuthToken>>> = ({ signal }) => refreshJwtAuthToken({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof refreshJwtAuthToken>>, TError, TData>
}

export type RefreshJwtAuthTokenQueryResult = NonNullable<Awaited<ReturnType<typeof refreshJwtAuthToken>>>
export type RefreshJwtAuthTokenQueryError = AxiosError<unknown>


/**
 * @summary Refresh the JWT authentication token cookie from the DB
 */

export function useRefreshJwtAuthToken<TData = Awaited<ReturnType<typeof refreshJwtAuthToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshJwtAuthToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRefreshJwtAuthTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Provides user information (uuid) if the JWT token is for logged in user
 */
export const jwtTokenInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JwtTokenInfo200>> => {


    return axios.get(
      `/service/api/users/jwt/info`,options
    );
  }




export const getJwtTokenInfoQueryKey = () => {
    return [
    'service','api','users','jwt','info'
    ] as const;
    }


export const getJwtTokenInfoQueryOptions = <TData = Awaited<ReturnType<typeof jwtTokenInfo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jwtTokenInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getJwtTokenInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jwtTokenInfo>>> = ({ signal }) => jwtTokenInfo({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jwtTokenInfo>>, TError, TData>
}

export type JwtTokenInfoQueryResult = NonNullable<Awaited<ReturnType<typeof jwtTokenInfo>>>
export type JwtTokenInfoQueryError = AxiosError<unknown>


/**
 * @summary Provides user information (uuid) if the JWT token is for logged in user
 */

export function useJwtTokenInfo<TData = Awaited<ReturnType<typeof jwtTokenInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jwtTokenInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJwtTokenInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Creates a GUEST user JWT token
 */
export const createGuestJwtAuthToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.get(
      `/service/api/users/jwt/guest/authenticate`,options
    );
  }




export const getCreateGuestJwtAuthTokenQueryKey = () => {
    return [
    'service','api','users','jwt','guest','authenticate'
    ] as const;
    }


export const getCreateGuestJwtAuthTokenQueryOptions = <TData = Awaited<ReturnType<typeof createGuestJwtAuthToken>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGuestJwtAuthToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getCreateGuestJwtAuthTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createGuestJwtAuthToken>>> = ({ signal }) => createGuestJwtAuthToken({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createGuestJwtAuthToken>>, TError, TData>
}

export type CreateGuestJwtAuthTokenQueryResult = NonNullable<Awaited<ReturnType<typeof createGuestJwtAuthToken>>>
export type CreateGuestJwtAuthTokenQueryError = AxiosError<unknown>


/**
 * @summary Creates a GUEST user JWT token
 */

export function useCreateGuestJwtAuthToken<TData = Awaited<ReturnType<typeof createGuestJwtAuthToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGuestJwtAuthToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateGuestJwtAuthTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Search a user by token and create a JWT authentication token cookie for it. User must be active.
 */
export const createJwtAuthTokenByIdentifier = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.get(
      `/service/api/users/jwt/authenticate`,options
    );
  }




export const getCreateJwtAuthTokenByIdentifierQueryKey = () => {
    return [
    'service','api','users','jwt','authenticate'
    ] as const;
    }


export const getCreateJwtAuthTokenByIdentifierQueryOptions = <TData = Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getCreateJwtAuthTokenByIdentifierQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>> = ({ signal }) => createJwtAuthTokenByIdentifier({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>, TError, TData>
}

export type CreateJwtAuthTokenByIdentifierQueryResult = NonNullable<Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>>
export type CreateJwtAuthTokenByIdentifierQueryError = AxiosError<unknown>


/**
 * @summary Search a user by token and create a JWT authentication token cookie for it. User must be active.
 */

export function useCreateJwtAuthTokenByIdentifier<TData = Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createJwtAuthTokenByIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateJwtAuthTokenByIdentifierQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is store admin or user is requested user himself
 * @summary Search an user by user name, email or uuid
 */
export const findUserByIdentifier = (
    params: MaybeRefOrGetter<FindUserByIdentifierParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetUserWithIdmInfos>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/users/identifier`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindUserByIdentifierQueryKey = (params?: MaybeRefOrGetter<FindUserByIdentifierParams>,) => {
    return [
    'service','api','users','identifier', ...(params ? [params] : [])
    ] as const;
    }


export const getFindUserByIdentifierQueryOptions = <TData = Awaited<ReturnType<typeof findUserByIdentifier>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindUserByIdentifierParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserByIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindUserByIdentifierQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUserByIdentifier>>> = ({ signal }) => findUserByIdentifier(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUserByIdentifier>>, TError, TData>
}

export type FindUserByIdentifierQueryResult = NonNullable<Awaited<ReturnType<typeof findUserByIdentifier>>>
export type FindUserByIdentifierQueryError = AxiosError<unknown>


/**
 * @summary Search an user by user name, email or uuid
 */

export function useFindUserByIdentifier<TData = Awaited<ReturnType<typeof findUserByIdentifier>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindUserByIdentifierParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserByIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserByIdentifierQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is store admin or user is requested user himself
 * @summary Find the hub and country for a user
 */
export const findHubForUser = (
    params?: MaybeRefOrGetter<FindHubForUserParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelCountryAndHubForUser>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/users/hub`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindHubForUserQueryKey = (params?: MaybeRefOrGetter<FindHubForUserParams>,) => {
    return [
    'service','api','users','hub', ...(params ? [params] : [])
    ] as const;
    }


export const getFindHubForUserQueryOptions = <TData = Awaited<ReturnType<typeof findHubForUser>>, TError = AxiosError<unknown>>(params?: MaybeRefOrGetter<FindHubForUserParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findHubForUser>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindHubForUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findHubForUser>>> = ({ signal }) => findHubForUser(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findHubForUser>>, TError, TData>
}

export type FindHubForUserQueryResult = NonNullable<Awaited<ReturnType<typeof findHubForUser>>>
export type FindHubForUserQueryError = AxiosError<unknown>


/**
 * @summary Find the hub and country for a user
 */

export function useFindHubForUser<TData = Awaited<ReturnType<typeof findHubForUser>>, TError = AxiosError<unknown>>(
 params?: MaybeRefOrGetter<FindHubForUserParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findHubForUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindHubForUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is admin or user is requesting user
 * @summary Get user roles by UUID or token
 */
export const findUserRoles = (
    params: MaybeRefOrGetter<FindUserRolesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Role[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/user-principals/roles`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindUserRolesQueryKey = (params?: MaybeRefOrGetter<FindUserRolesParams>,) => {
    return [
    'service','api','user-principals','roles', ...(params ? [params] : [])
    ] as const;
    }


export const getFindUserRolesQueryOptions = <TData = Awaited<ReturnType<typeof findUserRoles>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindUserRolesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserRoles>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindUserRolesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUserRoles>>> = ({ signal }) => findUserRoles(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUserRoles>>, TError, TData>
}

export type FindUserRolesQueryResult = NonNullable<Awaited<ReturnType<typeof findUserRoles>>>
export type FindUserRolesQueryError = AxiosError<unknown>


/**
 * @summary Get user roles by UUID or token
 */

export function useFindUserRoles<TData = Awaited<ReturnType<typeof findUserRoles>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindUserRolesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserRoles>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserRolesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated
 * @summary Get trial code information by code of trial code
 */
export const getTrialCodeByCode = (
    code: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetTrialCode>> => {
    code = toValue(code);

    return axios.get(
      `/service/api/trial-codes/${code}`,options
    );
  }




export const getGetTrialCodeByCodeQueryKey = (code: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','trial-codes',code
    ] as const;
    }


export const getGetTrialCodeByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getTrialCodeByCode>>, TError = AxiosError<unknown>>(code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialCodeByCode>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetTrialCodeByCodeQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrialCodeByCode>>> = ({ signal }) => getTrialCodeByCode(code, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(code) !== null && toValue(code) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrialCodeByCode>>, TError, TData>
}

export type GetTrialCodeByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getTrialCodeByCode>>>
export type GetTrialCodeByCodeQueryError = AxiosError<unknown>


/**
 * @summary Get trial code information by code of trial code
 */

export function useGetTrialCodeByCode<TData = Awaited<ReturnType<typeof getTrialCodeByCode>>, TError = AxiosError<unknown>>(
 code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialCodeByCode>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrialCodeByCodeQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated
 * @summary Get extended trial code information by code of trial code
 */
export const getExtendedTrialCodeInfo = (
    code: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetExtendedTrialCode>> => {
    code = toValue(code);

    return axios.get(
      `/service/api/trial-codes/extended-info/${code}`,options
    );
  }




export const getGetExtendedTrialCodeInfoQueryKey = (code: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','trial-codes','extended-info',code
    ] as const;
    }


export const getGetExtendedTrialCodeInfoQueryOptions = <TData = Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>, TError = AxiosError<unknown>>(code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetExtendedTrialCodeInfoQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>> = ({ signal }) => getExtendedTrialCodeInfo(code, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(code) !== null && toValue(code) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>, TError, TData>
}

export type GetExtendedTrialCodeInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>>
export type GetExtendedTrialCodeInfoQueryError = AxiosError<unknown>


/**
 * @summary Get extended trial code information by code of trial code
 */

export function useGetExtendedTrialCodeInfo<TData = Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>, TError = AxiosError<unknown>>(
 code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExtendedTrialCodeInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExtendedTrialCodeInfoQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is device owner
 * @summary Get requsted actions for a device
 */
export const getRequstedActions = (
    deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetRequstedActionsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetRequstedAction[]>> => {
    deviceid = toValue(deviceid);
params = toValue(params);

    return axios.get(
      `/service/api/requested-actions/devices/${deviceid}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetRequstedActionsQueryKey = (deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetRequstedActionsParams>,) => {
    return [
    'service','api','requested-actions','devices',deviceid, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRequstedActionsQueryOptions = <TData = Awaited<ReturnType<typeof getRequstedActions>>, TError = AxiosError<unknown>>(deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetRequstedActionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequstedActions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetRequstedActionsQueryKey(deviceid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequstedActions>>> = ({ signal }) => getRequstedActions(deviceid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(deviceid) !== null && toValue(deviceid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequstedActions>>, TError, TData>
}

export type GetRequstedActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequstedActions>>>
export type GetRequstedActionsQueryError = AxiosError<unknown>


/**
 * @summary Get requsted actions for a device
 */

export function useGetRequstedActions<TData = Awaited<ReturnType<typeof getRequstedActions>>, TError = AxiosError<unknown>>(
 deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetRequstedActionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequstedActions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRequstedActionsQueryOptions(deviceid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Export payments as csv
 */
export const exportPaymentsCsv = (
    hubid: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<ExportPaymentsCsvParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ExportPaymentsCsv200>> => {
    hubid = toValue(hubid);
params = toValue(params);

    return axios.get(
      `/service/api/payments/export/hubs/${hubid}`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getExportPaymentsCsvQueryKey = (hubid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ExportPaymentsCsvParams>,) => {
    return [
    'service','api','payments','export','hubs',hubid, ...(params ? [params] : [])
    ] as const;
    }


export const getExportPaymentsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportPaymentsCsv>>, TError = AxiosError<unknown>>(hubid: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<ExportPaymentsCsvParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPaymentsCsv>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getExportPaymentsCsvQueryKey(hubid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPaymentsCsv>>> = ({ signal }) => exportPaymentsCsv(hubid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(hubid) !== null && toValue(hubid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportPaymentsCsv>>, TError, TData>
}

export type ExportPaymentsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportPaymentsCsv>>>
export type ExportPaymentsCsvQueryError = AxiosError<unknown>


/**
 * @summary Export payments as csv
 */

export function useExportPaymentsCsv<TData = Awaited<ReturnType<typeof exportPaymentsCsv>>, TError = AxiosError<unknown>>(
 hubid: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<ExportPaymentsCsvParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportPaymentsCsv>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportPaymentsCsvQueryOptions(hubid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get an error code translation for an novalnet error code
 */
export const getNovalnetErrorCodeTranslation = (
    params: MaybeRefOrGetter<GetNovalnetErrorCodeTranslationParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/payments/errorcode_translation`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetNovalnetErrorCodeTranslationQueryKey = (params?: MaybeRefOrGetter<GetNovalnetErrorCodeTranslationParams>,) => {
    return [
    'service','api','payments','errorcode_translation', ...(params ? [params] : [])
    ] as const;
    }


export const getGetNovalnetErrorCodeTranslationQueryOptions = <TData = Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetNovalnetErrorCodeTranslationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetNovalnetErrorCodeTranslationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>> = ({ signal }) => getNovalnetErrorCodeTranslation(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>, TError, TData>
}

export type GetNovalnetErrorCodeTranslationQueryResult = NonNullable<Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>>
export type GetNovalnetErrorCodeTranslationQueryError = AxiosError<unknown>


/**
 * @summary Get an error code translation for an novalnet error code
 */

export function useGetNovalnetErrorCodeTranslation<TData = Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetNovalnetErrorCodeTranslationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNovalnetErrorCodeTranslation>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNovalnetErrorCodeTranslationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Search order by criteria
 */
export const findOrders = (
    params: MaybeRefOrGetter<FindOrdersParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetOrder[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/orders`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindOrdersQueryKey = (params?: MaybeRefOrGetter<FindOrdersParams>,) => {
    return [
    'service','api','orders', ...(params ? [params] : [])
    ] as const;
    }


export const getFindOrdersQueryOptions = <TData = Awaited<ReturnType<typeof findOrders>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindOrdersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOrders>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOrders>>> = ({ signal }) => findOrders(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findOrders>>, TError, TData>
}

export type FindOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof findOrders>>>
export type FindOrdersQueryError = AxiosError<unknown>


/**
 * @summary Search order by criteria
 */

export function useFindOrders<TData = Awaited<ReturnType<typeof findOrders>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindOrdersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOrders>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Generate invoice for order
 */
export const generateInvoice = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/orders/${id}/invoice`,{
        responseType: 'blob',
    ...options,}
    );
  }




export const getGenerateInvoiceQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','orders',id,'invoice'
    ] as const;
    }


export const getGenerateInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof generateInvoice>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGenerateInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof generateInvoice>>> = ({ signal }) => generateInvoice(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof generateInvoice>>, TError, TData>
}

export type GenerateInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof generateInvoice>>>
export type GenerateInvoiceQueryError = AxiosError<unknown>


/**
 * @summary Generate invoice for order
 */

export function useGenerateInvoice<TData = Awaited<ReturnType<typeof generateInvoice>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateInvoice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenerateInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Generate credit note for order
 */
export const generateCreditNote = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/orders/${id}/creditNote`,{
        responseType: 'blob',
    ...options,}
    );
  }




export const getGenerateCreditNoteQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','orders',id,'creditNote'
    ] as const;
    }


export const getGenerateCreditNoteQueryOptions = <TData = Awaited<ReturnType<typeof generateCreditNote>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateCreditNote>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGenerateCreditNoteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof generateCreditNote>>> = ({ signal }) => generateCreditNote(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof generateCreditNote>>, TError, TData>
}

export type GenerateCreditNoteQueryResult = NonNullable<Awaited<ReturnType<typeof generateCreditNote>>>
export type GenerateCreditNoteQueryError = AxiosError<unknown>


/**
 * @summary Generate credit note for order
 */

export function useGenerateCreditNote<TData = Awaited<ReturnType<typeof generateCreditNote>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateCreditNote>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenerateCreditNoteQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get a license option by id
 */
export const getLicenseOptionById = (
    licenseOptionId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicenseOption>> => {
    licenseOptionId = toValue(licenseOptionId);

    return axios.get(
      `/service/api/license-options/${licenseOptionId}`,options
    );
  }




export const getGetLicenseOptionByIdQueryKey = (licenseOptionId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','license-options',licenseOptionId
    ] as const;
    }


export const getGetLicenseOptionByIdQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseOptionById>>, TError = AxiosError<unknown>>(licenseOptionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseOptionById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetLicenseOptionByIdQueryKey(licenseOptionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseOptionById>>> = ({ signal }) => getLicenseOptionById(licenseOptionId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(licenseOptionId) !== null && toValue(licenseOptionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseOptionById>>, TError, TData>
}

export type GetLicenseOptionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseOptionById>>>
export type GetLicenseOptionByIdQueryError = AxiosError<unknown>


/**
 * @summary Get a license option by id
 */

export function useGetLicenseOptionById<TData = Awaited<ReturnType<typeof getLicenseOptionById>>, TError = AxiosError<unknown>>(
 licenseOptionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseOptionById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicenseOptionByIdQueryOptions(licenseOptionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, get license information from wibu for a ticketid
 */
export const adminGetLicenseInformationByTicketId = (
    ticketid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    ticketid = toValue(ticketid);

    return axios.get(
      `/service/api/license-info/ticketid/${ticketid}`,{
        responseType: 'text',
    ...options,}
    );
  }




export const getAdminGetLicenseInformationByTicketIdQueryKey = (ticketid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','license-info','ticketid',ticketid
    ] as const;
    }


export const getAdminGetLicenseInformationByTicketIdQueryOptions = <TData = Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>, TError = AxiosError<unknown>>(ticketid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getAdminGetLicenseInformationByTicketIdQueryKey(ticketid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>> = ({ signal }) => adminGetLicenseInformationByTicketId(ticketid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ticketid) !== null && toValue(ticketid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>, TError, TData>
}

export type AdminGetLicenseInformationByTicketIdQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>>
export type AdminGetLicenseInformationByTicketIdQueryError = AxiosError<unknown>


/**
 * @summary As an admin user, get license information from wibu for a ticketid
 */

export function useAdminGetLicenseInformationByTicketId<TData = Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>, TError = AxiosError<unknown>>(
 ticketid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLicenseInformationByTicketId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetLicenseInformationByTicketIdQueryOptions(ticketid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, get license information from wibu for a container id
 */
export const adminGetLicenseInformationbyContainerId = (
    containerid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    containerid = toValue(containerid);

    return axios.get(
      `/service/api/license-info/containerid/${containerid}`,{
        responseType: 'text',
    ...options,}
    );
  }




export const getAdminGetLicenseInformationbyContainerIdQueryKey = (containerid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','license-info','containerid',containerid
    ] as const;
    }


export const getAdminGetLicenseInformationbyContainerIdQueryOptions = <TData = Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>, TError = AxiosError<unknown>>(containerid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getAdminGetLicenseInformationbyContainerIdQueryKey(containerid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>> = ({ signal }) => adminGetLicenseInformationbyContainerId(containerid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(containerid) !== null && toValue(containerid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>, TError, TData>
}

export type AdminGetLicenseInformationbyContainerIdQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>>
export type AdminGetLicenseInformationbyContainerIdQueryError = AxiosError<unknown>


/**
 * @summary As an admin user, get license information from wibu for a container id
 */

export function useAdminGetLicenseInformationbyContainerId<TData = Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>, TError = AxiosError<unknown>>(
 containerid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLicenseInformationbyContainerId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetLicenseInformationbyContainerIdQueryOptions(containerid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get all license container types
 */
export const getAllLicenseContainerTypes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetLicenseContainerType[]>> => {


    return axios.get(
      `/service/api/license-container-types`,options
    );
  }




export const getGetAllLicenseContainerTypesQueryKey = () => {
    return [
    'service','api','license-container-types'
    ] as const;
    }


export const getGetAllLicenseContainerTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllLicenseContainerTypes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLicenseContainerTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllLicenseContainerTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLicenseContainerTypes>>> = ({ signal }) => getAllLicenseContainerTypes({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLicenseContainerTypes>>, TError, TData>
}

export type GetAllLicenseContainerTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLicenseContainerTypes>>>
export type GetAllLicenseContainerTypesQueryError = AxiosError<unknown>


/**
 * @summary Get all license container types
 */

export function useGetAllLicenseContainerTypes<TData = Awaited<ReturnType<typeof getAllLicenseContainerTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLicenseContainerTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllLicenseContainerTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Export kpi as json
 */
export const exportKPIsAsWebModel = (
    params: MaybeRefOrGetter<ExportKPIsAsWebModelParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetKPI[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/kpi/json-export`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getExportKPIsAsWebModelQueryKey = (params?: MaybeRefOrGetter<ExportKPIsAsWebModelParams>,) => {
    return [
    'service','api','kpi','json-export', ...(params ? [params] : [])
    ] as const;
    }


export const getExportKPIsAsWebModelQueryOptions = <TData = Awaited<ReturnType<typeof exportKPIsAsWebModel>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<ExportKPIsAsWebModelParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportKPIsAsWebModel>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getExportKPIsAsWebModelQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportKPIsAsWebModel>>> = ({ signal }) => exportKPIsAsWebModel(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportKPIsAsWebModel>>, TError, TData>
}

export type ExportKPIsAsWebModelQueryResult = NonNullable<Awaited<ReturnType<typeof exportKPIsAsWebModel>>>
export type ExportKPIsAsWebModelQueryError = AxiosError<unknown>


/**
 * @summary Export kpi as json
 */

export function useExportKPIsAsWebModel<TData = Awaited<ReturnType<typeof exportKPIsAsWebModel>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<ExportKPIsAsWebModelParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportKPIsAsWebModel>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportKPIsAsWebModelQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Export kpi as csv
 */
export const exportKPIsAsCsv = (
    params: MaybeRefOrGetter<ExportKPIsAsCsvParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/kpi/csv-export`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getExportKPIsAsCsvQueryKey = (params?: MaybeRefOrGetter<ExportKPIsAsCsvParams>,) => {
    return [
    'service','api','kpi','csv-export', ...(params ? [params] : [])
    ] as const;
    }


export const getExportKPIsAsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportKPIsAsCsv>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<ExportKPIsAsCsvParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportKPIsAsCsv>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getExportKPIsAsCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportKPIsAsCsv>>> = ({ signal }) => exportKPIsAsCsv(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportKPIsAsCsv>>, TError, TData>
}

export type ExportKPIsAsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportKPIsAsCsv>>>
export type ExportKPIsAsCsvQueryError = AxiosError<unknown>


/**
 * @summary Export kpi as csv
 */

export function useExportKPIsAsCsv<TData = Awaited<ReturnType<typeof exportKPIsAsCsv>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<ExportKPIsAsCsvParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportKPIsAsCsv>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportKPIsAsCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get all knowlegdebase documents
 */
export const getAllKnowlegdebaseDocuments = (
    params: MaybeRefOrGetter<GetAllKnowlegdebaseDocumentsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelKnowledgeBaseDocument[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/knowlegdebase`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllKnowlegdebaseDocumentsQueryKey = (params?: MaybeRefOrGetter<GetAllKnowlegdebaseDocumentsParams>,) => {
    return [
    'service','api','knowlegdebase', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAllKnowlegdebaseDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetAllKnowlegdebaseDocumentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllKnowlegdebaseDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>> = ({ signal }) => getAllKnowlegdebaseDocuments(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>, TError, TData>
}

export type GetAllKnowlegdebaseDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>>
export type GetAllKnowlegdebaseDocumentsQueryError = AxiosError<unknown>


/**
 * @summary Get all knowlegdebase documents
 */

export function useGetAllKnowlegdebaseDocuments<TData = Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetAllKnowlegdebaseDocumentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllKnowlegdebaseDocuments>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllKnowlegdebaseDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Invalidate knowlegdebase documents and load new
 */
export const invalidateKnowlegdebaseDocuments = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.delete(
      `/service/api/knowlegdebase`,options
    );
  }




export const getInvalidateKnowlegdebaseDocumentsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateKnowlegdebaseDocuments>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof invalidateKnowlegdebaseDocuments>>, TError,void, TContext> => {

const mutationKey = ['invalidateKnowlegdebaseDocuments'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invalidateKnowlegdebaseDocuments>>, void> = () => {


          return  invalidateKnowlegdebaseDocuments(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvalidateKnowlegdebaseDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateKnowlegdebaseDocuments>>>

    export type InvalidateKnowlegdebaseDocumentsMutationError = AxiosError<unknown>

    /**
 * @summary Invalidate knowlegdebase documents and load new
 */
export const useInvalidateKnowlegdebaseDocuments = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateKnowlegdebaseDocuments>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof invalidateKnowlegdebaseDocuments>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getInvalidateKnowlegdebaseDocumentsMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated. User has to be a store admin.
 * @summary Get all journal entries
 */
export const getJournals = (
    params?: MaybeRefOrGetter<GetJournalsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournal[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/journals`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetJournalsQueryKey = (params?: MaybeRefOrGetter<GetJournalsParams>,) => {
    return [
    'service','api','journals', ...(params ? [params] : [])
    ] as const;
    }


export const getGetJournalsQueryOptions = <TData = Awaited<ReturnType<typeof getJournals>>, TError = AxiosError<unknown>>(params?: MaybeRefOrGetter<GetJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetJournalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournals>>> = ({ signal }) => getJournals(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJournals>>, TError, TData>
}

export type GetJournalsQueryResult = NonNullable<Awaited<ReturnType<typeof getJournals>>>
export type GetJournalsQueryError = AxiosError<unknown>


/**
 * @summary Get all journal entries
 */

export function useGetJournals<TData = Awaited<ReturnType<typeof getJournals>>, TError = AxiosError<unknown>>(
 params?: MaybeRefOrGetter<GetJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJournalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be the user.
 * @summary Get all journal entries for a specific user
 */
export const getUserJournals = (
    userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournal[]>> => {
    userid = toValue(userid);
params = toValue(params);

    return axios.get(
      `/service/api/journals/users/${userid}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetUserJournalsQueryKey = (userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalsParams>,) => {
    return [
    'service','api','journals','users',userid, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserJournalsQueryOptions = <TData = Awaited<ReturnType<typeof getUserJournals>>, TError = AxiosError<unknown>>(userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetUserJournalsQueryKey(userid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserJournals>>> = ({ signal }) => getUserJournals(userid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userid) !== null && toValue(userid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserJournals>>, TError, TData>
}

export type GetUserJournalsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserJournals>>>
export type GetUserJournalsQueryError = AxiosError<unknown>


/**
 * @summary Get all journal entries for a specific user
 */

export function useGetUserJournals<TData = Awaited<ReturnType<typeof getUserJournals>>, TError = AxiosError<unknown>>(
 userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserJournalsQueryOptions(userid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be the user.
 * @summary Get all supported journal events (event types) for a specific user
 */
export const getUserJournalEvents = (
    userid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGenericEnum[]>> => {
    userid = toValue(userid);

    return axios.get(
      `/service/api/journals/users/${userid}/journalevents`,options
    );
  }




export const getGetUserJournalEventsQueryKey = (userid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','journals','users',userid,'journalevents'
    ] as const;
    }


export const getGetUserJournalEventsQueryOptions = <TData = Awaited<ReturnType<typeof getUserJournalEvents>>, TError = AxiosError<unknown>>(userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetUserJournalEventsQueryKey(userid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserJournalEvents>>> = ({ signal }) => getUserJournalEvents(userid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userid) !== null && toValue(userid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserJournalEvents>>, TError, TData>
}

export type GetUserJournalEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserJournalEvents>>>
export type GetUserJournalEventsQueryError = AxiosError<unknown>


/**
 * @summary Get all supported journal events (event types) for a specific user
 */

export function useGetUserJournalEvents<TData = Awaited<ReturnType<typeof getUserJournalEvents>>, TError = AxiosError<unknown>>(
 userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserJournalEventsQueryOptions(userid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be the user.
 * @summary Get count of all journal entries for a specific user
 */
export const getUserJournalCount = (
    userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalCountParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournalCount>> => {
    userid = toValue(userid);
params = toValue(params);

    return axios.get(
      `/service/api/journals/users/${userid}/count`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetUserJournalCountQueryKey = (userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalCountParams>,) => {
    return [
    'service','api','journals','users',userid,'count', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserJournalCountQueryOptions = <TData = Awaited<ReturnType<typeof getUserJournalCount>>, TError = AxiosError<unknown>>(userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserJournalCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetUserJournalCountQueryKey(userid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserJournalCount>>> = ({ signal }) => getUserJournalCount(userid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userid) !== null && toValue(userid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserJournalCount>>, TError, TData>
}

export type GetUserJournalCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUserJournalCount>>>
export type GetUserJournalCountQueryError = AxiosError<unknown>


/**
 * @summary Get count of all journal entries for a specific user
 */

export function useGetUserJournalCount<TData = Awaited<ReturnType<typeof getUserJournalCount>>, TError = AxiosError<unknown>>(
 userid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetUserJournalCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserJournalCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserJournalCountQueryOptions(userid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get all supported journal events (event types)
 */
export const getJournalEvents = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGenericEnum[]>> => {


    return axios.get(
      `/service/api/journals/journalevents`,options
    );
  }




export const getGetJournalEventsQueryKey = () => {
    return [
    'service','api','journals','journalevents'
    ] as const;
    }


export const getGetJournalEventsQueryOptions = <TData = Awaited<ReturnType<typeof getJournalEvents>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetJournalEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournalEvents>>> = ({ signal }) => getJournalEvents({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJournalEvents>>, TError, TData>
}

export type GetJournalEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getJournalEvents>>>
export type GetJournalEventsQueryError = AxiosError<unknown>


/**
 * @summary Get all supported journal events (event types)
 */

export function useGetJournalEvents<TData = Awaited<ReturnType<typeof getJournalEvents>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJournalEventsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be owner of the device.
 * @summary Get all journal entries for a specific device
 */
export const getDeviceJournals = (
    deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournal[]>> => {
    deviceid = toValue(deviceid);
params = toValue(params);

    return axios.get(
      `/service/api/journals/devices/${deviceid}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDeviceJournalsQueryKey = (deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsParams>,) => {
    return [
    'service','api','journals','devices',deviceid, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDeviceJournalsQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceJournals>>, TError = AxiosError<unknown>>(deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDeviceJournalsQueryKey(deviceid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceJournals>>> = ({ signal }) => getDeviceJournals(deviceid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(deviceid) !== null && toValue(deviceid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournals>>, TError, TData>
}

export type GetDeviceJournalsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceJournals>>>
export type GetDeviceJournalsQueryError = AxiosError<unknown>


/**
 * @summary Get all journal entries for a specific device
 */

export function useGetDeviceJournals<TData = Awaited<ReturnType<typeof getDeviceJournals>>, TError = AxiosError<unknown>>(
 deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceJournalsQueryOptions(deviceid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be owner of the device.
 * @summary Get all supported journal events (event types) for a specific device
 */
export const getDeviceJournalEvents = (
    deviceid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGenericEnum[]>> => {
    deviceid = toValue(deviceid);

    return axios.get(
      `/service/api/journals/devices/${deviceid}/journalevents`,options
    );
  }




export const getGetDeviceJournalEventsQueryKey = (deviceid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','journals','devices',deviceid,'journalevents'
    ] as const;
    }


export const getGetDeviceJournalEventsQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceJournalEvents>>, TError = AxiosError<unknown>>(deviceid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDeviceJournalEventsQueryKey(deviceid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceJournalEvents>>> = ({ signal }) => getDeviceJournalEvents(deviceid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(deviceid) !== null && toValue(deviceid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournalEvents>>, TError, TData>
}

export type GetDeviceJournalEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceJournalEvents>>>
export type GetDeviceJournalEventsQueryError = AxiosError<unknown>


/**
 * @summary Get all supported journal events (event types) for a specific device
 */

export function useGetDeviceJournalEvents<TData = Awaited<ReturnType<typeof getDeviceJournalEvents>>, TError = AxiosError<unknown>>(
 deviceid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceJournalEventsQueryOptions(deviceid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be owner of the device.
 * @summary Get count of all journal entries for a specific device
 */
export const getDeviceJournalsCount = (
    deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsCountParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournalCount>> => {
    deviceid = toValue(deviceid);
params = toValue(params);

    return axios.get(
      `/service/api/journals/devices/${deviceid}/count`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDeviceJournalsCountQueryKey = (deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsCountParams>,) => {
    return [
    'service','api','journals','devices',deviceid,'count', ...(params ? [params] : [])
    ] as const;
    }


export const getGetDeviceJournalsCountQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceJournalsCount>>, TError = AxiosError<unknown>>(deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournalsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDeviceJournalsCountQueryKey(deviceid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceJournalsCount>>> = ({ signal }) => getDeviceJournalsCount(deviceid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(deviceid) !== null && toValue(deviceid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournalsCount>>, TError, TData>
}

export type GetDeviceJournalsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceJournalsCount>>>
export type GetDeviceJournalsCountQueryError = AxiosError<unknown>


/**
 * @summary Get count of all journal entries for a specific device
 */

export function useGetDeviceJournalsCount<TData = Awaited<ReturnType<typeof getDeviceJournalsCount>>, TError = AxiosError<unknown>>(
 deviceid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetDeviceJournalsCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceJournalsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceJournalsCountQueryOptions(deviceid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be a store admin.
 * @summary Get count of all journal entries
 */
export const getJournalsCount = (
    params?: MaybeRefOrGetter<GetJournalsCountParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournalCount>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/journals/count`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetJournalsCountQueryKey = (params?: MaybeRefOrGetter<GetJournalsCountParams>,) => {
    return [
    'service','api','journals','count', ...(params ? [params] : [])
    ] as const;
    }


export const getGetJournalsCountQueryOptions = <TData = Awaited<ReturnType<typeof getJournalsCount>>, TError = AxiosError<unknown>>(params?: MaybeRefOrGetter<GetJournalsCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetJournalsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournalsCount>>> = ({ signal }) => getJournalsCount(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJournalsCount>>, TError, TData>
}

export type GetJournalsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getJournalsCount>>>
export type GetJournalsCountQueryError = AxiosError<unknown>


/**
 * @summary Get count of all journal entries
 */

export function useGetJournalsCount<TData = Awaited<ReturnType<typeof getJournalsCount>>, TError = AxiosError<unknown>>(
 params?: MaybeRefOrGetter<GetJournalsCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJournalsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be in the company.
 * @summary Get all journal entries for a specific company
 */
export const getCompanyJournals = (
    companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournal[]>> => {
    companyid = toValue(companyid);
params = toValue(params);

    return axios.get(
      `/service/api/journals/companys/${companyid}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetCompanyJournalsQueryKey = (companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalsParams>,) => {
    return [
    'service','api','journals','companys',companyid, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyJournalsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyJournals>>, TError = AxiosError<unknown>>(companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCompanyJournalsQueryKey(companyid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyJournals>>> = ({ signal }) => getCompanyJournals(companyid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyid) !== null && toValue(companyid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournals>>, TError, TData>
}

export type GetCompanyJournalsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyJournals>>>
export type GetCompanyJournalsQueryError = AxiosError<unknown>


/**
 * @summary Get all journal entries for a specific company
 */

export function useGetCompanyJournals<TData = Awaited<ReturnType<typeof getCompanyJournals>>, TError = AxiosError<unknown>>(
 companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournals>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyJournalsQueryOptions(companyid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be in the company.
 * @summary Get all supported journal events (event types) for a specific company
 */
export const getCompanyJournalEvents = (
    companyid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGenericEnum[]>> => {
    companyid = toValue(companyid);

    return axios.get(
      `/service/api/journals/companys/${companyid}/journalevents`,options
    );
  }




export const getGetCompanyJournalEventsQueryKey = (companyid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','journals','companys',companyid,'journalevents'
    ] as const;
    }


export const getGetCompanyJournalEventsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyJournalEvents>>, TError = AxiosError<unknown>>(companyid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCompanyJournalEventsQueryKey(companyid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyJournalEvents>>> = ({ signal }) => getCompanyJournalEvents(companyid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyid) !== null && toValue(companyid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournalEvents>>, TError, TData>
}

export type GetCompanyJournalEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyJournalEvents>>>
export type GetCompanyJournalEventsQueryError = AxiosError<unknown>


/**
 * @summary Get all supported journal events (event types) for a specific company
 */

export function useGetCompanyJournalEvents<TData = Awaited<ReturnType<typeof getCompanyJournalEvents>>, TError = AxiosError<unknown>>(
 companyid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournalEvents>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyJournalEventsQueryOptions(companyid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User has to be in the company.
 * @summary Get count of all journal entries for a specific company
 */
export const getCompanyJournalCount = (
    companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalCountParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetJournalCount>> => {
    companyid = toValue(companyid);
params = toValue(params);

    return axios.get(
      `/service/api/journals/companys/${companyid}/count`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetCompanyJournalCountQueryKey = (companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalCountParams>,) => {
    return [
    'service','api','journals','companys',companyid,'count', ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompanyJournalCountQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyJournalCount>>, TError = AxiosError<unknown>>(companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournalCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCompanyJournalCountQueryKey(companyid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyJournalCount>>> = ({ signal }) => getCompanyJournalCount(companyid,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyid) !== null && toValue(companyid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournalCount>>, TError, TData>
}

export type GetCompanyJournalCountQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyJournalCount>>>
export type GetCompanyJournalCountQueryError = AxiosError<unknown>


/**
 * @summary Get count of all journal entries for a specific company
 */

export function useGetCompanyJournalCount<TData = Awaited<ReturnType<typeof getCompanyJournalCount>>, TError = AxiosError<unknown>>(
 companyid: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetCompanyJournalCountParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJournalCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyJournalCountQueryOptions(companyid,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Translate IP to Iso Country Code
 */
export const getIsoCountryCodeByIpAddress = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {


    return axios.get(
      `/service/api/iptocountry`,{
        responseType: 'text',
    ...options,}
    );
  }




export const getGetIsoCountryCodeByIpAddressQueryKey = () => {
    return [
    'service','api','iptocountry'
    ] as const;
    }


export const getGetIsoCountryCodeByIpAddressQueryOptions = <TData = Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetIsoCountryCodeByIpAddressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>> = ({ signal }) => getIsoCountryCodeByIpAddress({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>, TError, TData>
}

export type GetIsoCountryCodeByIpAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>>
export type GetIsoCountryCodeByIpAddressQueryError = AxiosError<unknown>


/**
 * @summary Translate IP to Iso Country Code
 */

export function useGetIsoCountryCodeByIpAddress<TData = Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsoCountryCodeByIpAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIsoCountryCodeByIpAddressQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Return information for all hubs of the store
 */
export const getAllHubs = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetHub[]>> => {


    return axios.get(
      `/service/api/hubs`,options
    );
  }




export const getGetAllHubsQueryKey = () => {
    return [
    'service','api','hubs'
    ] as const;
    }


export const getGetAllHubsQueryOptions = <TData = Awaited<ReturnType<typeof getAllHubs>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHubs>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllHubsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllHubs>>> = ({ signal }) => getAllHubs({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllHubs>>, TError, TData>
}

export type GetAllHubsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllHubs>>>
export type GetAllHubsQueryError = AxiosError<unknown>


/**
 * @summary Return information for all hubs of the store
 */

export function useGetAllHubs<TData = Awaited<ReturnType<typeof getAllHubs>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHubs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllHubsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Return app ids for all apps available in a hub
 */
export const getActiveAppsInHub = (
    hubid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number[]>> => {
    hubid = toValue(hubid);

    return axios.get(
      `/service/api/hubs/${hubid}/apps`,options
    );
  }




export const getGetActiveAppsInHubQueryKey = (hubid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','hubs',hubid,'apps'
    ] as const;
    }


export const getGetActiveAppsInHubQueryOptions = <TData = Awaited<ReturnType<typeof getActiveAppsInHub>>, TError = AxiosError<unknown>>(hubid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveAppsInHub>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetActiveAppsInHubQueryKey(hubid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveAppsInHub>>> = ({ signal }) => getActiveAppsInHub(hubid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(hubid) !== null && toValue(hubid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveAppsInHub>>, TError, TData>
}

export type GetActiveAppsInHubQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveAppsInHub>>>
export type GetActiveAppsInHubQueryError = AxiosError<unknown>


/**
 * @summary Return app ids for all apps available in a hub
 */

export function useGetActiveAppsInHub<TData = Awaited<ReturnType<typeof getActiveAppsInHub>>, TError = AxiosError<unknown>>(
 hubid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveAppsInHub>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveAppsInHubQueryOptions(hubid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get a hardwaretype by id
 */
export const getHardwareTypeById = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HardwareType>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/hardwaretype/${id}`,options
    );
  }




export const getGetHardwareTypeByIdQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','hardwaretype',id
    ] as const;
    }


export const getGetHardwareTypeByIdQueryOptions = <TData = Awaited<ReturnType<typeof getHardwareTypeById>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHardwareTypeById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetHardwareTypeByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHardwareTypeById>>> = ({ signal }) => getHardwareTypeById(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHardwareTypeById>>, TError, TData>
}

export type GetHardwareTypeByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHardwareTypeById>>>
export type GetHardwareTypeByIdQueryError = AxiosError<unknown>


/**
 * @summary Get a hardwaretype by id
 */

export function useGetHardwareTypeById<TData = Awaited<ReturnType<typeof getHardwareTypeById>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHardwareTypeById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHardwareTypeByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Delete a hardwaretype
 */
export const deleteHardwareType = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/hardwaretype/${id}`,options
    );
  }




export const getDeleteHardwareTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHardwareType>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHardwareType>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteHardwareType'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHardwareType>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteHardwareType(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHardwareTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHardwareType>>>

    export type DeleteHardwareTypeMutationError = AxiosError<unknown>

    /**
 * @summary Delete a hardwaretype
 */
export const useDeleteHardwareType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHardwareType>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteHardwareType>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteHardwareTypeMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner.
 * @summary Search a device by id
 */
export const getDevice = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDevice>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/devices/${id}`,options
    );
  }




export const getGetDeviceQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','devices',id
    ] as const;
    }


export const getGetDeviceQueryOptions = <TData = Awaited<ReturnType<typeof getDevice>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDeviceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevice>>> = ({ signal }) => getDevice(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>
}

export type GetDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getDevice>>>
export type GetDeviceQueryError = AxiosError<unknown>


/**
 * @summary Search a device by id
 */

export function useGetDevice<TData = Awaited<ReturnType<typeof getDevice>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be the device owner.
 * @summary Delete a device
 */
export const deleteDevice = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/devices/${id}`,options
    );
  }




export const getDeleteDeviceMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDevice'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDevice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDevice(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDevice>>>

    export type DeleteDeviceMutationError = AxiosError<unknown>

    /**
 * @summary Delete a device
 */
export const useDeleteDevice = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteDevice>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteDeviceMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and owner of the device.
 * @summary Get all license containers for a device
 */
export const getLicenseContainersForDevice = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetLicenseContainer[]>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/devices/${id}/licenses/containers`,options
    );
  }




export const getGetLicenseContainersForDeviceQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','devices',id,'licenses','containers'
    ] as const;
    }


export const getGetLicenseContainersForDeviceQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseContainersForDevice>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseContainersForDevice>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetLicenseContainersForDeviceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseContainersForDevice>>> = ({ signal }) => getLicenseContainersForDevice(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseContainersForDevice>>, TError, TData>
}

export type GetLicenseContainersForDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseContainersForDevice>>>
export type GetLicenseContainersForDeviceQueryError = AxiosError<unknown>


/**
 * @summary Get all license containers for a device
 */

export function useGetLicenseContainersForDevice<TData = Awaited<ReturnType<typeof getLicenseContainersForDevice>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseContainersForDevice>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicenseContainersForDeviceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access its own user-uuid path. User has to be the device owner.
 * @summary Search for selectable devices by user uuid, app id and license type
 */
export const findSelectableDevices = (
    params: MaybeRefOrGetter<FindSelectableDevicesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelSelectableDevice[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/devices/selectable`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindSelectableDevicesQueryKey = (params?: MaybeRefOrGetter<FindSelectableDevicesParams>,) => {
    return [
    'service','api','devices','selectable', ...(params ? [params] : [])
    ] as const;
    }


export const getFindSelectableDevicesQueryOptions = <TData = Awaited<ReturnType<typeof findSelectableDevices>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindSelectableDevicesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSelectableDevices>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindSelectableDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSelectableDevices>>> = ({ signal }) => findSelectableDevices(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findSelectableDevices>>, TError, TData>
}

export type FindSelectableDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof findSelectableDevices>>>
export type FindSelectableDevicesQueryError = AxiosError<unknown>


/**
 * @summary Search for selectable devices by user uuid, app id and license type
 */

export function useFindSelectableDevices<TData = Awaited<ReturnType<typeof findSelectableDevices>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindSelectableDevicesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSelectableDevices>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSelectableDevicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access its own user-uuid path. User has to be the device owner.
 * @summary Export User Device Data as .csv
 */
export const exportUserDeviceData = (
    userid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    userid = toValue(userid);

    return axios.get(
      `/service/api/devices/export/users/${userid}`,options
    );
  }




export const getExportUserDeviceDataQueryKey = (userid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','devices','export','users',userid
    ] as const;
    }


export const getExportUserDeviceDataQueryOptions = <TData = Awaited<ReturnType<typeof exportUserDeviceData>>, TError = AxiosError<unknown>>(userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserDeviceData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getExportUserDeviceDataQueryKey(userid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportUserDeviceData>>> = ({ signal }) => exportUserDeviceData(userid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userid) !== null && toValue(userid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportUserDeviceData>>, TError, TData>
}

export type ExportUserDeviceDataQueryResult = NonNullable<Awaited<ReturnType<typeof exportUserDeviceData>>>
export type ExportUserDeviceDataQueryError = AxiosError<unknown>


/**
 * @summary Export User Device Data as .csv
 */

export function useExportUserDeviceData<TData = Awaited<ReturnType<typeof exportUserDeviceData>>, TError = AxiosError<unknown>>(
 userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserDeviceData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportUserDeviceDataQueryOptions(userid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access its own user-uuid path. User has to be the device owner.
 * @summary Export Company Device Data as .csv
 */
export const exportCompanyDeviceData = (
    companyid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    companyid = toValue(companyid);

    return axios.get(
      `/service/api/devices/export/company/${companyid}`,options
    );
  }




export const getExportCompanyDeviceDataQueryKey = (companyid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','devices','export','company',companyid
    ] as const;
    }


export const getExportCompanyDeviceDataQueryOptions = <TData = Awaited<ReturnType<typeof exportCompanyDeviceData>>, TError = AxiosError<unknown>>(companyid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCompanyDeviceData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getExportCompanyDeviceDataQueryKey(companyid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCompanyDeviceData>>> = ({ signal }) => exportCompanyDeviceData(companyid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyid) !== null && toValue(companyid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCompanyDeviceData>>, TError, TData>
}

export type ExportCompanyDeviceDataQueryResult = NonNullable<Awaited<ReturnType<typeof exportCompanyDeviceData>>>
export type ExportCompanyDeviceDataQueryError = AxiosError<unknown>


/**
 * @summary Export Company Device Data as .csv
 */

export function useExportCompanyDeviceData<TData = Awaited<ReturnType<typeof exportCompanyDeviceData>>, TError = AxiosError<unknown>>(
 companyid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCompanyDeviceData>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportCompanyDeviceDataQueryOptions(companyid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated.
 * @summary Get the count of devices
 */
export const getDeviceCounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDeviceCounts>> => {


    return axios.get(
      `/service/api/devices/counts`,options
    );
  }




export const getGetDeviceCountsQueryKey = () => {
    return [
    'service','api','devices','counts'
    ] as const;
    }


export const getGetDeviceCountsQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceCounts>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDeviceCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceCounts>>> = ({ signal }) => getDeviceCounts({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceCounts>>, TError, TData>
}

export type GetDeviceCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceCounts>>>
export type GetDeviceCountsQueryError = AxiosError<unknown>


/**
 * @summary Get the count of devices
 */

export function useGetDeviceCounts<TData = Awaited<ReturnType<typeof getDeviceCounts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access his own path (user uuid).
 * @summary Get all devices with all apps/libs/licenses for a user
 */
export const findAllDevicesWithAppsAndLicenses = (
    params: MaybeRefOrGetter<FindAllDevicesWithAppsAndLicensesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDeviceWithAppsAndLicenses[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/devices/apps`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindAllDevicesWithAppsAndLicensesQueryKey = (params?: MaybeRefOrGetter<FindAllDevicesWithAppsAndLicensesParams>,) => {
    return [
    'service','api','devices','apps', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllDevicesWithAppsAndLicensesQueryOptions = <TData = Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindAllDevicesWithAppsAndLicensesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAllDevicesWithAppsAndLicensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>> = ({ signal }) => findAllDevicesWithAppsAndLicenses(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>, TError, TData>
}

export type FindAllDevicesWithAppsAndLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>>
export type FindAllDevicesWithAppsAndLicensesQueryError = AxiosError<unknown>


/**
 * @summary Get all devices with all apps/libs/licenses for a user
 */

export function useFindAllDevicesWithAppsAndLicenses<TData = Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindAllDevicesWithAppsAndLicensesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicesWithAppsAndLicenses>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDevicesWithAppsAndLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get all countries
 */
export const getAllCountries = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCountry[]>> => {


    return axios.get(
      `/service/api/country`,options
    );
  }




export const getGetAllCountriesQueryKey = () => {
    return [
    'service','api','country'
    ] as const;
    }


export const getGetAllCountriesQueryOptions = <TData = Awaited<ReturnType<typeof getAllCountries>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCountries>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllCountriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCountries>>> = ({ signal }) => getAllCountries({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCountries>>, TError, TData>
}

export type GetAllCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCountries>>>
export type GetAllCountriesQueryError = AxiosError<unknown>


/**
 * @summary Get all countries
 */

export function useGetAllCountries<TData = Awaited<ReturnType<typeof getAllCountries>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCountries>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCountriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get config data to access novalnet
 */
export const getPaymentConfig = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<KeyValue[]>> => {


    return axios.get(
      `/service/api/configurations/novalnet`,options
    );
  }




export const getGetPaymentConfigQueryKey = () => {
    return [
    'service','api','configurations','novalnet'
    ] as const;
    }


export const getGetPaymentConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetPaymentConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentConfig>>> = ({ signal }) => getPaymentConfig({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>
}

export type GetPaymentConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentConfig>>>
export type GetPaymentConfigQueryError = AxiosError<unknown>


/**
 * @summary Get config data to access novalnet
 */

export function useGetPaymentConfig<TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get Deployment Info
 */
export const getDeploymentInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeploymentInfo>> => {


    return axios.get(
      `/service/api/configurations/deployment-info`,options
    );
  }




export const getGetDeploymentInfoQueryKey = () => {
    return [
    'service','api','configurations','deployment-info'
    ] as const;
    }


export const getGetDeploymentInfoQueryOptions = <TData = Awaited<ReturnType<typeof getDeploymentInfo>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDeploymentInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeploymentInfo>>> = ({ signal }) => getDeploymentInfo({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeploymentInfo>>, TError, TData>
}

export type GetDeploymentInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getDeploymentInfo>>>
export type GetDeploymentInfoQueryError = AxiosError<unknown>


/**
 * @summary Get Deployment Info
 */

export function useGetDeploymentInfo<TData = Awaited<ReturnType<typeof getDeploymentInfo>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeploymentInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Search a company profile by id
 */
export const findCompanyProfile = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/company-profiles/${id}`,options
    );
  }




export const getFindCompanyProfileQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','company-profiles',id
    ] as const;
    }


export const getFindCompanyProfileQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyProfile>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyProfile>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindCompanyProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyProfile>>> = ({ signal }) => findCompanyProfile(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyProfile>>, TError, TData>
}

export type FindCompanyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyProfile>>>
export type FindCompanyProfileQueryError = AxiosError<unknown>


/**
 * @summary Search a company profile by id
 */

export function useFindCompanyProfile<TData = Awaited<ReturnType<typeof findCompanyProfile>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyProfile>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyProfileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be an admin of the company or store admin.
 * @summary Delete a company profile
 */
export const deleteCompanyProfile = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/company-profiles/${id}`,options
    );
  }




export const getDeleteCompanyProfileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyProfile>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyProfile>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCompanyProfile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyProfile>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanyProfile(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyProfile>>>

    export type DeleteCompanyProfileMutationError = AxiosError<unknown>

    /**
 * @summary Delete a company profile
 */
export const useDeleteCompanyProfile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyProfile>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompanyProfile>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCompanyProfileMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Get all public company profiles
 */
export const getAllPublicCompanyProfiles = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyProfile[]>> => {


    return axios.get(
      `/service/api/company-profiles/public`,options
    );
  }




export const getGetAllPublicCompanyProfilesQueryKey = () => {
    return [
    'service','api','company-profiles','public'
    ] as const;
    }


export const getGetAllPublicCompanyProfilesQueryOptions = <TData = Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllPublicCompanyProfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>> = ({ signal }) => getAllPublicCompanyProfiles({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>, TError, TData>
}

export type GetAllPublicCompanyProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>>
export type GetAllPublicCompanyProfilesQueryError = AxiosError<unknown>


/**
 * @summary Get all public company profiles
 */

export function useGetAllPublicCompanyProfiles<TData = Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPublicCompanyProfiles>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllPublicCompanyProfilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: The company has to be an approved contributor, the user has to be a member of the company or the user has to be store admin
 * @summary Search a company by id
 */
export const findCompany = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompany>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/companies/${id}`,options
    );
  }




export const getFindCompanyQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','companies',id
    ] as const;
    }


export const getFindCompanyQueryOptions = <TData = Awaited<ReturnType<typeof findCompany>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindCompanyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompany>>> = ({ signal }) => findCompany(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>
}

export type FindCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof findCompany>>>
export type FindCompanyQueryError = AxiosError<unknown>


/**
 * @summary Search a company by id
 */

export function useFindCompany<TData = Awaited<ReturnType<typeof findCompany>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be a company admin of the company
 * @summary Delete a company
 */
export const deleteCompany = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/companies/${id}`,options
    );
  }




export const getDeleteCompanyMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCompany'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompany>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompany(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompany>>>

    export type DeleteCompanyMutationError = AxiosError<unknown>

    /**
 * @summary Delete a company
 */
export const useDeleteCompany = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompany>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCompanyMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and is in the company of the given id
 * @summary Get all license options for published apps in the users company
 */
export const getAllLicenseOptions = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAllLicenseOptionsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicenseOption[]>> => {
    id = toValue(id);
params = toValue(params);

    return axios.get(
      `/service/api/companies/${id}/license-options`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAllLicenseOptionsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAllLicenseOptionsParams>,) => {
    return [
    'service','api','companies',id,'license-options', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAllLicenseOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAllLicenseOptions>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAllLicenseOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLicenseOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllLicenseOptionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLicenseOptions>>> = ({ signal }) => getAllLicenseOptions(id,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLicenseOptions>>, TError, TData>
}

export type GetAllLicenseOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLicenseOptions>>>
export type GetAllLicenseOptionsQueryError = AxiosError<unknown>


/**
 * @summary Get all license options for published apps in the users company
 */

export function useGetAllLicenseOptions<TData = Awaited<ReturnType<typeof getAllLicenseOptions>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAllLicenseOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLicenseOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllLicenseOptionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be a member of the company.
 * @summary Get all company members
 */
export const getAllCompanyMembers = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyMember[]>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/companies/${id}/company-members`,options
    );
  }




export const getGetAllCompanyMembersQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','companies',id,'company-members'
    ] as const;
    }


export const getGetAllCompanyMembersQueryOptions = <TData = Awaited<ReturnType<typeof getAllCompanyMembers>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanyMembers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllCompanyMembersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCompanyMembers>>> = ({ signal }) => getAllCompanyMembers(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCompanyMembers>>, TError, TData>
}

export type GetAllCompanyMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCompanyMembers>>>
export type GetAllCompanyMembersQueryError = AxiosError<unknown>


/**
 * @summary Get all company members
 */

export function useGetAllCompanyMembers<TData = Awaited<ReturnType<typeof getAllCompanyMembers>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanyMembers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCompanyMembersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * @summary Get all developer certificates of a company
 */
export const getCompanyCertificates = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCertificate[]>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/companies/${id}/certificates`,options
    );
  }




export const getGetCompanyCertificatesQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','companies',id,'certificates'
    ] as const;
    }


export const getGetCompanyCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyCertificates>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyCertificates>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetCompanyCertificatesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyCertificates>>> = ({ signal }) => getCompanyCertificates(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyCertificates>>, TError, TData>
}

export type GetCompanyCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyCertificates>>>
export type GetCompanyCertificatesQueryError = AxiosError<unknown>


/**
 * @summary Get all developer certificates of a company
 */

export function useGetCompanyCertificates<TData = Awaited<ReturnType<typeof getCompanyCertificates>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyCertificates>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyCertificatesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Get all companies for admin view
 */
export const getAllCompaniesForAdminView = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetCompanyForAdminView[]>> => {


    return axios.get(
      `/service/api/companies/admin`,options
    );
  }




export const getGetAllCompaniesForAdminViewQueryKey = () => {
    return [
    'service','api','companies','admin'
    ] as const;
    }


export const getGetAllCompaniesForAdminViewQueryOptions = <TData = Awaited<ReturnType<typeof getAllCompaniesForAdminView>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompaniesForAdminView>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllCompaniesForAdminViewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCompaniesForAdminView>>> = ({ signal }) => getAllCompaniesForAdminView({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCompaniesForAdminView>>, TError, TData>
}

export type GetAllCompaniesForAdminViewQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCompaniesForAdminView>>>
export type GetAllCompaniesForAdminViewQueryError = AxiosError<unknown>


/**
 * @summary Get all companies for admin view
 */

export function useGetAllCompaniesForAdminView<TData = Awaited<ReturnType<typeof getAllCompaniesForAdminView>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompaniesForAdminView>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCompaniesForAdminViewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary Get all app settings
 */
export const getApps = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppSettings[]>> => {


    return axios.get(
      `/service/api/appsettings`,options
    );
  }




export const getGetAppsQueryKey = () => {
    return [
    'service','api','appsettings'
    ] as const;
    }


export const getGetAppsQueryOptions = <TData = Awaited<ReturnType<typeof getApps>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApps>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApps>>> = ({ signal }) => getApps({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApps>>, TError, TData>
}

export type GetAppsQueryResult = NonNullable<Awaited<ReturnType<typeof getApps>>>
export type GetAppsQueryError = AxiosError<unknown>


/**
 * @summary Get all app settings
 */

export function useGetApps<TData = Awaited<ReturnType<typeof getApps>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApps>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @deprecated
 * @summary Get app settings by id
 */
export const getAppId = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppSettings>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/appsettings/${id}`,options
    );
  }




export const getGetAppIdQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','appsettings',id
    ] as const;
    }


export const getGetAppIdQueryOptions = <TData = Awaited<ReturnType<typeof getAppId>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppId>>> = ({ signal }) => getAppId(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppId>>, TError, TData>
}

export type GetAppIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAppId>>>
export type GetAppIdQueryError = AxiosError<unknown>


/**
 * @deprecated
 * @summary Get app settings by id
 */

export function useGetAppId<TData = Awaited<ReturnType<typeof getAppId>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated and is a store admin.
 * @summary Export safety app subscribers as csv
 */
export const exportSafetyAppSubscribersAsCsv = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/appsettings/${id}/admin/safety/subscribers`,options
    );
  }




export const getExportSafetyAppSubscribersAsCsvQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','appsettings',id,'admin','safety','subscribers'
    ] as const;
    }


export const getExportSafetyAppSubscribersAsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getExportSafetyAppSubscribersAsCsvQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>> = ({ signal }) => exportSafetyAppSubscribersAsCsv(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>, TError, TData>
}

export type ExportSafetyAppSubscribersAsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>>
export type ExportSafetyAppSubscribersAsCsvQueryError = AxiosError<unknown>


/**
 * @summary Export safety app subscribers as csv
 */

export function useExportSafetyAppSubscribersAsCsv<TData = Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSafetyAppSubscribersAsCsv>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportSafetyAppSubscribersAsCsvQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Search apps by a set of values. This API method is used for the main page search
 */
export const findApps = (
    params?: MaybeRefOrGetter<FindAppsParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/apps`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindAppsQueryKey = (params?: MaybeRefOrGetter<FindAppsParams>,) => {
    return [
    'service','api','apps', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAppsQueryOptions = <TData = Awaited<ReturnType<typeof findApps>>, TError = AxiosError<unknown>>(params?: MaybeRefOrGetter<FindAppsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApps>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAppsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findApps>>> = ({ signal }) => findApps(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findApps>>, TError, TData>
}

export type FindAppsQueryResult = NonNullable<Awaited<ReturnType<typeof findApps>>>
export type FindAppsQueryError = AxiosError<unknown>


/**
 * @summary Search apps by a set of values. This API method is used for the main page search
 */

export function useFindApps<TData = Awaited<ReturnType<typeof findApps>>, TError = AxiosError<unknown>>(
 params?: MaybeRefOrGetter<FindAppsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApps>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAppsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: Apps which are not released are only visible for assigned developers and store admins.
 * @summary Search apps by appid and internalversion
 */
export const findAppByAppIdAndInternalVersion = (
    params: MaybeRefOrGetter<FindAppByAppIdAndInternalVersionParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/apps/version`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindAppByAppIdAndInternalVersionQueryKey = (params?: MaybeRefOrGetter<FindAppByAppIdAndInternalVersionParams>,) => {
    return [
    'service','api','apps','version', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAppByAppIdAndInternalVersionQueryOptions = <TData = Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindAppByAppIdAndInternalVersionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAppByAppIdAndInternalVersionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>> = ({ signal }) => findAppByAppIdAndInternalVersion(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>, TError, TData>
}

export type FindAppByAppIdAndInternalVersionQueryResult = NonNullable<Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>>
export type FindAppByAppIdAndInternalVersionQueryError = AxiosError<unknown>


/**
 * @summary Search apps by appid and internalversion
 */

export function useFindAppByAppIdAndInternalVersion<TData = Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindAppByAppIdAndInternalVersionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAppByAppIdAndInternalVersion>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAppByAppIdAndInternalVersionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be assigned developer to the app.
 * @summary Number of installed apps for this app version.
 */
export const installedAppsCount = (
    appVersionId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    appVersionId = toValue(appVersionId);

    return axios.get(
      `/service/api/apps/version/installed_apps_count/${appVersionId}`,options
    );
  }




export const getInstalledAppsCountQueryKey = (appVersionId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','version','installed_apps_count',appVersionId
    ] as const;
    }


export const getInstalledAppsCountQueryOptions = <TData = Awaited<ReturnType<typeof installedAppsCount>>, TError = AxiosError<unknown>>(appVersionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof installedAppsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getInstalledAppsCountQueryKey(appVersionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof installedAppsCount>>> = ({ signal }) => installedAppsCount(appVersionId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appVersionId) !== null && toValue(appVersionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof installedAppsCount>>, TError, TData>
}

export type InstalledAppsCountQueryResult = NonNullable<Awaited<ReturnType<typeof installedAppsCount>>>
export type InstalledAppsCountQueryError = AxiosError<unknown>


/**
 * @summary Number of installed apps for this app version.
 */

export function useInstalledAppsCount<TData = Awaited<ReturnType<typeof installedAppsCount>>, TError = AxiosError<unknown>>(
 appVersionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof installedAppsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstalledAppsCountQueryOptions(appVersionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be assigned developer to the app.
 * @summary Check whether an app version can be deleted.
 */
export const appVersionDeletable = (
    appVersionId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    appVersionId = toValue(appVersionId);

    return axios.get(
      `/service/api/apps/version/deletable/${appVersionId}`,options
    );
  }




export const getAppVersionDeletableQueryKey = (appVersionId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','version','deletable',appVersionId
    ] as const;
    }


export const getAppVersionDeletableQueryOptions = <TData = Awaited<ReturnType<typeof appVersionDeletable>>, TError = AxiosError<unknown>>(appVersionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appVersionDeletable>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getAppVersionDeletableQueryKey(appVersionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appVersionDeletable>>> = ({ signal }) => appVersionDeletable(appVersionId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appVersionId) !== null && toValue(appVersionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appVersionDeletable>>, TError, TData>
}

export type AppVersionDeletableQueryResult = NonNullable<Awaited<ReturnType<typeof appVersionDeletable>>>
export type AppVersionDeletableQueryError = AxiosError<unknown>


/**
 * @summary Check whether an app version can be deleted.
 */

export function useAppVersionDeletable<TData = Awaited<ReturnType<typeof appVersionDeletable>>, TError = AxiosError<unknown>>(
 appVersionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appVersionDeletable>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppVersionDeletableQueryOptions(appVersionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be authenticated. User can only access his own path (userid).
 * @summary Get apps for a specified user (used on software products page)
 */
export const getAppsForUser = (
    userid: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetDeveloperApp[]>> => {
    userid = toValue(userid);

    return axios.get(
      `/service/api/apps/user/${userid}`,options
    );
  }




export const getGetAppsForUserQueryKey = (userid: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','apps','user',userid
    ] as const;
    }


export const getGetAppsForUserQueryOptions = <TData = Awaited<ReturnType<typeof getAppsForUser>>, TError = AxiosError<unknown>>(userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppsForUser>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppsForUserQueryKey(userid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppsForUser>>> = ({ signal }) => getAppsForUser(userid, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userid) !== null && toValue(userid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppsForUser>>, TError, TData>
}

export type GetAppsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAppsForUser>>>
export type GetAppsForUserQueryError = AxiosError<unknown>


/**
 * @summary Get apps for a specified user (used on software products page)
 */

export function useGetAppsForUser<TData = Awaited<ReturnType<typeof getAppsForUser>>, TError = AxiosError<unknown>>(
 userid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppsForUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppsForUserQueryOptions(userid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Search apps by a set of values. This API method is used for the main page search
 */
export const findAppsPage = (
    params: MaybeRefOrGetter<FindAppsPageParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelAppPageAndContent>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/apps/page`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindAppsPageQueryKey = (params?: MaybeRefOrGetter<FindAppsPageParams>,) => {
    return [
    'service','api','apps','page', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAppsPageQueryOptions = <TData = Awaited<ReturnType<typeof findAppsPage>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindAppsPageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAppsPage>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAppsPageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAppsPage>>> = ({ signal }) => findAppsPage(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAppsPage>>, TError, TData>
}

export type FindAppsPageQueryResult = NonNullable<Awaited<ReturnType<typeof findAppsPage>>>
export type FindAppsPageQueryError = AxiosError<unknown>


/**
 * @summary Search apps by a set of values. This API method is used for the main page search
 */

export function useFindAppsPage<TData = Awaited<ReturnType<typeof findAppsPage>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindAppsPageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAppsPage>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAppsPageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be assigned developer to the app.
 * @summary Check if an app is ready to be published
 */
export const isReleasable = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetIsAppReleaseable>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/apps/id/${id}/releasable`,options
    );
  }




export const getIsReleasableQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','id',id,'releasable'
    ] as const;
    }


export const getIsReleasableQueryOptions = <TData = Awaited<ReturnType<typeof isReleasable>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isReleasable>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getIsReleasableQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof isReleasable>>> = ({ signal }) => isReleasable(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof isReleasable>>, TError, TData>
}

export type IsReleasableQueryResult = NonNullable<Awaited<ReturnType<typeof isReleasable>>>
export type IsReleasableQueryError = AxiosError<unknown>


/**
 * @summary Check if an app is ready to be published
 */

export function useIsReleasable<TData = Awaited<ReturnType<typeof isReleasable>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isReleasable>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIsReleasableQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Get the latest release of an app by app identifier (proficloud app id)
 */
export const getIdOfLatestReleaseByAppIdentifier = (
    appIdentifier: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    appIdentifier = toValue(appIdentifier);

    return axios.get(
      `/service/api/apps/app-identifier/${appIdentifier}`,options
    );
  }




export const getGetIdOfLatestReleaseByAppIdentifierQueryKey = (appIdentifier: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','apps','app-identifier',appIdentifier
    ] as const;
    }


export const getGetIdOfLatestReleaseByAppIdentifierQueryOptions = <TData = Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>, TError = AxiosError<unknown>>(appIdentifier: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetIdOfLatestReleaseByAppIdentifierQueryKey(appIdentifier);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>> = ({ signal }) => getIdOfLatestReleaseByAppIdentifier(appIdentifier, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appIdentifier) !== null && toValue(appIdentifier) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>, TError, TData>
}

export type GetIdOfLatestReleaseByAppIdentifierQueryResult = NonNullable<Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>>
export type GetIdOfLatestReleaseByAppIdentifierQueryError = AxiosError<unknown>


/**
 * @summary Get the latest release of an app by app identifier (proficloud app id)
 */

export function useGetIdOfLatestReleaseByAppIdentifier<TData = Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>, TError = AxiosError<unknown>>(
 appIdentifier: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIdOfLatestReleaseByAppIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIdOfLatestReleaseByAppIdentifierQueryOptions(appIdentifier,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Is this app (by app_id) a free or paid app?
 */
export const getIsPaidApp = (
    appId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    appId = toValue(appId);

    return axios.get(
      `/service/api/apps/app-id/${appId}/paid`,options
    );
  }




export const getGetIsPaidAppQueryKey = (appId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','apps','app-id',appId,'paid'
    ] as const;
    }


export const getGetIsPaidAppQueryOptions = <TData = Awaited<ReturnType<typeof getIsPaidApp>>, TError = AxiosError<unknown>>(appId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsPaidApp>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetIsPaidAppQueryKey(appId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsPaidApp>>> = ({ signal }) => getIsPaidApp(appId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appId) !== null && toValue(appId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIsPaidApp>>, TError, TData>
}

export type GetIsPaidAppQueryResult = NonNullable<Awaited<ReturnType<typeof getIsPaidApp>>>
export type GetIsPaidAppQueryError = AxiosError<unknown>


/**
 * @summary Is this app (by app_id) a free or paid app?
 */

export function useGetIsPaidApp<TData = Awaited<ReturnType<typeof getIsPaidApp>>, TError = AxiosError<unknown>>(
 appId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsPaidApp>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIsPaidAppQueryOptions(appId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated
 * @summary Get trial code by code and license option and app id
 */
export const getTrialCodeByCode1 = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    trialCodeId: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetTrialCode>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);
trialCodeId = toValue(trialCodeId);

    return axios.get(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}/trial-codes/${trialCodeId}`,options
    );
  }




export const getGetTrialCodeByCode1QueryKey = (appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    trialCodeId: MaybeRefOrGetter<string>,) => {
    return [
    'service','api','apps','app-id',appId,'license-options',licenseOptionId,'trial-codes',trialCodeId
    ] as const;
    }


export const getGetTrialCodeByCode1QueryOptions = <TData = Awaited<ReturnType<typeof getTrialCodeByCode1>>, TError = AxiosError<unknown>>(appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    trialCodeId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialCodeByCode1>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetTrialCodeByCode1QueryKey(appId,licenseOptionId,trialCodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrialCodeByCode1>>> = ({ signal }) => getTrialCodeByCode1(appId,licenseOptionId,trialCodeId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appId) !== null && toValue(appId) !== undefined && toValue(licenseOptionId) !== null && toValue(licenseOptionId) !== undefined && toValue(trialCodeId) !== null && toValue(trialCodeId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrialCodeByCode1>>, TError, TData>
}

export type GetTrialCodeByCode1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrialCodeByCode1>>>
export type GetTrialCodeByCode1QueryError = AxiosError<unknown>


/**
 * @summary Get trial code by code and license option and app id
 */

export function useGetTrialCodeByCode1<TData = Awaited<ReturnType<typeof getTrialCodeByCode1>>, TError = AxiosError<unknown>>(
 appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    trialCodeId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialCodeByCode1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrialCodeByCode1QueryOptions(appId,licenseOptionId,trialCodeId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated. User is assigned to the app.
 * @summary Delete a trial code
 */
export const deleteTrialCode = (
    appId: MaybeRefOrGetter<number>,
    licenseOptionId: MaybeRefOrGetter<number>,
    trialCodeId: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    appId = toValue(appId);
licenseOptionId = toValue(licenseOptionId);
trialCodeId = toValue(trialCodeId);

    return axios.delete(
      `/service/api/apps/app-id/${appId}/license-options/${licenseOptionId}/trial-codes/${trialCodeId}`,options
    );
  }




export const getDeleteTrialCodeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrialCode>>, TError,{appId: number;licenseOptionId: number;trialCodeId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrialCode>>, TError,{appId: number;licenseOptionId: number;trialCodeId: string}, TContext> => {

const mutationKey = ['deleteTrialCode'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrialCode>>, {appId: number;licenseOptionId: number;trialCodeId: string}> = (props) => {
          const {appId,licenseOptionId,trialCodeId} = props ?? {};

          return  deleteTrialCode(appId,licenseOptionId,trialCodeId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrialCodeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrialCode>>>

    export type DeleteTrialCodeMutationError = AxiosError<unknown>

    /**
 * @summary Delete a trial code
 */
export const useDeleteTrialCode = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrialCode>>, TError,{appId: number;licenseOptionId: number;trialCodeId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTrialCode>>,
        TError,
        {appId: number;licenseOptionId: number;trialCodeId: string},
        TContext
      > => {
      return useMutation(getDeleteTrialCodeMutationOptions(options), queryClient);
    }

/**
 * Security: -
 * @summary Search an app by AppID to return version history
 */
export const getAppWithHistory = (
    id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAppWithHistoryParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppVersion[]>> => {
    id = toValue(id);
params = toValue(params);

    return axios.get(
      `/service/api/apps/all/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAppWithHistoryQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAppWithHistoryParams>,) => {
    return [
    'service','api','apps','all',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAppWithHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAppWithHistory>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAppWithHistoryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppWithHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppWithHistoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppWithHistory>>> = ({ signal }) => getAppWithHistory(id,params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppWithHistory>>, TError, TData>
}

export type GetAppWithHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAppWithHistory>>>
export type GetAppWithHistoryQueryError = AxiosError<unknown>


/**
 * @summary Search an app by AppID to return version history
 */

export function useGetAppWithHistory<TData = Awaited<ReturnType<typeof getAppWithHistory>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAppWithHistoryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppWithHistory>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppWithHistoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: -
 * @summary Return all app types of the store
 */
export const getAllAppTypes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppType[]>> => {


    return axios.get(
      `/service/api/app-types`,options
    );
  }




export const getGetAllAppTypesQueryKey = () => {
    return [
    'service','api','app-types'
    ] as const;
    }


export const getGetAllAppTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllAppTypes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAppTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAllAppTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAppTypes>>> = ({ signal }) => getAllAppTypes({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAppTypes>>, TError, TData>
}

export type GetAllAppTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAppTypes>>>
export type GetAllAppTypesQueryError = AxiosError<unknown>


/**
 * @summary Return all app types of the store
 */

export function useGetAllAppTypes<TData = Awaited<ReturnType<typeof getAllAppTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAppTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllAppTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access his own path (user uuid) or be store admin.
 * @summary Search app licenses by a combination of app id, device id and user uuid
 */
export const findAppLicenses = (
    params: MaybeRefOrGetter<FindAppLicensesParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicense[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/app-licenses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getFindAppLicensesQueryKey = (params?: MaybeRefOrGetter<FindAppLicensesParams>,) => {
    return [
    'service','api','app-licenses', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAppLicensesQueryOptions = <TData = Awaited<ReturnType<typeof findAppLicenses>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<FindAppLicensesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAppLicenses>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getFindAppLicensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAppLicenses>>> = ({ signal }) => findAppLicenses(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAppLicenses>>, TError, TData>
}

export type FindAppLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof findAppLicenses>>>
export type FindAppLicensesQueryError = AxiosError<unknown>


/**
 * @summary Search app licenses by a combination of app id, device id and user uuid
 */

export function useFindAppLicenses<TData = Awaited<ReturnType<typeof findAppLicenses>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<FindAppLicensesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAppLicenses>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAppLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be the owner of the license or store admin.
 * @summary Search a license by id
 */
export const getAppLicense = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAppLicense>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/app-licenses/${id}`,options
    );
  }




export const getGetAppLicenseQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','app-licenses',id
    ] as const;
    }


export const getGetAppLicenseQueryOptions = <TData = Awaited<ReturnType<typeof getAppLicense>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppLicense>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAppLicenseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppLicense>>> = ({ signal }) => getAppLicense(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppLicense>>, TError, TData>
}

export type GetAppLicenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAppLicense>>>
export type GetAppLicenseQueryError = AxiosError<unknown>


/**
 * @summary Search a license by id
 */

export function useGetAppLicense<TData = Awaited<ReturnType<typeof getAppLicense>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppLicense>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppLicenseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access his own path (user uuid).
 * @summary Returns true if Trial is available
 */
export const isTrialAvailable = (
    params: MaybeRefOrGetter<IsTrialAvailableParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/app-licenses/trial-available`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getIsTrialAvailableQueryKey = (params?: MaybeRefOrGetter<IsTrialAvailableParams>,) => {
    return [
    'service','api','app-licenses','trial-available', ...(params ? [params] : [])
    ] as const;
    }


export const getIsTrialAvailableQueryOptions = <TData = Awaited<ReturnType<typeof isTrialAvailable>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<IsTrialAvailableParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isTrialAvailable>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getIsTrialAvailableQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof isTrialAvailable>>> = ({ signal }) => isTrialAvailable(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof isTrialAvailable>>, TError, TData>
}

export type IsTrialAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof isTrialAvailable>>>
export type IsTrialAvailableQueryError = AxiosError<unknown>


/**
 * @summary Returns true if Trial is available
 */

export function useIsTrialAvailable<TData = Awaited<ReturnType<typeof isTrialAvailable>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<IsTrialAvailableParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isTrialAvailable>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIsTrialAvailableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access his own path (user uuid).
 * @summary Get detailed license installation status information by a combination of app id, device id, user uuid and cmActId
 */
export const getDetailedLicenseInstallationInformation = (
    params: MaybeRefOrGetter<GetDetailedLicenseInstallationInformationParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InstallationDetailStatus[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/app-licenses/license-installation-details`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDetailedLicenseInstallationInformationQueryKey = (params?: MaybeRefOrGetter<GetDetailedLicenseInstallationInformationParams>,) => {
    return [
    'service','api','app-licenses','license-installation-details', ...(params ? [params] : [])
    ] as const;
    }


export const getGetDetailedLicenseInstallationInformationQueryOptions = <TData = Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetDetailedLicenseInstallationInformationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDetailedLicenseInstallationInformationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>> = ({ signal }) => getDetailedLicenseInstallationInformation(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>, TError, TData>
}

export type GetDetailedLicenseInstallationInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>>
export type GetDetailedLicenseInstallationInformationQueryError = AxiosError<unknown>


/**
 * @summary Get detailed license installation status information by a combination of app id, device id, user uuid and cmActId
 */

export function useGetDetailedLicenseInstallationInformation<TData = Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetDetailedLicenseInstallationInformationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetailedLicenseInstallationInformation>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDetailedLicenseInstallationInformationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, get all errors for all apps and licenses
 */
export const adminGetErrors = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelAdminErrorInfo[]>> => {


    return axios.get(
      `/service/api/app-licenses/errors`,options
    );
  }




export const getAdminGetErrorsQueryKey = () => {
    return [
    'service','api','app-licenses','errors'
    ] as const;
    }


export const getAdminGetErrorsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetErrors>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrors>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getAdminGetErrorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetErrors>>> = ({ signal }) => adminGetErrors({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetErrors>>, TError, TData>
}

export type AdminGetErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetErrors>>>
export type AdminGetErrorsQueryError = AxiosError<unknown>


/**
 * @summary As an admin user, get all errors for all apps and licenses
 */

export function useAdminGetErrors<TData = Awaited<ReturnType<typeof adminGetErrors>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrors>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetErrorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated.
 * @summary Get the count of licenses
 */
export const getLicenseCounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetLicenseCounts>> => {


    return axios.get(
      `/service/api/app-licenses/counts`,options
    );
  }




export const getGetLicenseCountsQueryKey = () => {
    return [
    'service','api','app-licenses','counts'
    ] as const;
    }


export const getGetLicenseCountsQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseCounts>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetLicenseCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseCounts>>> = ({ signal }) => getLicenseCounts({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseCounts>>, TError, TData>
}

export type GetLicenseCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseCounts>>>
export type GetLicenseCountsQueryError = AxiosError<unknown>


/**
 * @summary Get the count of licenses
 */

export function useGetLicenseCounts<TData = Awaited<ReturnType<typeof getLicenseCounts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseCounts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicenseCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User needs to be assigned developer to the app.
 * @summary Count app licenses for app with id
 */
export const countLicensesByAppId = (
    appId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    appId = toValue(appId);

    return axios.get(
      `/service/api/app-licenses/count/${appId}`,options
    );
  }




export const getCountLicensesByAppIdQueryKey = (appId: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','app-licenses','count',appId
    ] as const;
    }


export const getCountLicensesByAppIdQueryOptions = <TData = Awaited<ReturnType<typeof countLicensesByAppId>>, TError = AxiosError<unknown>>(appId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countLicensesByAppId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getCountLicensesByAppIdQueryKey(appId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countLicensesByAppId>>> = ({ signal }) => countLicensesByAppId(appId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(appId) !== null && toValue(appId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countLicensesByAppId>>, TError, TData>
}

export type CountLicensesByAppIdQueryResult = NonNullable<Awaited<ReturnType<typeof countLicensesByAppId>>>
export type CountLicensesByAppIdQueryError = AxiosError<unknown>


/**
 * @summary Count app licenses for app with id
 */

export function useCountLicensesByAppId<TData = Awaited<ReturnType<typeof countLicensesByAppId>>, TError = AxiosError<unknown>>(
 appId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countLicensesByAppId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountLicensesByAppIdQueryOptions(appId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User can only access his own path (user uuid).
 * @summary Get detailed app installation status information by a combination of app id, device id and user uuid
 */
export const getDetailedAppInstallationInformation = (
    params: MaybeRefOrGetter<GetDetailedAppInstallationInformationParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InstallationDetailStatus[]>> => {
    params = toValue(params);

    return axios.get(
      `/service/api/app-licenses/app-installation-details`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDetailedAppInstallationInformationQueryKey = (params?: MaybeRefOrGetter<GetDetailedAppInstallationInformationParams>,) => {
    return [
    'service','api','app-licenses','app-installation-details', ...(params ? [params] : [])
    ] as const;
    }


export const getGetDetailedAppInstallationInformationQueryOptions = <TData = Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>, TError = AxiosError<unknown>>(params: MaybeRefOrGetter<GetDetailedAppInstallationInformationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetDetailedAppInstallationInformationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>> = ({ signal }) => getDetailedAppInstallationInformation(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>, TError, TData>
}

export type GetDetailedAppInstallationInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>>
export type GetDetailedAppInstallationInformationQueryError = AxiosError<unknown>


/**
 * @summary Get detailed app installation status information by a combination of app id, device id and user uuid
 */

export function useGetDetailedAppInstallationInformation<TData = Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>, TError = AxiosError<unknown>>(
 params: MaybeRefOrGetter<GetDetailedAppInstallationInformationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetailedAppInstallationInformation>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDetailedAppInstallationInformationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User has to be authenticated. User needs access to the company that this address is used for. Either the company is approved contributor or the user is member of the company or the user is store admin
 * @summary Get an address by id
 */
export const getAddress = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelGetAddress>> => {
    id = toValue(id);

    return axios.get(
      `/service/api/addresses/${id}`,options
    );
  }




export const getGetAddressQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'service','api','addresses',id
    ] as const;
    }


export const getGetAddressQueryOptions = <TData = Awaited<ReturnType<typeof getAddress>>, TError = AxiosError<unknown>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  getGetAddressQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddress>>> = ({ signal }) => getAddress(id, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>
}

export type GetAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getAddress>>>
export type GetAddressQueryError = AxiosError<unknown>


/**
 * @summary Get an address by id
 */

export function useGetAddress<TData = Awaited<ReturnType<typeof getAddress>>, TError = AxiosError<unknown>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







/**
 * Security: User is authenticated.
 * @summary Delete the JWT Authentication token cookie
 */
export const deleteJwtAuthToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.delete(
      `/service/api/users/jwt/delete`,options
    );
  }




export const getDeleteJwtAuthTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJwtAuthToken>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJwtAuthToken>>, TError,void, TContext> => {

const mutationKey = ['deleteJwtAuthToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJwtAuthToken>>, void> = () => {


          return  deleteJwtAuthToken(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteJwtAuthTokenMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJwtAuthToken>>>

    export type DeleteJwtAuthTokenMutationError = AxiosError<unknown>

    /**
 * @summary Delete the JWT Authentication token cookie
 */
export const useDeleteJwtAuthToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJwtAuthToken>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteJwtAuthToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteJwtAuthTokenMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be a store admin.
 * @summary Remove a device from an account
 */
export const removeFromAccountByAdmin = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RemoveFromAccountByAdminParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebModelDeleteRemoveDeviceFromAccount>> => {
    id = toValue(id);
params = toValue(params);

    return axios.delete(
      `/service/api/devices/${id}/remove-from-account`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getRemoveFromAccountByAdminMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromAccountByAdmin>>, TError,{id: string;params?: RemoveFromAccountByAdminParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeFromAccountByAdmin>>, TError,{id: string;params?: RemoveFromAccountByAdminParams}, TContext> => {

const mutationKey = ['removeFromAccountByAdmin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFromAccountByAdmin>>, {id: string;params?: RemoveFromAccountByAdminParams}> = (props) => {
          const {id,params} = props ?? {};

          return  removeFromAccountByAdmin(id,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFromAccountByAdminMutationResult = NonNullable<Awaited<ReturnType<typeof removeFromAccountByAdmin>>>

    export type RemoveFromAccountByAdminMutationError = AxiosError<unknown>

    /**
 * @summary Remove a device from an account
 */
export const useRemoveFromAccountByAdmin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromAccountByAdmin>>, TError,{id: string;params?: RemoveFromAccountByAdminParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeFromAccountByAdmin>>,
        TError,
        {id: string;params?: RemoveFromAccountByAdminParams},
        TContext
      > => {
      return useMutation(getRemoveFromAccountByAdminMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner. Device is private.
 * @summary Reset a reg token for device
 */
export const resetRegToken = (
    id: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/devices/${id}/regtoken`,options
    );
  }




export const getResetRegTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetRegToken>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetRegToken>>, TError,{id: string}, TContext> => {

const mutationKey = ['resetRegToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetRegToken>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  resetRegToken(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetRegTokenMutationResult = NonNullable<Awaited<ReturnType<typeof resetRegToken>>>

    export type ResetRegTokenMutationError = AxiosError<unknown>

    /**
 * @summary Reset a reg token for device
 */
export const useResetRegToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetRegToken>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetRegToken>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getResetRegTokenMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be the device owner. Device is private.
 * @summary Uninstall a license on a device
 */
export const uninstallLicense = (
    id: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<UninstallLicenseParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
params = toValue(params);

    return axios.delete(
      `/service/api/devices/${id}/licenses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getUninstallLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uninstallLicense>>, TError,{id: string;params: UninstallLicenseParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uninstallLicense>>, TError,{id: string;params: UninstallLicenseParams}, TContext> => {

const mutationKey = ['uninstallLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uninstallLicense>>, {id: string;params: UninstallLicenseParams}> = (props) => {
          const {id,params} = props ?? {};

          return  uninstallLicense(id,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UninstallLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof uninstallLicense>>>

    export type UninstallLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Uninstall a license on a device
 */
export const useUninstallLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uninstallLicense>>, TError,{id: string;params: UninstallLicenseParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uninstallLicense>>,
        TError,
        {id: string;params: UninstallLicenseParams},
        TContext
      > => {
      return useMutation(getUninstallLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be an admin of the company.
 * @summary Delete a company invite
 */
export const deleteCompanyInvite = (
    id: MaybeRefOrGetter<string>,
    inviteCode: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);
inviteCode = toValue(inviteCode);

    return axios.delete(
      `/service/api/companies/${id}/company-invites/${inviteCode}`,options
    );
  }




export const getDeleteCompanyInviteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyInvite>>, TError,{id: string;inviteCode: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyInvite>>, TError,{id: string;inviteCode: string}, TContext> => {

const mutationKey = ['deleteCompanyInvite'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyInvite>>, {id: string;inviteCode: string}> = (props) => {
          const {id,inviteCode} = props ?? {};

          return  deleteCompanyInvite(id,inviteCode,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyInviteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyInvite>>>

    export type DeleteCompanyInviteMutationError = AxiosError<unknown>

    /**
 * @summary Delete a company invite
 */
export const useDeleteCompanyInvite = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyInvite>>, TError,{id: string;inviteCode: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompanyInvite>>,
        TError,
        {id: string;inviteCode: string},
        TContext
      > => {
      return useMutation(getDeleteCompanyInviteMutationOptions(options), queryClient);
    }

/**
 * Security: None
 * @summary Delete a company invite as guest
 */
export const deleteCompanyInviteAsGuest = (
    inviteCode: MaybeRefOrGetter<string>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    inviteCode = toValue(inviteCode);

    return axios.delete(
      `/service/api/companies/company-invites/${inviteCode}`,options
    );
  }




export const getDeleteCompanyInviteAsGuestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyInviteAsGuest>>, TError,{inviteCode: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyInviteAsGuest>>, TError,{inviteCode: string}, TContext> => {

const mutationKey = ['deleteCompanyInviteAsGuest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyInviteAsGuest>>, {inviteCode: string}> = (props) => {
          const {inviteCode} = props ?? {};

          return  deleteCompanyInviteAsGuest(inviteCode,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyInviteAsGuestMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyInviteAsGuest>>>

    export type DeleteCompanyInviteAsGuestMutationError = AxiosError<unknown>

    /**
 * @summary Delete a company invite as guest
 */
export const useDeleteCompanyInviteAsGuest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyInviteAsGuest>>, TError,{inviteCode: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompanyInviteAsGuest>>,
        TError,
        {inviteCode: string},
        TContext
      > => {
      return useMutation(getDeleteCompanyInviteAsGuestMutationOptions(options), queryClient);
    }

/**
 * Security: User needs to be assigned developer to the app.
 * @summary Delete an app version (only draft apps can be deleted)
 */
export const deleteRelease = (
    id: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    id = toValue(id);

    return axios.delete(
      `/service/api/apps/release/${id}`,options
    );
  }




export const getDeleteReleaseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRelease>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRelease>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteRelease'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRelease>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRelease(id,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRelease>>>

    export type DeleteReleaseMutationError = AxiosError<unknown>

    /**
 * @summary Delete an app version (only draft apps can be deleted)
 */
export const useDeleteRelease = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRelease>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteRelease>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteReleaseMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be owner of the device.
 * @summary Uninstall an app from device, also uninstalls the license if a matching license is found.
 */
export const uninstallAppAndLicense = (
    proficloudAppId: MaybeRefOrGetter<string>,
    deviceid: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<UninstallAppAndLicenseParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    proficloudAppId = toValue(proficloudAppId);
deviceid = toValue(deviceid);
params = toValue(params);

    return axios.delete(
      `/service/api/apps/proficloud-app-id/${proficloudAppId}/devices/${deviceid}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getUninstallAppAndLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uninstallAppAndLicense>>, TError,{proficloudAppId: string;deviceid: string;params: UninstallAppAndLicenseParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uninstallAppAndLicense>>, TError,{proficloudAppId: string;deviceid: string;params: UninstallAppAndLicenseParams}, TContext> => {

const mutationKey = ['uninstallAppAndLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uninstallAppAndLicense>>, {proficloudAppId: string;deviceid: string;params: UninstallAppAndLicenseParams}> = (props) => {
          const {proficloudAppId,deviceid,params} = props ?? {};

          return  uninstallAppAndLicense(proficloudAppId,deviceid,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UninstallAppAndLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof uninstallAppAndLicense>>>

    export type UninstallAppAndLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Uninstall an app from device, also uninstalls the license if a matching license is found.
 */
export const useUninstallAppAndLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uninstallAppAndLicense>>, TError,{proficloudAppId: string;deviceid: string;params: UninstallAppAndLicenseParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uninstallAppAndLicense>>,
        TError,
        {proficloudAppId: string;deviceid: string;params: UninstallAppAndLicenseParams},
        TContext
      > => {
      return useMutation(getUninstallAppAndLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin or owner of the license.
 * @summary As an admin user or license owner, reset errors for a license
 */
export const resetLicenseError = (
    licenseId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    licenseId = toValue(licenseId);

    return axios.delete(
      `/service/api/app-licenses/errors/user/reset/${licenseId}`,options
    );
  }




export const getResetLicenseErrorMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetLicenseError>>, TError,{licenseId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetLicenseError>>, TError,{licenseId: number}, TContext> => {

const mutationKey = ['resetLicenseError'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetLicenseError>>, {licenseId: number}> = (props) => {
          const {licenseId} = props ?? {};

          return  resetLicenseError(licenseId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetLicenseErrorMutationResult = NonNullable<Awaited<ReturnType<typeof resetLicenseError>>>

    export type ResetLicenseErrorMutationError = AxiosError<unknown>

    /**
 * @summary As an admin user or license owner, reset errors for a license
 */
export const useResetLicenseError = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetLicenseError>>, TError,{licenseId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetLicenseError>>,
        TError,
        {licenseId: number},
        TContext
      > => {
      return useMutation(getResetLicenseErrorMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, retry error for a license
 */
export const adminRetryErrorsForLicense = (
    licenseid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    licenseid = toValue(licenseid);

    return axios.delete(
      `/service/api/app-licenses/errors/licensens/${licenseid}/retry`,options
    );
  }




export const getAdminRetryErrorsForLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRetryErrorsForLicense>>, TError,{licenseid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof adminRetryErrorsForLicense>>, TError,{licenseid: number}, TContext> => {

const mutationKey = ['adminRetryErrorsForLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRetryErrorsForLicense>>, {licenseid: number}> = (props) => {
          const {licenseid} = props ?? {};

          return  adminRetryErrorsForLicense(licenseid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRetryErrorsForLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof adminRetryErrorsForLicense>>>

    export type AdminRetryErrorsForLicenseMutationError = AxiosError<unknown>

    /**
 * @summary As an admin user, retry error for a license
 */
export const useAdminRetryErrorsForLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRetryErrorsForLicense>>, TError,{licenseid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminRetryErrorsForLicense>>,
        TError,
        {licenseid: number},
        TContext
      > => {
      return useMutation(getAdminRetryErrorsForLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, reset errors for a license
 */
export const adminResetErrorsForLicense = (
    licenseid: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    licenseid = toValue(licenseid);

    return axios.delete(
      `/service/api/app-licenses/errors/licensens/${licenseid}/reset`,options
    );
  }




export const getAdminResetErrorsForLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminResetErrorsForLicense>>, TError,{licenseid: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof adminResetErrorsForLicense>>, TError,{licenseid: number}, TContext> => {

const mutationKey = ['adminResetErrorsForLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminResetErrorsForLicense>>, {licenseid: number}> = (props) => {
          const {licenseid} = props ?? {};

          return  adminResetErrorsForLicense(licenseid,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminResetErrorsForLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof adminResetErrorsForLicense>>>

    export type AdminResetErrorsForLicenseMutationError = AxiosError<unknown>

    /**
 * @summary As an admin user, reset errors for a license
 */
export const useAdminResetErrorsForLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminResetErrorsForLicense>>, TError,{licenseid: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminResetErrorsForLicense>>,
        TError,
        {licenseid: number},
        TContext
      > => {
      return useMutation(getAdminResetErrorsForLicenseMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, retry error for an installed app
 */
export const adminRetryErrorsForInstalledApp = (
    installedAppId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    installedAppId = toValue(installedAppId);

    return axios.delete(
      `/service/api/app-licenses/errors/installed-apps/${installedAppId}/retry`,options
    );
  }




export const getAdminRetryErrorsForInstalledAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRetryErrorsForInstalledApp>>, TError,{installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof adminRetryErrorsForInstalledApp>>, TError,{installedAppId: number}, TContext> => {

const mutationKey = ['adminRetryErrorsForInstalledApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRetryErrorsForInstalledApp>>, {installedAppId: number}> = (props) => {
          const {installedAppId} = props ?? {};

          return  adminRetryErrorsForInstalledApp(installedAppId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRetryErrorsForInstalledAppMutationResult = NonNullable<Awaited<ReturnType<typeof adminRetryErrorsForInstalledApp>>>

    export type AdminRetryErrorsForInstalledAppMutationError = AxiosError<unknown>

    /**
 * @summary As an admin user, retry error for an installed app
 */
export const useAdminRetryErrorsForInstalledApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRetryErrorsForInstalledApp>>, TError,{installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminRetryErrorsForInstalledApp>>,
        TError,
        {installedAppId: number},
        TContext
      > => {
      return useMutation(getAdminRetryErrorsForInstalledAppMutationOptions(options), queryClient);
    }

/**
 * Security: User has to be authenticated. User has to be store admin.
 * @summary As an admin user, reset error for an installed app
 */
export const adminResetErrorsForInstalledApp = (
    installedAppId: MaybeRefOrGetter<number>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    installedAppId = toValue(installedAppId);

    return axios.delete(
      `/service/api/app-licenses/errors/installed-apps/${installedAppId}/reset`,options
    );
  }




export const getAdminResetErrorsForInstalledAppMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminResetErrorsForInstalledApp>>, TError,{installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof adminResetErrorsForInstalledApp>>, TError,{installedAppId: number}, TContext> => {

const mutationKey = ['adminResetErrorsForInstalledApp'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminResetErrorsForInstalledApp>>, {installedAppId: number}> = (props) => {
          const {installedAppId} = props ?? {};

          return  adminResetErrorsForInstalledApp(installedAppId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminResetErrorsForInstalledAppMutationResult = NonNullable<Awaited<ReturnType<typeof adminResetErrorsForInstalledApp>>>

    export type AdminResetErrorsForInstalledAppMutationError = AxiosError<unknown>

    /**
 * @summary As an admin user, reset error for an installed app
 */
export const useAdminResetErrorsForInstalledApp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminResetErrorsForInstalledApp>>, TError,{installedAppId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminResetErrorsForInstalledApp>>,
        TError,
        {installedAppId: number},
        TContext
      > => {
      return useMutation(getAdminResetErrorsForInstalledAppMutationOptions(options), queryClient);
    }

/**
 * Security: User is authenticated and owner of the license.
 * @summary Deactivate a license via uploading a Rac-File
 */
export const deactivateOfflineLicense = (
    cmContainerContextFile: MaybeRefOrGetter<CmContainerContextFile>,
    params: MaybeRefOrGetter<DeactivateOfflineLicenseParams>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CmContainerUpdateFile>> => {
    cmContainerContextFile = toValue(cmContainerContextFile);
params = toValue(params);

    return axios.delete(
      `/service/api/app-licenses/deactivateOfflineLicense`,{data: cmContainerContextFile,
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getDeactivateOfflineLicenseMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateOfflineLicense>>, TError,{data: CmContainerContextFile;params: DeactivateOfflineLicenseParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateOfflineLicense>>, TError,{data: CmContainerContextFile;params: DeactivateOfflineLicenseParams}, TContext> => {

const mutationKey = ['deactivateOfflineLicense'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateOfflineLicense>>, {data: CmContainerContextFile;params: DeactivateOfflineLicenseParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deactivateOfflineLicense(data,params,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateOfflineLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateOfflineLicense>>>
    export type DeactivateOfflineLicenseMutationBody = CmContainerContextFile
    export type DeactivateOfflineLicenseMutationError = AxiosError<unknown>

    /**
 * @summary Deactivate a license via uploading a Rac-File
 */
export const useDeactivateOfflineLicense = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateOfflineLicense>>, TError,{data: CmContainerContextFile;params: DeactivateOfflineLicenseParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivateOfflineLicense>>,
        TError,
        {data: CmContainerContextFile;params: DeactivateOfflineLicenseParams},
        TContext
      > => {
      return useMutation(getDeactivateOfflineLicenseMutationOptions(options), queryClient);
    }

